// Use our custom event listeners to tap into common functions.
// Documentation - https://archetypethemes.co/blogs/streamline/javascript-events-for-developers
//
// document.addEventListener('page:loaded', function() {
//   /* Stylesheet and theme scripts have loaded */
// });

window.theme = window.theme || {};
window.slate = window.slate || {};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

(function(){
  slate.utils = {
    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },

    promiseStylesheet: function() {
      if (typeof this.stylesheetPromise === 'undefined') {
        this.stylesheetPromise = $.Deferred(function(defer) {
          var link = document.querySelector('link[href="' + theme.stylesheet + '"]');

          if (link.loaded) {
            defer.resolve();
          }

          onloadCSS(link, function() { // Global onloadCSS function injected by load-css.liquid
            defer.resolve();
          });
        });
      }

      return this.stylesheetPromise;
    }
  };

  slate.a11y = {

    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    trapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';

      if (!options.$elementToFocus) {
        options.$elementToFocus = options.$container;
      }

      options.$container.attr('tabindex', '-1');
      options.$elementToFocus.focus();

      $(document).off('focusin');

      $(document).on(eventName, function(evt) {
        if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
          options.$container.focus();
        }
      });
    },

    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';

      if (options.$container && options.$container.length) {
        options.$container.removeAttr('tabindex');
      }

      $(document).off(eventName);
    },

    // Not from Slate, but fit in the a11y category
    lockMobileScrolling: function(namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.on('touchmove' + namespace, function () {
        return false;
      });
    },

    unlockMobileScrolling: function(namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.off(namespace);
    },

    promiseAnimationEnd: function($el) {
      var events = 'animationend webkitAnimationEnd oAnimationEnd';
      var properties = ['animation-duration', '-moz-animation-duration', '-webkit-animation-duration', '-o-animation-duration'];
      var duration = 0;
      var promise = $.Deferred().resolve();

      // check the various CSS properties to see if a duration has been set
      $.each(properties, function(index, value) {
        duration || (duration = parseFloat($el.css(value)));
      });

      if (duration > 0) {
        promise = $.Deferred(function(defer) {
          $el.on(events, function(evt) {
            if (evt.target !== $el[0]) return;
            $el.off(events);
            defer.resolve();
          });
        });
      }

      return promise;
    },

    promiseTransitionEnd: function($el) {
      var events = 'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend';
      var properties = ['transition-duration', '-moz-transition-duration', '-webkit-transition-duration', '-o-transition-duration'];
      var duration = 0;
      var promise = $.Deferred().resolve();

      // check the various CSS properties to see if a duration has been set
      $.each(properties, function(index, value) {
        duration || (duration = parseFloat($el.css(value)));
      });

      if (duration > 0) {
        promise = $.Deferred(function(defer) {
          $el.on(events, function(evt) {
            if (evt.target !== $el[0]) return;
            $el.off(events);
            defer.resolve();
          });
        });
      }

      return promise;
    }
  };

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    $(document)
      .on('shopify:section:load', this._onSectionLoad.bind(this))
      .on('shopify:section:unload', this._onSectionUnload.bind(this))
      .on('shopify:section:select', this._onSelect.bind(this))
      .on('shopify:section:deselect', this._onDeselect.bind(this))
      .on('shopify:block:select', this._onBlockSelect.bind(this))
      .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };

  theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {
    createInstance: function(container, constructor, customScope) {
      var $container = $(container);
      var id = $container.attr('data-section-id');
      var type = $container.attr('data-section-type');

      constructor = constructor || this.constructors[type];

      if (typeof constructor === 'undefined') {
        return;
      }

      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (customScope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          return;
        }
      }

      var instance = $.extend(new constructor(container), {
        id: id,
        type: type,
        container: container,
        namespace: '.' + type + '-' + id
      });

      this.instances.push(instance);
    },

    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (AOS) {
        AOS.refreshHard();
      }

      var container = subSection ? subSection : $('[data-section-id]', evt.target)[0];

      if (!container) {
        return;
      }

      this.createInstance(container);

      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

      if (!subSection) {
        this.loadSubSections();
      }

      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
    },

    loadSubSections: function($context) {
      var $sections = $context ? $context.find('[data-subsection]') : $('[data-subsection]');

      $sections.each(function(evt, el) {
        this._onSectionLoad(null, el, $(el).data('section-id'));
      }.bind(this));

      if (AOS) {
        AOS.refreshHard();
      }
    },

    _onSectionUnload: function(evt) {
      var instance = this._removeInstance(evt.detail.sectionId);
      if (instance && typeof instance.onUnload === 'function') {
        instance.onUnload(evt);
      }
    },

    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (instance && typeof instance.onSelect === 'function') {
        instance.onSelect(evt);
      }
    },

    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (instance && typeof instance.onDeselect === 'function') {
        instance.onDeselect(evt);
      }
    },

    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (instance && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(evt);
      }
    },

    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (instance && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(evt);
      }
    },

    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },

    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;

      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }

      return instance;
    },

    reinitSection: function(section) {
      for (var i = 0; i < sections.instances.length; i++) {
        var instance = sections.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    },

    register: function(type, constructor, $scope) {
      var afterLoad = false;
      this.constructors[type] = constructor;
      var $sections = $(`[data-section-type="${type}"]`);

      // Any section within the scope
      if ($scope) {
        $sections = $(`[data-section-type="${type}"]`, $scope);
      }
      if (!$sections.length) {
        $sections = $(type);
      }

      $sections.each(function(index, container) {
        this.createInstance(container, constructor, $scope);
      }.bind(this));
    }
  });

  theme.Currency = (function() {
    var moneyFormat = '$';

    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = slate.utils.defaultTo(precision, 2);
        thousands = slate.utils.defaultTo(thousands, ',');
        decimal = slate.utils.defaultTo(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    return {
      formatMoney: formatMoney
    }
  })();


  /**
   * Image Helper Functions
   * -----------------------------------------------------------------------------
   * A collection of functions that help with basic image operations.
   *
   */

  theme.Images = (function() {

    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }

      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }

    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
      if (size == null) {
        return src;
      }

      if (size === 'master') {
        return this.removeProtocol(src);
      }

      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }

      return null;
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }

    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol
    };
  })();

  slate.Variants = (function() {

    function Variants(options) {
      this.$container = options.$container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();
      $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }

    Variants.prototype = $.extend({}, Variants.prototype, {

      _getCurrentOptions: function() {
        var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        });

        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = this._compact(currentOptions);

        return currentOptions;
      },

      _getVariantFromOptions: function() {
        var selectedValues = this._getCurrentOptions();
        var variants = this.variants;
        var found = false;

        variants.forEach(function(variant) {
          var match = true;
          var options = variant.options;

          selectedValues.forEach(function(option) {
            if (match) {
              match = (variant[option.index] === option.value);
            }
          });

          if (match) {
            found = variant;
          }
        });

        return found || null;
      },

      _onSelectChange: function() {
        var variant = this._getVariantFromOptions();
  		// console.log(variant);

        this.$container.trigger({
          type: 'variantChange',
          variant: variant
        });

        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: {
            variant: variant
          }
        }));

        if (!variant) {
          return;
        }

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;

        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },

      _updateImages: function(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant?.featured_image || {};

        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }

        this.$container.trigger({
          type: 'variantImageChange',
          variant: variant
        });
      },

      _updatePrice: function(variant) {
        // if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        //   return;
        // }

        //get cart total data here:
        this.$container.trigger({
          type: 'variantPriceChange',
          variant: variant
        });
      },

      _updateSKU: function(variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }

        this.$container.trigger({
          type: 'variantSKUChange',
          variant: variant
        });
      },

      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        // CUSTOM -- not change url on variant#change
        // var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        // window.history.replaceState({path: newurl}, '', newurl);
      },

      _updateMasterSelect: function(variant) {
        $(this.originalSelectorId, this.$container).val(variant.id).change();
      },

      // _.compact from lodash
      // https://github.com/lodash/lodash/blob/4d4e452ade1e78c7eb890968d851f837be37e429/compact.js
      _compact: function(array) {
        var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];

        while (++index < length) {
          var value = array[index];
          if (value) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
    });

    return Variants;
  })();

  slate.rte = {
    init: function() {
      slate.rte.wrapTable();
      slate.rte.wrapVideo();
      slate.rte.imageLinks();
    },

    wrapTable: function() {
      $('.rte table').wrap('<div class="table-wrapper"></div>');
    },

    wrapVideo: function() {
      var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
      var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

      $iframeVideo.each(function () {
        // Add wrapper to make video responsive
        if (!$(this).parents('.video-wrapper').length) {
          $(this).wrap('<div class="video-wrapper"></div>');
        }
      });

      $iframeReset.each(function () {
        // Re-set the src attribute on each iframe after page load
        // for Chrome's "incorrect iFrame content on 'back'" bug.
        // https://code.google.com/p/chromium/issues/detail?id=395791
        // Need to specifically target video and admin bar
        this.src = this.src;
      });
    },

    // Remove CSS that adds animated underline under image links
    imageLinks: function() {
      $('.rte a img').parent().addClass('rte__image');
    }
  };


  theme.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        bodyOpenClass: 'modal-open',
        closeOffContentClick: true
      };

      this.id = id;
      this.$modal = $('#' + id);

      if (!this.$modal.length) {
        return false;
      }

      this.nodes = {
        $parent: $('html').add('body'),
        $modalContent: this.$modal.find('.modal__inner')
      };

      this.config = $.extend(defaults, options);
      this.modalIsOpen = false;
      this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;

      this.init();
    }

    Modal.prototype.init = function() {
      var $openBtn = $(this.config.open);

      // Add aria controls
      $openBtn.attr('aria-expanded', 'false');

      $(this.config.open).on('click', this.open.bind(this));
      this.$modal.find(this.config.close).on('click', this.close.bind(this));

      // Close modal if a drawer is opened
      $('body').on('drawerOpen', function() {
        this.close();
      }.bind(this));
    };

    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
      if (this.$modal.attr('id') === 'SearchModal') {
        this.$modal.css('top', $('header').height());
        const height = `calc(100% - ${$('header').height()}px)`
        this.$modal.css('height', height);
      }

      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget);
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.$modal.addClass(this.config.openClass);
      this.nodes.$parent.addClass(this.config.bodyOpenClass);

      setTimeout(function() {
        this.$modal.addClass('aos-animate');
      }.bind(this), 0);

      this.modalIsOpen = true;

      slate.a11y.trapFocus({
        $container: this.$modal,
        $elementToFocus: this.$focusOnOpen,
        namespace: 'modal_focus'
      });

      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'true');
      }

      $('body').trigger('modalOpen.' + this.id);

      this.bindEvents();
    };

    Modal.prototype.close = function() {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }

      // deselect any focused form elements
      $(document.activeElement).trigger('blur');

      this.$modal.removeClass(this.config.openClass).removeClass('aos-animate');
      this.nodes.$parent.removeClass(this.config.bodyOpenClass);

      this.modalIsOpen = false;

      slate.a11y.removeTrapFocus({
        $container: this.$modal,
        namespace: 'modal_focus'
      });

      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'false').focus();
      }

      $('body').trigger('modalClose.' + this.id);

      this.unbindEvents();
    };

    Modal.prototype.bindEvents = function() {
      // Pressing escape closes modal
      this.nodes.$parent.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));

      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.$modal.on('click.modal', this.close.bind(this));

        // Exception to above: clicking anywhere on the modal content will NOT close it
        this.nodes.$modalContent.on('click.modal', function(evt) {
          evt.stopImmediatePropagation();
        });
      }
    };

    Modal.prototype.unbindEvents = function() {
      this.nodes.$parent.off('.modal');

      if (this.config.closeOffContentClick) {
        this.$modal.off('.modal');
        this.nodes.$modalContent.off('.modal');
      }
    };

    return Modal;
  })();

  theme.ProductScreen = (function() {

    var originalTitle = document.title;
    var namespace = 'productscreen';
    var windowPosition = 0;
    var $page = $('#MainContent');

    function ProductScreen(id, name, options) {
      var defaults = {
        close: '.js-screen-close',
        open: '.js-screen-open-' + name,
        openClass: 'screen-layer--is-active',
        closeSlideAnimate: 'screen-layer--is-sliding',
        bodyOpenClass: 'screen-layer-open',
        bodyClosingClass: 'screen-layer-closing',
        bodyCloseAnimate: 'screen-layer-closing screen-layer-animating',
        loaderStart: 200,
        pullToCloseThreshold: -100
      };

      this.id = id;
      this.$screen = $('#' + id);
      this.title = this.$screen.data('product-title');

      if (!this.$screen.length) {
        return false;
      }

      this.nodes = {
        $parent: $('html').add('body'),
        $body: $('body'),
        $loader: $('#OverscrollLoader').find('.icon-loader__path'),
        $screenContent: this.$screen.find('.screen-layer__inner'),
        $photoswipe: $('.pswp')
      };

      this.config = $.extend(defaults, options);
      this.initalized = false; // opened at least once
      this.isOpen = false;
      this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$screen;

      this.init();
    }

    ProductScreen.prototype.init = function() {
      var $openBtn = $(this.config.open);

      // Add aria controls
      $openBtn.attr('aria-expanded', 'false');

      $(this.config.open).on('click', this.open.bind(this));
      this.$screen.find(this.config.close).on('click', { noAnimate: true, back: true }, this.close.bind(this));

      // Close screen if product added to sticky cart
      if (theme.settings.cartType === 'sticky') {
        this.nodes.$body.on('added.' + this.id, function() {
          theme.headerNav.toggleThumbMenu(false, true);
          var args = { back: true };
          this.close(false, args);
        }.bind(this));

        this.nodes.$body.on('error.' + this.id, function() {
          if (this.initalized) {
            this.open();
          }
        }.bind(this));
      }
    };

    ProductScreen.prototype.open = function(evt, data) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
      var args = {
        updateCurrentPath: data ? data.updateCurrentPath : true
      };

      if (this.isOpen) {
        return;
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget);
      }

      if (this.isOpen && !externalCall) {
        this.close();
      }

      windowPosition = window.scrollY;

      this.$screen
        .prepareTransition()
        .addClass(this.config.openClass);
      this.nodes.$parent.addClass(this.config.bodyOpenClass);
      this.nodes.$screenContent.scrollTop(0);
      window.scrollTo(0,0);

      slate.a11y.trapFocus({
        $container: this.$screen,
        $elementToFocus: this.$focusOnOpen,
        namespace: namespace
      });

      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'true');
      }

      var newUrl = this.$activeSource.data('url');
      this.nodes.$body
        .trigger('productModalOpen.' + this.id)
        .trigger('newPopstate', {screen: this, url: newUrl, updateCurrentPath: args.updateCurrentPath});

      this.initalized = true;
      this.isOpen = true;
      document.title = this.title;

      // Trigger Google Analytics page view if enabled
      if (window.ga) { ga('send', 'pageview', { page: newUrl }) }

      this.bindEvents();
    };

    ProductScreen.prototype.close = function(evt, args) {
      var evtData = args ? args : (evt ? evt.data : null);
      var goBack = evtData ? evtData.back : false;
      var noAnimate = (evtData && evtData.noAnimate) ? true : false;
      this.nodes.$body.removeAttr('style');
      this.nodes.$loader.css('stroke-dashoffset', this.config.loaderStart);

      if (goBack) {
        this.nodes.$body.trigger('newPopstate', {screen: this, back: true});
      }

      var closeClass = noAnimate ? '' : this.config.closeSlideAnimate;
      var bodyCloseClass = noAnimate ? this.config.bodyClosingClass : this.config.bodyCloseAnimate;

      // Don't close if already closed
      if (!this.isOpen) {
        return;
      }

      // deselect any focused form elements
      $(document.activeElement).trigger('blur');

      this.$screen
        .prepareTransition()
        .removeClass(this.config.openClass)
        .addClass(closeClass);
      this.nodes.$parent.removeClass(this.config.bodyOpenClass);
      this.nodes.$parent.addClass(bodyCloseClass);

      window.setTimeout(function() {
        this.nodes.$parent.removeClass(bodyCloseClass);
        this.$screen.removeClass(closeClass);
      }.bind(this), 500); // duration of css animation

      slate.a11y.removeTrapFocus({
        $container: this.$screen,
        namespace: namespace
      });

      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'false').focus();
      }

      this.nodes.$body
        .trigger('productModalClose')
        .trigger('productModalClose.' + this.id)
        .scrollTop(windowPosition);

      this.isOpen = false;
      document.title = originalTitle;

      if (window.ga) { ga('send', 'pageview') }

      this.unbindEvents();
    };

    ProductScreen.prototype.bindEvents = function() {
      // Pressing escape closes modal, unless the photoswipe screen is open
      this.nodes.$body.on('keyup.' + namespace, function(evt) {
        if (evt.keyCode === 27) {
          if (this.nodes.$photoswipe.hasClass('pswp--open')) {
            return;
          }
          if (this.nodes.$body.hasClass('js-drawer-open')) {
            return;
          }
          var args = { back: true };
          this.close(false, args);
        }
      }.bind(this));

      // If scrolling up while at top, close modal
      var bgAmount = 0;
      var loaderAmount = 0;
      $(document).on('touchmove.' + namespace, $.throttle(15, function(evt) {
        var pos = window.scrollY;

        if (pos >= 0) {
          return;
        }

        bgAmount = -(pos/100);
        this.nodes.$body.css('background', 'rgba(0,0,0,' + bgAmount + ')');

        // stroke fills from 200-0 (0 = full)
        loaderAmount = this.config.loaderStart + (pos * 2); // pos is negative number

        if (pos <= this.config.pullToCloseThreshold) {
          loaderAmount = 0;
        }

        this.nodes.$loader.css('stroke-dashoffset', loaderAmount);
      }.bind(this)));

      $(document).on('touchend.' + namespace, function(evt) {
        totalLoader = this.config.loaderStart; // reset to starting point
        var pos = window.scrollY;
        if (pos < this.config.pullToCloseThreshold) {
          var args = { back: true };
          this.close(false, args);
        }
      }.bind(this));
    };

    ProductScreen.prototype.unbindEvents = function() {
      this.nodes.$body.off('.' + namespace);
      $(document).off('.' + namespace);
    };

    return ProductScreen;
  })();

  theme.Drawers = (function() {
    function Drawer(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };

      this.$nodes = {
        parent: $(document.documentElement).add('body'),
        page: $('body')
      };

      this.$drawer = $('#' + id);

      if (!this.$drawer.length) {
        return false;
      }

      this.isOpen = false;
      this.init();
    };

    Drawer.prototype = $.extend({}, Drawer.prototype, {
      init: function() {
        var $openBtn = $(this.config.open);

        // Add aria controls
        $openBtn.attr('aria-expanded', 'false');

        $openBtn.on('click', this.open.bind(this));
        this.$drawer.find(this.config.close).on('click', this.close.bind(this));
      },

      open: function(evt) {
        if (evt) {
          evt.preventDefault();
        }

        if (this.isOpen) {
          return;
        }

        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          this.$activeSource = $(evt.currentTarget);
        }

        this.$drawer.prepareTransition().addClass(this.config.activeDrawer);

        this.$nodes.parent.addClass(this.config.openClass);
        this.isOpen = true;

        slate.a11y.trapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });

        $('body').trigger('drawerOpen.' + this.config.id);

        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
          this.$activeSource.attr('aria-expanded', 'true');
        }

        this.bindEvents();
      },

      close: function() {
        if (!this.isOpen) {
          return;
        }

        // deselect any focused form elements
        $(document.activeElement).trigger('blur');

        this.$drawer.prepareTransition().removeClass(this.config.activeDrawer);

        this.$nodes.parent.removeClass(this.config.openClass);
        this.$nodes.parent.addClass(this.config.closingClass);
        var o = this;
        window.setTimeout(function() {
          o.$nodes.parent.removeClass(o.config.closingClass);
        }, 500);

        this.isOpen = false;

        slate.a11y.removeTrapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });

        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
          this.$activeSource.attr('aria-expanded', 'false');
        }

        if (($('.product-template-build-a-system').length || $('.page-build_a_system_new').length) && $('.add-to-cart').hasClass('disabled')) {
          window.location.href = '/'
        }

        this.unbindEvents();
      },

      bindEvents: function() {
        slate.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page);

        // Clicking body closes drawer
        this.$nodes.page.on('click' + this.config.namespace, function (evt) {
          if (evt.target === this.$nodes.page[0]) {
            this.close();
            return false;
          }
        }.bind(this));

        // Pressing escape closes drawer
        this.$nodes.parent.on('keyup' + this.config.namespace, function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));
      },

      unbindEvents: function() {
        slate.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page);
        this.$nodes.parent.off(this.config.namespace);
        this.$nodes.page.off(this.config.namespace);
      }
    });

    return Drawer;
  })();

  theme.cart = {
    getCart: function() {
      return $.ajax({
	    type: 'GET',
	    url: '/cart?view=extended&timestamp=' + new Date().getTime(),
      }).then(data => JSON.parse(data)).then((data) => this.data = data);
    },

    changeItem: async function(key, qty) {
      console.log('removing/changing item!');
      if (!key) return

      const item = document.querySelector(`[data-cart-item-id="${key}"]`);
      const price = $(item).find('.cart__item-price').text();
      const updates = {}

      // MEMORIALDAYPROMO --
      // DEVTODO- what the hell was this? is this to remove free items or something like that?
      // if (price === '$0.00') {
      //   const property = $(item).find('[data-cart-item-property]').html();
      //   const items = document.querySelectorAll('.cart__items [data-cart-item-property]');

      //   for (var i = 0; i < items.length; i++) {
      //     if ($(items[i]).html() === property) {
      //       let newKey = $(items[i]).parents('.cart__item').data('cart-item-id');
      //       let change = parseInt($(item).find('[data-cart-item-input-quantity]').val(), 10) === 2 ? 1 : -1;
      //       let newQty = parseInt($(items[i]).parents('.cart__item').find('[data-cart-item-input-quantity]').val(), 10) + change;

      //       if (newKey !== key) {
      //         return this._updateCart({
      //           type: 'POST',
      //           url: '/cart/update.js',
      //           data: `updates[${newKey}]=${newQty}`,
      //           dataType: 'json'
      //         });
      //       }
      //     }
      //   }
      // }

      const cart = await theme.cart.getCart()
      const curProduct = cart.items.find((item) => item.key === key)
      const timestamp = curProduct?.properties && (curProduct.properties['_Timestamp'] || curProduct.properties['Timestamp'])
      cart.items.forEach((item) => {
        if (item.properties['Parent key'] === key || (timestamp && item.properties && 
          (item.properties['Parent Timestamp'] === timestamp || item.properties['_Parent Timestamp'] === timestamp)
        ))
          updates[item.key] = (item.properties['_Quantity'] || item.properties['Quantity'] || 1) * qty
        if (item.key === key)
          updates[item.key] = qty
      })

      return this._updateCart({
        type: 'POST',
        url: '/cart/update.js',
        data: {updates},
        dataType: 'json'
      });
    },

    updateCartCustomBundles: async function(key, qty) {
      console.log('updating custom bundle!');
      updates = {}
      const cart = await theme.cart.getCart()
      const curProduct = cart.items.find((item) => item.key === key)
      const timestamp = curProduct?.properties && curProduct.properties['Timestamp']
      cart.items.forEach((item) => {
        if (item.properties['Parent key'] === key || item.properties['Parent Timestamp'] === timestamp)
          updates[item.id] = item.properties['Quantity'] * qty
        if (item.key === key)
          updates[item.id] = qty
      })
      return this._updateCart({
        type: 'POST',
        url: '/cart/update.js',
        data: {updates},
        dataType: 'json'
      });
    },
    
    clearCartIfHasCorporateGifts: async function () {
      const hasCorporate = theme.cart.data?.items?.find((i) => i.id === Number(corporate_gifting_main_id))
      if (hasCorporate)
        return await $.post('/cart/clear.js')
    },

    addItemFromForm: function(data) {
      return this._updateCart({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json'
      });
    },

    _updateCart: function(params) {
      return $.ajax(params)
        .then(function(cart) {
          $('body').trigger('updateCart', cart);
          return cart;
        }.bind(this))
    },

    updateNote: function(note) {
      const noteMsg = theme.cart.attributeToString(note);
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: { attributes: { 'Gift message': noteMsg } },
        dataType: 'json',
        success: function(cart) {},
        error: function(XMLHttpRequest, textStatus) {}
      };

      $.ajax(params);
    },

    updateCurrency: function(code) {
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'currency=' + code,
        dataType: 'json',
        success: function(cart) {
          location.reload(); // required for multi-currency feature to update
        },
        error: function(XMLHttpRequest, textStatus) {}
      };

      $.ajax(params);
    },

    attributeToString: function(attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return $.trim(attribute);
    }



  }

  $(function() {
    // Add a loading indicator on the cart checkout button (/cart and drawer)
    $('body').on('click', '.cart__checkout', function() {
      $(this).addClass('btn--loading');
    });

    $('body').on('change', 'textarea[name="note"]', function() {
      var newNote = $('textarea[name="note"]').val();
      theme.cart.updateNote(newNote);
    });


    // Custom JS to prevent checkout without confirming terms and conditions
    $('body').on('click', '.cart__checkout--ajax', function(evt) {
      if ($('#CartAgree').is(':checked')) {
      } else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });

    $('body').on('click', '.cart__checkout--page', function(evt) {
      if ($('#CartPageAgree').is(':checked')) {
      } else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });
  });

  theme.AjaxCart = (function() {
    var config = {
      namespace: '.ajaxcart'
    };

    var data = {
      itemId: 'data-cart-item-id'
    };

    var selectors = {
      form: 'form.cart',
      cartCount: '.cart-link__count',
      updateBtn: '.update-cart',

      itemList: '[data-cart-item-list]',
      item: '[data-cart-item]',
      itemId: '[data-cart-item-id]',
      itemHref: '[data-cart-item-href]',
      itemBackgroundImage: '[data-cart-item-background-image]',
      itemTitle: '[data-cart-item-title]',
      itemVariantTitle: '[data-cart-item-variant-title]',
      itemPropertyList: '[data-cart-item-property-list]',
      itemProperty: '[data-cart-item-property]',
      itemDiscountList: '[data-cart-item-discount-list]',
      itemDiscount: '[data-cart-item-discount]',
      itemDiscountTitle: '[data-cart-item-discount-title]',
      itemDiscountAmount: '[data-cart-item-discount-amount]',
      itemLabelQuantity: '[data-cart-item-label-quantity]',
      itemInputQuantity: '[data-cart-item-input-quantity]',
      itemDelete: '[data-cart-item-delete]',
      itemEdit: '[data-cart-item-edit]',
      itemPriceContainer: '[data-cart-item-price-container]',
      itemLinePriceContainer: '[data-cart-item-line-price-container]',
      itemGiftMessage: '[data-cart-item-gift-message]',
      itemMessage: '[data-item-message]',
      cartDiscountContainer: '[data-cart-discount-container]',
      cartDiscountContent: '[data-cart-discount-content]',
      cartDiscount: '[data-cart-discount]',
      cartDiscountTitle: '[data-cart-discount-title]',
      cartDiscountAmount: '[data-cart-discount-amount]',
      cartNoteContainer: '[data-cart-note-container]',
      cartNoteInput: '[data-cart-note]',
      cartMessage: '[data-cart-message]',
      cartSubtotal: '[data-cart-subtotal]',
      cartCompareAtDiscount: '[data-cart-compare-at-discount]',
      cartCompareAtContainer: '[data-cart-compare-at-container]',
      cartTotal: '[data-cart-total]',
      cartSubmit: '[data-cart-submit]',

      fixedFooter: '.drawer__footer--fixed',
      fixedInnerContent: '.drawer__inner--has-fixed-footer',
      cartFact: '.cart__fact',
      cartFactCopyDummy: '[data-message-dummy]',
      cartFactCopy: '[data-cart-message]',
    };

    var classes = {
      cartHasItems: 'cart-has-items',
      cartTemplate: 'ajax-cart__template',
      cartItemRemove: 'cart__item--remove',
      staticDrawerElement: 'drawer--cart--static',
      bundle: 'bundle',
    };

    function AjaxCart(id) {
      this.id = id;
      var $container = this.$container = $('#' + id);

      this.status = {
        loaded: false,
        loading: false,
        isDrawer: $container.attr('data-drawer')
      };

      if (this.status.isDrawer) {
        this.drawer = new theme.Drawers(id, 'cart');
      }

      this.init();
      this.initEventListeners();
    };

    AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {
      init: function() {
        this.$form = $(selectors.form, this.$container);
        $(selectors.updateBtn, this.$form).addClass('hide');
        this.$itemTemplate = $(selectors.item, this.$form).first().clone();
        this.$propertyTemplate = $(selectors.itemProperty, this.$form).first().clone();
        this.$discountTemplate = $(selectors.itemDiscount, this.$form).first().clone();
        this.$cartDiscountTemplate = $(selectors.cartDiscount, this.$container).first().clone();
      },
  // STUFF THAT HAPPENS ON UPDATE CART
      initEventListeners: function() {
        $('body').on('updateCart', function(evt, cart, openCart = true) {

          $('#CartDrawer').addClass('loading')

          theme.cart.getCart().then(function(cart) {
            theme.cart.items = cart.items
            this.buildCart(cart);
            calcPriceWithAdditional(cart)
            totalDiscountCalculation(cart)
            artistIconsText(cart)
            this.updateCartNotification(cart);
            this.disableNoteForTileOnly(cart)
            goalTracker(cart); // CUSTOM - PROGRESS BAR FUNCTIONS
            // re-activate the free ship progress once we bring it back!
            freeShipProgress(cart); // CUSTOM FREE SHIPPING PROGRESS

            // TIEREDGWP
            if (window.TieredGwp && typeof window.TieredGwp.syncCart === 'function') {
              window.TieredGwp.syncCart(cart);
            }

            // HOLIDAY2024TIERPRICING
            // EARTHDAYROLLBACK -- TIEREDPROMOS
            // holidayPromoMiniParcel(cart);
            // holidayPromoProgress(cart); // CUSTOM HOLIDAY PROMO PROGRESS

            // freeCapsuleProgress(cart); // Free capsule
            // freeMiniPopup(cart); // Custom function to add free gift popup
            // checkImpact(); // CHECK THE IMPACT YOU ARE MAKING
            this.productEditing(cart);
            // this.showExpectedToShipWarning(cart)
            
            // use this function to add/remove/verify free gifts
            // this.checkTheTermsOfFreeProducts(cart)
            // console.log('opening-cart');
            
         	  // addFreeMinis(); // CUSTOM FUNCTION TO ADD MINIS
            // Open cart once updated
            // console.log('OPENCART!!', openCart);
            if (openCart) {
              var openDrawer = false;
              if (this.status.isDrawer) {
               this.drawer.open();
               openDrawer = true; // OPEN DRAWER ON ADD TO CART
              }
            }

            const hasGiftMessage = cart.items.some((el) => el.properties['Gift message'])
            if (hasGiftMessage) {
              $('[id="add-gift-note-checkbox"]').prop('checked', true).change()
            }
          }.bind(this));
        }.bind(this));

        this.$container.on('click', selectors.itemDelete, this._onItemDelete.bind(this));
        this.$container.on('input', selectors.itemInputQuantity, $.debounce(500, this._onItemQuantityChange.bind(this)));
        this.$container.on('blur', selectors.itemInputQuantity, this._onItemQuantityEmptyBlur.bind(this));
        this.$container.on('focus', selectors.itemInputQuantity, this._highlightText);
   		this.$container.on('change', selectors.itemInputQuantity, $.debounce(500, this._onItemQuantityChange.bind(this))); // ADDED BY BRIAN FOR CUSTOM ADD SUBSTRACT QTY



        if (this.status.isDrawer) {
          $('body')
            .on('updateCart' + config.namespace, this.sizeCart.bind(this))
            .on('drawerOpen.' + this.id, function() {
              this.sizeCart();
              setTimeout(function() {
                this.sizeCart();
              }.bind(this), 500);
            }.bind(this));

          $(window).on('resize' + config.namespace, $.debounce(150, this.sizeCart.bind(this)));
        }
      },

      disableNoteForTileOnly: (cart) => {
        const hasOnlyTile = !cart.items.some((item) => !item.handle.includes('tile'))
        if (hasOnlyTile) {
          $('#add-gift-note-checkbox').prop('checked', false).change()
          $('.add-gift-note-checkbox').addClass('disabled force-disabled')
          return
        }

        $('.add-gift-note-checkbox').removeClass('force-disabled disabled')
      },

      showExpectedToShipWarning: (cart) => {
        // console.log('checking expected to ship');
        $('.drawer--cart .cart-expected-to-ship').toggle(!!cart.items.find((item) => metafields.airf.expected_to_ship_sku.includes(item.sku)))
        $('.drawer--cart .cart-product-message').toggle(!!cart.items.find((item) => metafields.cart.product_cart_message_skus.includes(item.sku)))
        //check if any of the skus in the cart contain any of the items in the array metafields.airf.expected_to_ship_colors in any part of the sku

        // //log the findings
        // console.log('expected to ship colors: ', metafields.airf.le_expected_to_ship_colors);
        // var expectedtoShipcolors = metafields.airf.le_expected_to_ship_colors;
        // //split the comma separated string into an array
        // expectedtoShipcolors = expectedtoShipcolors.split(',');
        
        // FINALSALECOLORS ========
        var expectedtoShipcolors = ['Sage','Pine']
        // console.log('expected to ship colors array: ', expectedtoShipcolors);
        $('.drawer--cart .cart-product-message').toggle(!!cart.items.find((item) => expectedtoShipcolors.some((color) => item.sku.includes(color))))

      },

      // FREECAPSULEPROMO -- this is going to be repurposed for the free gift with purchase
      checkTheTermsOfFreeProducts: (cart) => {
        

        //check if the product has already been added to cart
        // const hatFreeAdded = cart.items.find((item) => item.variant_id === patent_hat_variant_id_free)
        // const hatAdded = cart.items.find((item) => item.variant_id === patent_hat_variant_id)
        // const cartPrice = cart.items.reduce((accumulator, currentItem) => {
        //   if (currentItem.variant_id === patent_hat_variant_id || currentItem.handle === 'e-gift-card') return accumulator
        //   return accumulator + (currentItem.final_line_price / 100)
        // }, 0)
        // const priceForDiscount = isReturningCustomer() ? patent_hat_price_for_discount_returning_customer : patent_hat_price_for_discount;
        // if (!pending_hat_available) {
        //  hatFreeAdded && theme.cart.changeItem(hatFreeAdded.key, 0);
        //  hatAdded && theme.cart.changeItem(hatAdded.key, 0);
        //  return
        // }
        // if (isReturningCustomer()) {
        //   if (hatFreeAdded) theme.cart.changeItem(hatFreeAdded.key, 0)
        //   if (cartPrice < priceForDiscount && hatAdded) theme.cart.changeItem(hatAdded.key, 0)
        // } else {
        //   if (cartPrice < priceForDiscount && hatFreeAdded) theme.cart.changeItem(hatFreeAdded.key, 0)
        //   if (cartPrice >= priceForDiscount && hatAdded) theme.cart.changeItem(hatAdded.key, 0)
        // }

        // FREECAPSULEPROMO
        //find the free capsule or extender in their cart, if they have one
        // FREECAPSULEPROMO:ID
        // MEMORIALDAYPROMO

        // NEWHATT
        // const nonHatItems = cart.items.filter((item) => item.product_id !== 6952100266069)
        // console.log('non-hat items: ', nonHatItems.length)
        // const hatAdded = cart.items.find((item) => (
        //   (
        //     item.product_id === 6952100266069  
        //   )
        //   ))
        // console.log('free hat status?', hatAdded);

        // // if they don't have a hatt, add it
        // if(!hatAdded && nonHatItems.length > 0){
        //   console.log('free hat not added');
        //   // add the hatt
        //   theme.cart.addItemFromForm({
        //     quantity: 1,
        //     id: 40680886009941
        //   })
        // }
        // if(hatAdded.quantity > 1){
        //   console.log('free hat added more than once');
        //   theme.cart.changeItem(hatAdded.key, 1);
        // }else{
        //   console.log('free hat quantity: ', hatAdded.quantity);
        // }

        // if(hatAdded.quantity > 0 && nonHatItems < 1){
        //   console.log('free hat added and no other items, removing the hat');
        //   theme.cart.changeItem(hatAdded.key, 0);
        // }

        const smallCapsuleAdded = cart.items.find((item) => (
          (
            item.product_id === 8535889019180 
            || item.product_id === 6922694754389
            || item.product_id === 6922695016533          
          ) && item.properties['Offer']
          ))

          // if this is true then we need to remove the capsule from the cart. this can be outsourced to the shopify script editor
          //MEMORIALDAYPROMO -- add the extender as an option
        const smallDiscountedCapsuleToBeRemoved = cart.items.find((item) => (
            (
              item.product_id === 8535889019180 || 
              item.product_id === 6922694754389 || 
              item.product_id === 6922695016533) 

              && item.properties['Offer'] && item.final_line_price > 0
          ))

        const cartPrice = cart.items.reduce((accumulator, currentItem) => {
          if (currentItem.handle === 'e-gift-card') return accumulator
          return accumulator + (currentItem.final_line_price / 100)
        }, 0);
        
        //determine the price for the discount
        const priceForDiscount = 100;
        
        $('.cart-pending-hat > div').removeClass('active');
        //just deactivate the offer
        // BFCMROLLBACK
        // if(smallCapsuleAdded){
        //   theme.cart.changeItem(smallCapsuleAdded.key, 0);
        // }
        // return;

        //first check if they're returning customers, they're not eligible for the free capsule
        // if(returning_customer){
        //   if(smallCapsuleAdded){
        //     theme.cart.changeItem(smallCapsuleAdded.key, 0);
        //   }
        // }else 
        
        if (cartPrice < priceForDiscount){
          
          let remainingAmount = priceForDiscount - cartPrice;
          remainingAmount = Math.round(remainingAmount * 100) / 100;

          $('.cart-pending-hat > .not-achieved').addClass('active')
          $('.cart-pending-hat .spend-hat').text(remainingAmount);
          
          //if they don't reach the threshold and they have the free capsule in their cart, remove it
          if(smallCapsuleAdded){
            //this is how you remove the item from the cart by key, the 0 is the new quantity
            theme.cart.changeItem(smallCapsuleAdded.key, 0);
          }

        }else if(smallDiscountedCapsuleToBeRemoved){
          console.log('small discounted capsule to be removed');
          let remainingAmount2 = priceForDiscount + 14 - cartPrice;
          remainingAmount2 = Math.round(remainingAmount2 * 100) / 100;

          //remove the free capsule if its mislabeled because they did not meet the criteria
          $('.cart-pending-hat > .not-achieved').addClass('active')
          
          $('.cart-pending-hat .spend-hat').text(remainingAmount2);
          
          theme.cart.changeItem(smallCapsuleAdded.key, 0);

        }else{

          $('.cart-pending-hat > .achieved').addClass('active');
          if(smallCapsuleAdded){
            console.log('small capsule already added');
          }
          $('.cart-pending-hat').toggle(!(smallCapsuleAdded))
          $('.home-pending-hat .price').text(priceForDiscount)
          $('.patenting-hat-price-for-discount').text(priceForDiscount)
        }
      },

      productEditing: (cart) => {
        const handle = $('.template-product [data-product-handle]').data('product-handle')
        if (window.location.href.indexOf('?item_key') >= 0)  {
          if (!isBaSHandle(handle) && !isCorporateGifts(handle)) {
            const searchString = new URLSearchParams(window.location.search);
            const item_key = searchString.get('item_key');
            const product = cart.items.find(item => item.key == item_key)
            if(!product) return
              
            const buttonTextUpdateItem = "Update"
            $('[data-add-to-cart-text]').data('default-text', buttonTextUpdateItem)
            if (product.handle === "e-gift-card") {
              const amount = product.variant_title
              $('[name="properties[GC Name]"]').val(product.properties['GC Name']).change()
              $('[name="properties[to]"]').val(product.properties['to']).change()
              $('[name="properties[Sender Name]"]').val(product.properties['Sender Name']).change()
              $('[name="properties[Sender Email]"]').val(product.properties['Sender Email']).change()
              $('[name="properties[deliver on]"]').val(product.properties['deliver on']).change()
              $('[name="properties[GC Personalization]"]').val(product.properties['GC Personalization']).change()
              $(`[data-variant-input]`).data('selectize').addItem(amount)
            }
            if (['Bundle Color 1'] in product.properties) {
              const color = []
              const customLabel = []
              const label = []
              const amount = []
              for (key in product.properties) {
                if (key.includes('Color')) {
                  color.push(product.properties[key])
                } 
                if (key.includes('Custom Bundle')) {
                  customLabel.push(product.properties[key])
                }
                if (key.includes('Standard')) {
                  label.push(product.properties[key])
                }
                if (key.includes('Gift card amount')) {
                  amount.push(product.properties[key])
                } 
              }

              for(let i = 0; i < color.length; i++){
                const element = $(`#topA${i + 1}`).data('selectize')
                if (customLabel[i].length) {
                  element.addOption({ value: customLabel[i], text: customLabel[i], className: starterLabelSelectizeUserCreatedTagClass })
                  element.addItem(customLabel[i])
                } else if (label[i].length) {
                  element.addItem(label[i])
                  element.$input.blur()
                }
                $(`[data-product-index="${i + 1}"]`).data('selectize').addItem(color[i])
              }
              if (amount.length > 0) {
                $(`[data-product-gift-card-select]`).data('selectize').addItem(amount[0])
              }
              
            } else {
              const color = product.options_with_values.find(item => item.name == 'Color').value
              const label = product.properties['Label']
              const customLabel = product.properties['Custom Label']
              const element = $('[data-build-selectize]').data('selectize')

              if (customLabel) {
                element.addOption({ value: customLabel, text: customLabel, className: starterLabelSelectizeUserCreatedTagClass });
                element.addItem(customLabel)
              } else if (label) {
                element.addItem(label)
                element.$input.blur()
              }
              $(`[data-variant-name="${color}"]`).click()   
            }
          }
        }
      },

      buildCart: function(cart, openDrawer) {
        this.loading(true);

        this.$form.removeClass('cart--empty');

        if (cart.item_count === 0) {
          this.$form.addClass('cart--empty');
          this.status.loaded = true;
          this.loading(false);
          return;
        }

        // If 3+ items, remove static class for a 100% height cart drawer
        if (cart.items.length > 2) {
          this.$container.removeClass(classes.staticDrawerElement);
        } else {
          this.$container.addClass(classes.staticDrawerElement);
        }

        var $cart = this._createCart(cart);
        morphdom(this.$form[0], $cart[0]);

        if (theme.settings.currenciesEnabled) {
          theme.currencySwitcher.ajaxrefresh();
        }

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();

          // Resize footer after arbitrary delay to account for checkout buttons
          if (this.status.isDrawer) {
            setTimeout(function() {
              this.sizeCart();
            }.bind(this), 1000);
          }
        }

        // If specifically asked, open the cart drawer (only happens after product added from form)

        if (this.status.isDrawer) {
          if (openDrawer === true) {
            this.drawer.open();
          }
        }

        this.status.loaded = true;
        this.loading(false);

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: cart
          }
        }));
      },

      _createCart: function(cart) {
        var $form = this.$form.clone();

        $(selectors.item, $form)
          .not(selectors.cartNoteContainer)
          .remove();

        $(selectors.itemList, $form)
          .prepend(this._createItemList(cart));

        $(selectors.cartNoteInput, $form)
          .val(cart.note);

        this._updateFact(cart, $form)
        setTimeout(function() {
          this.sizeCart();
        }.bind(this), 500);

        $(selectors.cartDiscountContainer, $form)
          .toggleClass('hide', cart.total_discount === 0);

        $(selectors.cartDiscountContent, $form).html(
          this._createCartDiscountList(cart));

        $(selectors.cartSubtotal, $form)
          .html(theme.Currency.formatMoney(cart.total_compare_at, theme.settings.moneyFormat));

        // Hide discount if the prices match
        $(selectors.cartCompareAtContainer, $form)
          .toggleClass('hide', cart.total_compare_at === cart.total_price);
        $(selectors.cartCompareAtDiscount, $form)
          .html(theme.Currency.formatMoney(cart.total_price - cart.total_compare_at, theme.settings.moneyFormat));

        $(selectors.cartTotal, $form)
          .html(theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat));

        $(selectors.cartSubmit, $form).attr('disabled', cart.items.length === 0);

        return $form;
      },

      _createItemList: function(cart) {
        const artistText = $('.cart_artist_icons_text')
        let BaSCount = 0
        artistText.hide()
        return $.map(cart.items.reverse(), function(item) {
          // console.log('CREATE ITEM LIST', item);
          var itemName = item.title;
          var $item = this.$itemTemplate.clone().removeClass(classes.cartTemplate).removeClass(classes.bundle).attr('data-product-type', item.product_type); // CREATES NEW DRAWER CART ITEM
          if(item.handle.includes('tile-bundle') || item.handle.includes('the-flex-tile-set-of'))
            $item.addClass(classes.bundle)
          // $item.addClass('this-is-an-added-class')
          
          // NEWHATT
          if(item.handle.includes('patent-pending-hat') && item.final_line_price === 0){
            $item.addClass('free-promotional-item')
          }

          var propertyList = this._createPropertyList(item);
          var discountList = this._createDiscountList(item);

          // console.log('ITEM',item.title);
          //if(itemName != 'Custom Label') {
          //console.log(customCost, 'CUSTOM COST');
          
          if (item.product_id === Number(build_a_system_id))
            $item.hide()

          if (item.product_id === Number(gift_card_product_id))
            $item.hide()

          var customItem = checkCustomItem(customItem);
          function checkCustomItem(customItem) {
       	  $.each(item.properties, function(value, key) {
            //console.log('ITEM PROPERTIES', key, value);
          	 if(value == 'Custom Label' || value == '_Custom Label' && key != '') {
                  customItem = true;
                  return false;
             }

          });

            if(customItem == true) {
             return true;
            }
          }


             if(checkCustomItem(customItem) == true) {
              $item.addClass('customized-item');
            }

          var itemPrice = this._createItemPrice(
            item.original_price,
            item.final_price,
            item.compare_at_price,
            item.properties,
            item.handle,
            item.variant_title
          );

          var itemLinePrice = this._createItemPrice(
            item.original_line_price,
            item.final_line_price,
            0,
            item.properties,
            item.handle,
            item.variant_title
          );

         //  var itemCustomPrice = this._createCustomPrice();

           //console.log(itemCustomPrice);
          $item.find(selectors.itemId)
            .addBack(selectors.itemId)
            .attr(data.itemId, item.key);

          $(selectors.itemHref, $item)
            .attr('href', item.url);
          
          const boxesColor = []
          Object.keys(item.properties).forEach((prop)=>{
            if (prop.includes("Bundle Color"))
              boxesColor.push(bundleColorValues.indexOf(item.properties[prop]) + 1)
              
            if (prop.includes("Standard Bundle Label") && isLabelForPreorder(item.properties[prop])) {
              artistText.show()
            }
          })

          if (isArakiProduct(item.handle)) {
            artistText.show()
          }
          if (isCorporateGifts(item.handle)) {
            if (boxesColor.length === 2) {
              boxesColor.splice(0, 0, 0);
            }
            if (boxesColor.length === 4) {
              boxesColor.splice(3, 0, 0);
              boxesColor.push(0)
            }
            if (boxesColor.length === 5) {
              boxesColor.unshift(0)
            }
          }

          let previewUrl;
          $(selectors.itemEdit, $item).attr('href', `/products/${item.handle}?item_key=${item.key}`)
          if (canUseImageService(boxesColor, item.handle)) {
            const { typeParam, isCorporate } = imageServiceParams(item.handle)
            previewUrl = `${image_service_url}/api/image?${typeParam}device=thumbnail&capsules=${boxesColor.join(',')}${isCorporate}&source=theme-lqd`
          } else if (isBaSHandle(item.handle)) {
            previewUrl = `url(${cartBaSPreviewsList[BaSCount % cartBaSPreviewsList.length]})`
            
            if(item.properties['_custom_image_url']){
              previewUrl = `url(${item.properties['_custom_image_url']})`
            }
            
            //check if the item has a url for the image that we can use to preview the item in the cart

            // $(selectors.itemEdit, $item).attr('href', `${item.properties['_URL For Edit']}&item_key=${item.key}`)
            $(selectors.itemEdit, $item).attr('href', `${item.properties['URL For Edit'] || item.properties['_URL For Edit']}&item_key=${item.key}`);

            if (item.properties['_Price Without Discount']) {
              $(selectors.itemBackgroundImage, $item).after(
                `<div class="bas-count">${`$${BaSGetDiscount(Number(item.properties['_Price Without Discount'])).discount} off`}</div>`
              );
            }
            BaSCount += 1
          } else {
            previewUrl = item.image ? `url(${theme.Images.getSizedImageUrl(item.image, '200x')})` : 'none'
          }
          if (isCorporateGifts(item.handle)) {
            $(selectors.itemEdit, $item).attr('href', `${item.properties['URL For Edit']}&item_key=${item.key}`)
          }

          if (item.handle === 'patent-pending-hat') {
            $('.cart__edit', $item).hide();
            if (!item.variant_title.includes('no-discount')) {
              $('[data-cart-item-delete]', $item).addClass('visible');
              $('[data-cart-item-input-quantity]', $item).hide();
              $('[data-cart-item-edit], .cart-quantity-area', $item).hide();
            }
          }

          if (item.handle === 'build-a-system-new') {
            // $('.cart__edit', $item).hide();
            $('[data-cart-item-delete]', $item).addClass('visible');
            $('[data-cart-item-input-quantity]', $item).hide();
            $('.cart-quantity-area', $item).hide();
          }

          $(selectors.itemBackgroundImage, $item)
            .removeAttr('data-bgset')
            .css('background-image', previewUrl)
            .addClass('lazyload');

          $(selectors.itemTitle, $item).text(item.product_title);
          if (isBaSHandle(item.handle)) {
            $(selectors.itemTitle, $item).text(`${item.product_title} (${item.properties['_Count of items'] || item.properties['Count of items']})`);
          }

          $(selectors.itemVariantTitle, $item).text(item.variant_title);

          //FREECAPSULEPROMO
          //edit this code to style the cart however you want!
          //if the item properties contain the key Offer, then do something
          if(item.properties && item.properties['Offer']) {
            
            console.log(item, 'ITEM WITH OFFER PROPERTIES');
            $('[data-cart-item-delete]', $item).addClass('visible');
            $('[data-cart-item-input-quantity]', $item).hide();
            $('[data-cart-item-discount-list]', $item).hide();
            
            $('.cart-quantity-area', $item).hide();
            $('.cart__item-price--original', $item).hide();
            
            //update the name of the item in the cart
            $('[data-cart-item-title]', $item).text('FREE GIFT: ' + item.product_title);

            //set the url to edit to include that this item is an offer and it is free
            $(selectors.itemEdit, $item).attr('href', `/products/${item.handle}?item_key=${item.key}&Offer=FREE`);

          }

           if(item.handle === 'promotional-mini-ink-parcel' 
            || item.handle === 'gift-with-purchase-large-parcel'
            || item.handle === 'gift-with-purchase-small-trio-snow') {
            // console.log(item, 'ITEM WITH OFFER PROPERTIES');

            $('[data-cart-item-input-quantity]', $item).hide();
            $('[data-cart-item-discount-list]', $item).hide();            
            $('.cart-quantity-area', $item).hide();
            $('.cart-qty-block', $item).hide();
            $('.cart__item-price--original', $item).hide();
            //set the data-cart-item-price-container to FREE 
            $('.cart-price-wrapper', $item).text('FREE');

            //change the item url of the title to link to nothing, remove the link or link to a different page
            if(item.handle === 'gift-with-purchase-large-parcel'){
              $(selectors.itemHref, $item).attr('href', '/products/the-large-parcel');
            }
            
            //update the name of the item in the cart
            // $('[data-cart-item-title]', $item).text('FREE GIFT: ' + item.product_title);
            //set the url to edit to include that this item is an offer and it is free
            // $(selectors.itemEdit, $item).attr('href', `/products/${item.handle}?item_key=${item.key}&Offer=FREE`);

          }


          // add message to the cart item if it contains limited edition items
          // const limited_edition_colors = ['Blush', 'Rosa', 'Plum'];
          // let contains_limited_edition_color = false;

          // if (limited_edition_colors.some(substring => item.variant_title.includes(substring))) {
          //   contains_limited_edition_color = true;
          // }else{
          //   //check the bundle
          //   Object.keys(item.properties).forEach((prop)=>{
          //     if (prop.includes("Bundle Color")){
          //       if(limited_edition_colors.includes(item.properties[prop])){
          //         contains_limited_edition_color = true;
          //       }
          //     }
          //   });
          // }
          
          // //check the individual items
          // if (contains_limited_edition_color) {
          //   $(selectors.itemMessage, $item).text('US orders of limited edition colors are estimated to arrive by 11/24. ');
          // }
          
          $(selectors.itemPriceContainer, $item).html(itemPrice);

          $(selectors.itemLinePriceContainer, $item).html(itemLinePrice);

          $(selectors.itemGiftMessage, $item).val(item.properties['Gift message']);
          const giftMessageMaxLength = $(selectors.itemGiftMessage).attr('maxlength')
          const giftMessageLength = item.properties['Gift message'] ? item.properties['Gift message'].length : 0
          $(selectors.itemGiftMessage, $item).parent().find('.textarea-counter').html(`${giftMessageMaxLength - giftMessageLength} characters remaining`);
          $($item).attr('data-cart-variant-id', item.variant_id);
          $($item).attr('data-product-timestamp', item.properties ? item.properties['_Timestamp'] : '');

          $(selectors.itemLinePrice, $item)
            .html(theme.Currency.formatMoney(item.line_price, theme.settings.moneyFormat));

          $(selectors.itemLabelQuantity, $item)
            .attr('for', 'quantity_' + item.key);

          $(selectors.itemInputQuantity, $item)
            .attr('name', 'updates[' + item.key + ']')
            .attr('id', 'quantity_' + item.key)
            .val(item.quantity);
          
          $(selectors.itemPropertyList, $item)
            .html(propertyList);

          $(selectors.itemDiscountList, $item)
            .html(discountList);

          return $item[0];
            // }
        }.bind(this)).reverse();
      },

      _updateFact: function(cart, $form) {
        let totalCapsules = 0;
        const vm = this
        const cartCopyElementParent = $(selectors.cartFact, $form)
        totalCapsules = cart.items.reduce((acc, curr) => {
          return acc + vm._getCapsuleCount(curr.product_id, curr.quantity)
        }, 0)
        if (!totalCapsules) {
          cartCopyElementParent.addClass('hidden');
          return;
        }

        cartCopyElementParent.removeClass('hidden');
        const cartFactDummy = $(selectors.cartFactCopyDummy);
        if (!cartFactDummy.length) return

        const isSingular = totalCapsules.toString().endsWith('1');
        const capsuleText =  isSingular ? 'capsule' : 'capsules';
        const bottleText =  isSingular ? 'bottle' : 'bottles';
        const str = cartFactDummy.html().replace('n_capsules', totalCapsules).replace('n_bottles', totalCapsules)
          .replace('n_plastic', totalCapsules*3).replace('w_bottle', bottleText).replace('w_capsule', capsuleText)

        $(selectors.cartFactCopy, $form).html(str);
      },

      _createItemPrice: function(original_price, final_price, compare_at_price, item, handle, variant_title) {
        var customCost = getCustomCost(customCost);
        if (handle === 'patent-pending-hat' && !variant_title.includes('no-discount') && isReturningCustomer()) {
          return (`
            <div class="cart__item-price" data-cost="${original_price}">
              ${theme.Currency.formatMoney(0, theme.settings.moneyFormat)}
            </div>`
          );
        }

        function getCustomCost(customCost){
          $.map(item, function(value, key) {
            if(key == 'Customization Cost') {
              customCost = value;
              return customCost;
            }

          });

          return customCost;
        }


        if(customCost === undefined) {
         customCost = '';
        }

        if (original_price !== final_price) {
          return (
            '<span class="visually-hidden">' + theme.strings.regularPrice + '</span>' +
            '<del class="cart__item-price--original">' +
            theme.Currency.formatMoney(original_price, theme.settings.moneyFormat).replace('.00', '') +
            '</del>' +
            '<span class="visually-hidden">' + theme.strings.salePrice + '</span>' +
            '<span class="cart__item-price cart__item-price--bold">' +
            theme.Currency.formatMoney(final_price, theme.settings.moneyFormat).replace('.00', '') +
            '</span>'

          );
            } else if(customCost !== '' || null) {

          return (
            `<span class="cart__item-price" data-cost="${original_price}">${theme.Currency.formatMoney(original_price, theme.settings.moneyFormat).replace('.00', '')}</span>`
            // '<span class="cart__item-price">' + theme.Currency.formatMoney(original_price, theme.settings.moneyFormat) + '</span><div> + '+customCost+'</div>'
          );
        } else {
           const compare_text = (compare_at_price > original_price) ? theme.Currency.formatMoney(compare_at_price, theme.settings.moneyFormat).replace('.00', '') : '';
           return (`
            <div class="cart__item-price" data-cost="${original_price}">
              <span class="product__price product__price--compare" data-product-price-compare>
              ${compare_text}
              </span>
              ${theme.Currency.formatMoney(original_price, theme.settings.moneyFormat).replace('.00', '')}
            </div>`
          );
        }
      },

      _getCapsuleCount: function(productId, qty) {
        let num = 0
        const id = productId.toString()
        if (triple_bundles.includes(id)) {
          num = 3
        } else if (id === BY2_product_id) {
          num = 2
        } else if (id === BY4_product_id) {
          num = 4
        } else if (sextuple_bundles.includes(id)) {
          num = 6
        } else if (id === capsule_a_day_product_id) {
          num = 7
        } else if (id === BY12_product_id) {
          num = 12
        } else if (id === capsule_product_id) {
          num = 1
        }
        return qty * num
      },


      _createPropertyList: function(item) {
        // custom props logic
        let lastBundleColorValue;
        let lastBundleLabelValue;
        let lastBundleSizeValue = defaulf_size?.toLowerCase();
        const listItems = []
        var colorProperty = item.options_with_values.find(x => x.name === 'Color');
        var typeOption= item.options_with_values.find(x => x.name === 'Type');
        if (colorProperty) {
          lastBundleColorValue = colorProperty.value.charAt(0).toUpperCase() + colorProperty.value.slice(1)
        }
        
        // listItems.push('<div class="expand-wrapper">generic first item [test]</div>');
        
        //if this item contains adapter in the title, include the title of the variant in the cart
        if (item.sku?.includes('adapter')) {
          listItems.push('<div class="extra-line-items"><b>Type</b>: '+item.variant_title+'</div>');
        }

        //if we want to add generic versions of what to show here, just use something like this
        // listItems.push('<div class="extra-line-items"><b>Type</b>: '+item.variant_title+'</div>');

        if (item.sku?.includes('prelabeled')) {
          //if color property has a value then return the color property in the expand wrapper
          if (colorProperty?.value) {
            listItems.push('<div class="extra-line-items"><b>Color</b>: '+colorProperty.value+'</div>');
            // return '<div class="expand-wrapper">'+colorProperty.value+'</div>';r
          }

          var labelsProperty = item.options_with_values.find(x => x.name === 'Labels');
          var labelsPropAlternate = item.options_with_values.find(x => x.name === 'labels');

          if(labelsProperty){
            listItems.push('<div class="extra-line-items"><b>Labels</b>: '+labelsProperty.value+'</div>');
          }else if(labelsPropAlternate){
            listItems.push('<div class="extra-line-items"><b>Labels</b>: '+labelsPropAlternate.value+'</div>');
          }

        }

        if (item.handle.includes('harbor') || item.handle.includes('jade')) {
          var size_prop = item.options_with_values.find(x => x.name.toLowerCase() === 'size');
          if(size_prop){
            listItems.push('<div class="extra-line-items"><b>Size</b>: '+size_prop.value+'</div>');
          }
          //lookup the property with label , in here: item.properties['Label']
          var label_prop = item.properties['_Label'] || item.properties['label'];
          var customLabel = item.properties['_Custom Label'] || item.properties['Custom Label'];
          var font_prop = item.properties['_font'];
          if(label_prop){
            if(label_prop === 'customize' && customLabel){
              listItems.push('<div class="extra-line-items"><b>Custom Label</b>: '+customLabel+'</div>');
            } else {
              listItems.push('<div class="extra-line-items"><b>Label</b>: '+label_prop+'</div>');
            }
          }
          if(font_prop && font_prop !== ''){
            listItems.push('<div class="extra-line-items"><b>Font</b>: '+font_prop+'</div>');
          }
          return listItems;
        }else if (item.properties['_font']?.toLowerCase() === 'script') {
          listItems.push('<div class="extra-line-items"><b>Font</b>: Script</div>');
        }
        
        if (item.handle === 'the-vault-capsules') {

          // 3xparcel sizing
          var size_prop = item.options_with_values.find(x => x.name.toLowerCase() === 'size');
          if(size_prop){
            listItems.push('<div class="extra-line-items"><b>Size</b>: '+size_prop.value+'</div>');
          }
        }
        // var parcelColorProperty = item.options_with_values.find(x => x.name === 'Parcel Color');
        // if(parcelColorProperty){
        //   listItems.push('<div class="extra-line-items"><b>Parcel Color</b>: '+parcelColorProperty.value+'</div>');
        // }

        if (item.handle === 'new-parcel' || item.handle === 'parcel-canvas-early-launch') {
          
          // 3xparcel sizing
          var parcelSizingProperty = item.options_with_values.find(x => x.name === 'sizing');
          if(parcelSizingProperty && parcelSizingProperty.value !== 'Medium'){
            // listItems.push('<div class="extra-line-items"><b>Size</b>: '+parcelSizingProperty.value+'</div>');
          }

          var parcelSizeProperty = item.options_with_values.find(x => x.name === 'size');
          if(parcelSizeProperty){
            listItems.push('<div class="extra-line-items"><b>Bundle</b>: '+parcelSizeProperty.value+'</div>');
          }
          //list out the _color_parcel_1, _color_parcel_2, _color_parcel_3 properties
            // var parcelColorProperty = item.properties[`_color_parcel_1`];
            //check if item.properties[`_color_parcel_1`]; exists 
            if (parcelSizeProperty.value == 'Single' && item.properties['_color_parcel_1']) {
              listItems.push('<div class="extra-line-items"><b>Parcel Color</b>: '+item.properties['_color_parcel_1']+'</div>');
            }

            if (parcelSizeProperty.value == 'Duo' && item.properties['_color_parcel_1']) {
              listItems.push('<div class="extra-line-items"><b>Parcel Colors</b>: '+item.properties['_color_parcel_1']+', '+item.properties['_color_parcel_2']+'</div>');
            }
            if (parcelSizeProperty.value == 'Trio' && item.properties['_color_parcel_1']) {
              listItems.push('<div class="extra-line-items"><b>Parcel Colors</b>: '+item.properties['_color_parcel_1']+', '+item.properties['_color_parcel_2']+', '+item.properties['_color_parcel_3']+'</div>');
            }

        } else if (item.handle === 'the-mini-parcel') {
          listItems.push('<div class="extra-line-items"><b>Color</b>: Ink</div>');
          if(item.sku.toLowerCase().includes('miniparcelsingle')){
            listItems.push('<div class="extra-line-items"><b>Bundle</b>: Single Parcel</div>');
          }else if(item.sku.toLowerCase().includes('miniparcelcapsules')){
            listItems.push('<div class="extra-line-items"><b>Bundle</b>: Parcel + Snow Capsules</div>');
          }

        }else if (item.handle.includes('parcel')){
          if(colorProperty && colorProperty.value !== 'None'){
            listItems.push('<div class="extra-line-items"><b>Color</b>: '+colorProperty.value+'</div>')

          }else if (item.properties['Color Selection']) {
            listItems.push('<div class="extra-line-items"><b>Color</b>: '+item.properties['Color Selection']+'</div>');
          }else {
            var setsize = false;
            if(item.sku.toLowerCase().includes('duo')){
              setsize = 'Duo';
            }else if(item.sku.toLowerCase().includes('trio')){
              setsize = 'Trio';
            }else if(item.sku.toLowerCase().includes('single')){
              setsize = 'Single';
            }
            if(setsize){
              listItems.push('<div class="extra-line-items"><b>Bundle</b>: '+setsize+'</div>');
            }
            // if its single, show single
              //if its duo, show duo
              // if its trio say trio
          }

          if (item.properties['Embroidery']) {
            listItems.push('<div class="extra-line-items"><b>Embroidery</b>: '+item.properties['Embroidery']+'</div>');
          }

        }

        if (item.properties['_requestedGiftwrap']?.toLowerCase() === 'yes' && item.properties['Gift Note']) {
            listItems.push('<div class="extra-line-items"><b>Gift Note</b>: '+item.properties['Gift Note']+'</div>');
        }
        

        if (item.handle === 'the-discovery-set') {
            if (item.properties['_color_parcel_1']) {
              listItems.push('<div class="extra-line-items"><b>Parcel Color</b>: '+item.properties['_color_parcel_1']+'</div>');
            }
        }
        

        
        
        if (item.handle === 'build-your-6') {
          return ''
        }

        // NEWHATT
        if (item.handle === 'patent-pending-hat' && item.final_line_price === 0) {
          return '<div class="expand-wrapper">Free gift with purchase: Limited edition terracotta hat</div>'
        }else if (item.handle === 'patent-pending-hat' && item.final_line_price > 0) {
          return '<div class="expand-wrapper">Limited edition baseball hat</div>' 
        }

        // SPATULACODE
        if (item.handle === 'spatula') {
          return '<div class="expand-wrapper">'+item.variant_title+'</div>';
          // return '<div class="expand-wrapper">'+item.variant_title+'<br>NOTE: this is a preorder product and will not ship until later this year.</div>';
        }

        const regularItem = (value, key) => {
          const $propertyTemplate = (this.$propertyTemplate || $(selectors.itemProperty).first())
          const $property = $propertyTemplate.clone().removeClass(classes.cartTemplate).attr('data-cart-item-property', key);

          // SUPPRESSPROPS
          if (item.handle.includes('parcel')) return;
          if (item.handle.includes('discovery')) return;
          if (item.handle.includes('compact')) return;
          if (item.handle.includes('carry')) return;
          if (item.handle === '6-tile-bundle') return;
          
          // Line item properties prefixed with an underscore are not to be displayed

          var skippable = true;
          if(key.includes('Color') || key.includes('Label')){
            skippable = false;
          }
          if (key.charAt(0) === '_' && skippable) return;

          // PROPERTY LIST
          // Line item properties with no value are not to be displayed
          if (value === '') return;
          if (value == 'customize') return;
          if (filter_props.includes(key)) return;

          if (key == 'Gift card amount' || key == 'Gift Note') return $property.text(`${key}: ${value}`);

          if (key.includes('Color')) {
            lastBundleColorValue = value;
            return;
          }

          if (key.includes('Color')) {
            lastBundleColorValue = value;
            return;
          }
          
          if (key == 'Amount' || key == 'Gift Note') return $property.text(`${key}: ${value}`);

          if (key == 'to') return $property.text(`To: ${value}`)

          if (isCorporateGifts(item.handle) && !key.includes('Bundle ')) {
            const priceFormat = "$\{\{amount_no_decimals\}\}"
            let val = value
            if (key.toLowerCase().includes('price')) {
              val = parseFloat(value.replace(/[^.\d]+/g,"").replace( /^([^\.]*\.)|\./g, '$1' ))
              if (key === "Packing Price")
                key = val > 0 ? 'Cadence Packaging' : 'Bulk Packaging'
              val = val > 0 ? theme.Currency.formatMoney(val * 100, priceFormat) : 'Free'
            }
            return $property.text(`${key}: ${val}`);
          }


          if (key.includes('Label')) {
            const type = key.includes('Custom') ? 'C' : 'S';
            const index = key.split(' ').pop();
            $property.html(`<i>${value},</i> ${lastBundleColorValue}`);
          }
          else if (value.indexOf('/uploads/') === -1) {
            $property
              .text(value);
          } else {
            $property
              .html(key + ': <a href="' + value + '">' + value.split('/').pop() + '</a>');
          }

          return $property[0];
        }

        //this will generate the properties for the builder items (system and builders)
        const BaSItem = (value, key) => {
          
          //trim the prefix _ from the key, if it starts with it exclusively
          //backwards compatibility of keys hither for...
          // CHECKOUTEXTENSIBILITY
          var newKey = key.replace(/^_/, '');

          const $propertyTemplate = (this.$propertyTemplate || $(selectors.itemProperty).first())
          const $property = $propertyTemplate.clone().removeClass(classes.cartTemplate).attr('data-cart-item-property', newKey);
          //get the last property ID from the item
          var property_id = newKey.split(' ').pop();
          if (newKey.includes('Size')) { return; }
          // base it off the color property
          if (newKey.includes('Color') && newKey !== 'Color Selection') {
            
            var labelPropertyFromArrayDirectly, sizePropertyFromArrayDirectly;
            if (item.properties && `Standard Bundle Label ${property_id}` in item.properties) {
                labelPropertyFromArrayDirectly = item.properties[`Standard Bundle Label ${property_id}`];
            }else if (item.properties && `_Standard Bundle Label ${property_id}` in item.properties) {
              labelPropertyFromArrayDirectly = item.properties[`_Standard Bundle Label ${property_id}`];
            }
            
            if(isBuildYour(item.handle)){
              sizePropertyFromArrayDirectly = 'medium';
              if(item.handle == 'the-132-set-of-4-sm'){
                sizePropertyFromArrayDirectly = 'small';
              }
              if(item.handle == 'the-132-set-of-3-sm'){
                sizePropertyFromArrayDirectly = 'small';
              }

            }else if (item.properties && `Bundle Size ${property_id}` in item.properties) {
                sizePropertyFromArrayDirectly = item.properties[`Bundle Size ${property_id}`];
            }else if (item.properties && `_Bundle Size ${property_id}` in item.properties) {
              sizePropertyFromArrayDirectly = item.properties[`_Bundle Size ${property_id}`];
            }

            lastBundleColorValue = value;

            var final_size = sizeNameByValue[sizePropertyFromArrayDirectly.toLowerCase()];
            const colorIndex = bundleColorValues.indexOf(lastBundleColorValue) + 1
            const img = `<img src="https://dynacapsule.com/singles.php?is_single=true&capsules=${colorIndex}&size=${sizePropertyFromArrayDirectly?.toLowerCase()}&cropped=true">`;
            return $property.html(`${img} ${labelPropertyFromArrayDirectly}, ${final_size}`);
          }
        }

        const itemProperties = $.map(item.properties, (isBaSHandle(item.handle) || isBuildYour(item.handle) ? BaSItem : regularItem).bind(this));
        
        //if it is not a builder or special item, return the regular properties
        if (!isBaSHandle(item.handle) && !isBuildYour(item.handle)) return listItems.concat(itemProperties)


        const expandedEl = $(`
          <div class="expand-wrapper">
            <label class="expand-trigger">
              <span class="title-hide">Hide contents</span>
              <span class="title-show">View contents</span>
              <span class="ico-chevron-down"></span>
            </label>
            <div class="expand-content" style="display:none"></div>
          </div>
          `)
        expandedEl.find('.expand-content').append(itemProperties)
        // expandedEl.find('.expand-content').append('this is some sample text')
        return listItems.concat(expandedEl)
        
      },

      _createDiscountList: function(item) {
        return $.map(item.line_level_discount_allocations, function(discount) {
          /*
          var $discount = this.$discountTemplate.clone().removeClass(classes.cartTemplate);
            .find(selectors.itemDiscountTitle)
            .text(discount.discount_application.title);
          $discount
            .find(selectors.itemDiscountAmount)
            .html(theme.Currency.formatMoney(discount.amount, theme.settings.moneyFormat));
          return $discount[0];
          */

          // this was removed from the below code, if we want the actual amount of the discount there
          // (-<span data-cart-item-discount-amount>${theme.Currency.formatMoney(discount.amount, theme.settings.moneyFormat)}</span>)

          //discount line item
          const $discount = $(`
            <div data-cart-item-discount>
              <small><span data-cart-item-discount-title>${discount.discount_application.title}</span></small>
              
            </div>
          `);
          return $discount;
        }.bind(this));
      },

      _createCartDiscountList: function(cart) {
        return $.map(
          cart.cart_level_discount_applications,
          function(discount) {
            var $discount = this.$cartDiscountTemplate.clone().removeClass(classes.cartTemplate);

            $discount.find(selectors.cartDiscountTitle)
              .text(discount.title);
            $discount
              .find(selectors.cartDiscountAmount)
              .html(theme.Currency.formatMoney(discount.total_allocated_amount, theme.settings.moneyFormat));

            return $discount[0];
          }.bind(this)
        );
      },

      _onItemQuantityChange: function(evt) {
        this.loading(true);

        const $input = $(evt.target);
        const itemEl = $input.closest(selectors.item)
        const id = itemEl.attr(data.itemId);
        const productType = $input.closest(selectors.item).attr('data-product-type');
        let quantity = $input.val();
        const variantId = $input.closest(selectors.item).attr('data-cart-variant-id');

        // Don't update the cart when a input is empty. Also make sure an input
        // does not remain empty by checking blur event
        if (quantity === '' || !id)
          return;

        if (productType === "build-your-2" && quantity > 1)
          quantity = 1

        if (quantity == 0) {
          itemEl.attr(data.itemId, '');
          $('.js-modal-open-bas-confirm-modal').click()
          $('#bas-confirm-modal .modal__centered-header').text(theme.strings.cartConfirmDelete)
          $('#bas-confirm-modal .modal__centered-copy').hide()
          $('#bas-confirm-modal').data('itemEl', itemEl)
          $('#bas-confirm-modal').data('input', $input)
          $('#bas-confirm-modal').data('self', this)
          $('#bas-confirm-modal').data('id', id)
          $('#bas-confirm-modal').data('type', 'cart')
          $('#bas-confirm-modal .btn-confirm').text('Remove')
          return
        }
        theme.cart.changeItem(id, quantity);
      },

      _onItemQuantityEmptyBlur: function(evt) {
        var $input = $(evt.target);
        var id = $input.closest(selectors.item).attr(data.itemId);
        var value = $input.val();

        if (value !== '') { return; }

        theme.cart.getCart().then(function(cart) {
          this.buildCart(cart);
        }.bind(this));
      },

      _onItemDelete: function(evt) {
        evt.preventDefault();

        var $deleteButton = $(evt.target);
        var $items = $(selectors.item, this.$container);
        var $item = $deleteButton.closest(selectors.item);
        var $note = $(selectors.cartNoteContainer, this.$container);
        var id = $item.attr(data.itemId);
        var variantId = $item.attr('data-cart-variant-id');

        if ($items.length === 2 && $items.last().is($note)) {
          $note.addClass(classes.cartItemRemove);

          slate.a11y.promiseTransitionEnd($(selectors.itemList, this.$container)).then(function() {

            $note.removeClass(classes.cartItemRemove);
          });
        }

        //confirming the deletion only of the build a system stuff 
        if($item.attr('data-product-type') === 'build-a-system') {
          const $input = $(evt.target);
          //add modal to confirm removal just like the quantity == 0 change event
          $('.js-modal-open-bas-confirm-modal').click()
          $('#bas-confirm-modal .modal__centered-header').text(theme.strings.cartConfirmDelete)
          $('#bas-confirm-modal .modal__centered-copy').hide()
          $('#bas-confirm-modal').data('itemEl', $item)
          $('#bas-confirm-modal').data('input', $input)
          $('#bas-confirm-modal').data('self', this)
          $('#bas-confirm-modal').data('id', id)
          $('#bas-confirm-modal').data('type', 'cart')
          $('#bas-confirm-modal .btn-confirm').text('Remove')
          return;
      }
        
        $item.addClass(classes.cartItemRemove);

        slate.a11y.promiseAnimationEnd($item).then(function() {
          //getCustomLabelKey(id); // Added BD to remove custom labels when main item is deleted.
          console.log('DELETE', $item); // To test with stuff later
          console.log($item.attr(data.itemId));

          theme.cart.changeItem(id, 0);
        }.bind(this));
      },

      loading: function(state) {
        this.status.loading = state;

        if (state) {
          $(selectors.itemList, this.$form).addClass('loading');
        } else {
          $(selectors.itemList, this.$form).removeClass('loading');
        }
      },

      sizeCart: function() {
        // If drawer cart is set to static, measure to make sure it should
        // stay that way
        if (this.$container.hasClass(classes.staticDrawerElement)) {
          // Add static class, measure, and decide if we need to add it back
          this.$container.addClass(classes.staticDrawerElement);

          // If cart is taller than window, remove static class so
          // elements become absolute and items scrollable
          if (this.$container.height() >= window.innerHeight) {
            this.$container.removeClass(classes.staticDrawerElement);
          }
        }

        // Stop if our drawer doesn't have a fixed footer
        if (!this.$container.hasClass('drawer--has-fixed-footer')) {
          return;
        }

        // Elements are reprinted regularly so selectors are not cached
        var $cartFooter = this.$container.find(selectors.fixedFooter).removeAttr('style');
        var $cartInner = this.$container.find(selectors.fixedInnerContent).removeAttr('style');
        var cartFooterHeight = $cartFooter.outerHeight();

        $cartInner.css('bottom', cartFooterHeight);
        $cartFooter.css('height', cartFooterHeight);
      },

      updateCartNotification: function(cart) {
        // console.log('updateCartNotification');
        const isHidden = (item) => 
          (item.properties && item.properties['Parent key']) 
        || (item.properties && item.properties['Parent Timestamp'])
        || (item.properties && item.properties['_Parent Timestamp'])

        const itemCount = cart.items.reduce((prev, curr) => !isHidden(curr) ? prev + curr.quantity : prev, 0)

        $(selectors.cartCount).text(itemCount);
        $('body').toggleClass(classes.cartHasItems, cart.item_count > 0);
      },

      _highlightText: function(evt) {
        // Don't want the mobile tooltip to pop up
        if (!theme.config.isTouch) {
          $(evt.target).select();
        }
      }
    });

    return AjaxCart;
  })();



  theme.StickyCart = (function() {
    var config = {
      namespace: '.ajaxcart'
    };

    var selectors = {
      cart: '#StickyCart',
      items: '#StickyItems',
      subtotal: '#StickySubtotal',
      submit: '#StickySubmit'
    };

    var classes = {
      active: 'sticky-cart--open',
      activeBodyClass: 'body--sticky-cart-open'
    };

    function StickyCart() {
      this.status = {
        loaded: false,
        loading: false,
        open: $('body').hasClass(classes.activeBodyClass)
      };

      this.initEventListeners();
    };

    StickyCart.prototype = $.extend({}, StickyCart.prototype, {
      initEventListeners: function() {
        $(selectors.submit).on('click', function() {
          $(this).addClass('btn--loading');
        });

        $('body').on('added.ajaxProduct', function() {
          this.hideCart();
          theme.cart.getCart().then(function(cart) {
            this.buildCart(cart, true);
          }.bind(this));
        }.bind(this));
      },

      hideCart: function() {
        $('body').removeClass(classes.activeBodyClass);
        $(selectors.cart).removeClass(classes.active);
      },

      showCart: function(count, subtotal) {
        if (count) {
          $(selectors.items).text(theme.strings.cartItems.replace('[count]', count));
        }
        if (subtotal) {
          $(selectors.subtotal).html(theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat));
        }

        $('body').addClass(classes.activeBodyClass);
        $(selectors.cart).addClass(classes.active);

        this.status.open = true;

        if (theme.settings.currenciesEnabled) {
          theme.currencySwitcher.ajaxrefresh();
        }
      },

      buildCart: function(cart, open) {
        this.loading(true);

        this.status.loaded = true;
        this.loading(false);

        // If specifically asked, open the cart (only happens after product added from form)
        if (open === true) {
          this.showCart(cart.item_count, cart.total_price);
        }
      },

      loading: function(state) {
        this.status.loading = state;

        if (state) {
          $(selectors.cart).addClass('is-loading');
        } else {
          $(selectors.cart).removeClass('is-loading');
        }
      },

      updateError: function(XMLHttpRequest) {
        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          console.warn(XMLHttpRequest.responseJSON.description);
        }
      }
    });

    return StickyCart;
  })();

  theme.AjaxProduct = (function() {
    var status = {
      loading: false
    };

    function ProductForm($form) {
      this.$form = $form;
      this.$addToCart = this.$form.find('.add-to-cart');
      this.productId = $form.find('[name="data-product-id"]').val();

      if (this.$form.length) {
        this.$form.on('submit', this.addItemFromForm.bind(this));
      }
    };

    ProductForm.prototype = $.extend({}, ProductForm.prototype, {
      addItemFromForm: async function(evt, callback){
        evt.preventDefault();
        if ($('html').hasClass('page-corporate_gifts')) return;

        if (status.loading || !theme.cart.data?.items) {
          return;
        }

        this.$form.find('[data-add-to-cart]').addClass('btn--loading').removeClass('loaded');
        status.loading = true;
        const searchString = new URLSearchParams(window.location.search);
        const item_key = searchString.get('item_key');

        var data = this.$form.serialize();
        data = {items: [deparam(data)]}
        const product = data.items[0]
        this.setCustomLabels(product)
        this.addShadowProducts(data, product)
        this.addGiftCartWithProduct(data, product)
        
        //remove the property called 'Timestamp' from the items inside data
        //this is to prevent the cart from adding the same item multiple times
        //if this product's handle is 'the-parcel'
        // for (var i = 0; i < data.items.length; i++) {
        //   if(data.items?.[i]?.['product-id'] === "7041799520341"){ 
        //     delete data.items[i].properties['Timestamp'];
        //   }
        //   if(data.items?.[i]?.['product-id'] === "7055244722261"){ 
        //     delete data.items[i].properties['Timestamp'];
        //   }
        // }

        //delete properties that are empty strings or false or "no"
        var deletable_properties = ['_requestedGiftwrap', 'Gift Note', 'Embroidery']; 
        for (var i = 0; i < data.items.length; i++) {
          for (var key in data.items[i].properties) {
            if (deletable_properties.includes(key) && (data.items[i].properties[key] === '' || data.items[i].properties[key] === false || data.items[i].properties[key] === 'no')) {
              // console.log('we will be deleting this property', key, 'with value', data.items[i].properties[key]);
              delete data.items[i].properties[key];
            }
          }
        }

        //generate a `_settings` property with json string of the specific settings that the user has selected

        // _settings: 
        //   _embroidery_quantity
        //   _embroidery_price
        //     _requestedGiftWrap: 
        //     _gift_note: 
        //     _Timestamp
        //     _Parent Timestamp
        //  _Label
        //  _Custom Label

        var settings_properties = ['_embroidery_quantity', '_embroidery_price', '_requestedGiftwrap', '_gift_note', '_Timestamp', '_Parent Timestamp','_Label','_Custom Label'];
        var settings = {};

        for (var i = 0; i < data.items.length; i++) {
          for (var key in data.items[i].properties) {
            if(settings_properties.includes(key)){
              settings[key] = data.items[i].properties[key];
            }
          }
        }
        if(Object.keys(settings).length > 0){
          data.items[0].properties['_settings'] = JSON.stringify(settings);
        }

        // EMBROIDERMENT
        this.verifyEmbroideryFees(data, product);

        //hadle product-addon here
        // console.log('product-addon execution', data, product);
        //add the accesories to the cart if they are included in the array
        if (product['add_accessory'] && product['add_accessory'].length > 0) {
          // console.log('this cart contains this many accessories', product['add_accessory'].length);
          this.addProductAccessories(data, product);
        }
        
        $('body').trigger('added.ProductScreen-' + this.productId);

        
        // console.log({data})
        //remove the old item
        if (item_key) {
          await theme.cart.changeItem(item_key, 0)
        }
        
        //FREECAPSULEPROMO  
        //if this product that they're editing has an offer
        //include the offer in the properties of the new item
        const offer = searchString.get('Offer');
        if(offer){
          data.items[0].properties['Offer'] = offer;
        }

        // await theme.cart.clearCartIfHasCorporateGifts()
        theme.cart.addItemFromForm(data)
          .then(function(product) {
            this.success(product);
            if (!item_key) return;

            const url = new URL(window.location.href)
            const params = new URLSearchParams(url.search)
            params.set('item_key', product.items[0].key)
            window.history.replaceState({}, "", url.pathname + '?' + params.toString())
          }.bind(this))
          .catch(function(XMLHttpRequest) {
            this.error(XMLHttpRequest)
          }.bind(this))
          .always(function() {
            status.loading = false;
            const elm = this.$form.find('[data-add-to-cart]');
            elm.removeClass('btn--loading').addClass('loaded');
            setTimeout(() => elm.removeClass('loaded'), 1000);
          }.bind(this));

        // AXXON AXON PIXEL STUFF
        if (typeof axon === 'function') {
          var axonItem = window.axonItem;
          if(axonItem){
            axonItem.item_variant_id = product.id;
            axonItem.quantity = product.quantity;
          }
          axon('track', 'add_to_cart', 
            {
              currency: 'USD',
              value: axonItem.price * axonItem.quantity,
              items: [axonItem]
            }
            );
        }
        // END AXON PIXEL
      },

      setCustomLabels: function(product) {
        console.log('setting custom labels!');
        if (!product.properties) return

        const keys = Object.keys(product.properties).filter((el) => 
          el.includes('Standard Bundle Label') 
        || el === "Label"
        || el === "_Label"
      )
        // console.log('set custom labels here');
         keys.forEach((key, i) => {
          const isCustomize = $('.label-block').eq(i).find('.premade-labels .selectize-control .item').hasClass('user-created-tag')
          if (!isCustomize) return

          product.properties[key === '_Label' ? '_Custom Label' : `_Custom Bundle Label ${i + 1}`] = product.properties[key]
          product.properties[key] = 'customize'
        })
      },

      
      // EMBROIDERMENT
      verifyEmbroideryFees: async function(data, product) {
        
        // console.log('verifying embroidery fees');
        return;
        //if the embroidery exists and it is not empty or false
        if (!product.properties) return
        if(product.properties['Embroidery'] && product.properties['Embroidery'] !== ''){
          console.log('adding embroidery accessory');
          const accessoryData = {
              id: 41758052614229,
              quantity: 1,
            // properties: {
            //   '_accessory': true,
            //   '_addon_to': product.id
            // }
          }
          //prepend the accessory to the cart
          data.items.unshift(accessoryData);
          // data.items.push(accessoryData);
        }else{
          console.log('no embroidery to add');
        }

        return;
      },

      addProductAccessories: async function(data, product) {
        console.log('adding accessories');

        if(!product.add_accessory){
          console.log('no accessories to add');
          return;
        }
        
        var list_of_products_to_add = [];
        if (typeof product.add_accessory === 'string') {
          list_of_products_to_add = [product.add_accessory];
        } else {
          list_of_products_to_add = product.add_accessory;
        }

        for (var i = 0; i < list_of_products_to_add.length; i++) {
          // console.log('going through accessory list');
          // QUANTITYTIME
          const accessory = list_of_products_to_add[i];
          var addon_id = $(`.add-accessory[value="${accessory}"]`).data('product-id');
          var quantity = $('.addon-quantity[data-addon-id="'+addon_id+'"]').val() || 1;
          if (quantity < 1) {
            quantity = 1;
          }else if (quantity > 10) {
            quantity = 10;
          }
          
          const accessoryData = {
            id: accessory,
            quantity: quantity,
            properties: {
              '_accessory': true,
              '_addon_to': product.id
            }
          }
          //prepend the accessory to the cart
          data.items.unshift(accessoryData);
          // data.items.push(accessoryData);
        }
      },
    
      // TIMESTAMPREMOVAL
      addShadowProducts: async function(data, product) {
        return; 
        console.log('updating shadow products addshadowproducts()');
        const $container = $('.product-section')
        const hashName = $('[data-cpsl_cnt]', $container).attr('data-hash_name')
        if (hashes_for_skipping_shadow_products.includes(hashName)) return

        const capsuleCount = Number($('[data-cpsl_cnt]', $container).attr('data-cpsl_cnt'))
        const tilesCount = Number($('[data-cpsl_cnt]', $container).attr('data-tile_cnt'))
        const presetLabels = $('[data-cpsl_cnt]', $container).attr('data-labels').split(',')
        const presetSizes = $('[data-cpsl_cnt]', $container).attr('data-sizes').split(',')
        const color = $('[name="Color"]:checked', $container).val()
        const presetColors = $('[data-cpsl_cnt]', $container).attr('data-preset-colors').split(',')
        const count = tilesCount || capsuleCount
        const cartItems = theme.cart.data.items
        const existingInCart = cartItems.find((item) => {
          const defaultProps = { Timestamp: ""}
          const itemProps = JSON.stringify({...item.properties, ...defaultProps})
          const productProps = JSON.stringify({...product.properties, ...defaultProps})
          return  Number(product.id) === Number(item.id) && itemProps === productProps
        })

        product.properties ||= {}
        product.properties['Timestamp'] = existingInCart?.properties?.Timestamp || new Date().getTime()
        if (!count) return

        const items = data.items
        for (var i = 1; i <= count; i++) {
          const isPresetLabels = presetLabels.length && presetLabels[0]
          const curPresetColor = presetColors.length && presetColors[0] ? presetColors[i - 1] : false
          properties = {
            'Product': hashName,
            'Color': curPresetColor || color || product.properties[`Bundle Color ${i}`],
            'Label': isPresetLabels ? presetLabels[i - 1].trim() : product.properties[`Standard Bundle Label ${i}`] || product.properties[`Label`],
            'Custom Label': isPresetLabels ? "" : product.properties[`Custom Bundle Label ${i}`] || product.properties[`Custom Label`],
            'Parent Timestamp': product.properties['Timestamp']
          }
          const size = this.getOptionSize(presetSizes[i - 1])
          const type = this.getTypeShadowProduct(capsuleCount, product)
          const shadowProductId = getShadowProduct(type, properties['Color'], size)?.id
          const shadowProductSku = getShadowProduct(type, properties['Color'], size)?.sku
          const item = {id: shadowProductId, quantity: Number(product.quantity), properties}
          const existingItem = existingShadowProductItem(item, items)
          if (existingItem)
            existingItem.quantity += Number(product.quantity)
          else 
            items.push(item)
        }
        items.forEach((el) => el.properties && el.properties['Parent Timestamp'] === product.properties['Timestamp'] && (el.properties['Quantity'] = el.quantity / product.quantity))
      },

      

      getTypeShadowProduct: function (capsuleCount, product) {
        if ($('.template-product [data-product-handle]').eq(0).data('product-handle').includes('flex-tile')) return 'flex_tile'
        return capsuleCount ? 'capsule' : 'tile'
      },

      getOptionSize: function (presetSizes) {
        if ($('.template-product [data-product-handle]').eq(0).data('product-handle').includes('the-132-set-of-7')) return 'medium'
        const sizeName = $('.size-select-expand input:checked').val()?.toLowerCase()
        return sizeBySizeName[sizeName] || presetSizes?.toLowerCase() || defaulf_size.toLowerCase()
      },

      addGiftCartWithProduct: function(data, product) {
        const giftCard = $('.product-gift-card-variants .selectize-input > div');
        const giftNote = $('.gift-card-with-product textarea').val();
        const giftCardId = Number(giftCard?.data('id'))
        const quantity = $('[name="quantity"]').val()
        if (giftCardId) {
          if (!data.items[0].properties) data.items[0].properties = {}
          if (!data.items[0].properties['Timestamp']) data.items[0].properties['Timestamp'] = new Date().getTime()
          data.items.push(
            {
              id: giftCardId,
              properties: {
                'Gift Note': giftNote,
                'Parent Timestamp': product.properties['Timestamp']
              },
              quantity,
            }
          )
        }
      },

      success: function(product) {
        this.$form.find('.errors').remove();
        $('body').trigger('added.ajaxProduct');
        document.dispatchEvent(new CustomEvent('added:ajaxProduct', {
          detail: {
            product: product
          }
        }));
      },

      error: function(XMLHttpRequest) {
        this.$form.find('.errors').remove();

        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          console.warn(XMLHttpRequest.responseJSON.description);

          $('body').trigger('error.ProductScreen-' + this.productId);

          document.dispatchEvent(new CustomEvent('error:ajaxProduct', {
            detail: {
              errorMessage: XMLHttpRequest.responseJSON.description
            }
          }));

          this.$form.prepend('<div class="errors text-center">' + XMLHttpRequest.responseJSON.description + '</div>');
        }
      }
    });

    return ProductForm;
  })();

  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  theme.collapsibles = (function() {

    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner',
      tabs: '.collapsible-trigger--tab'
    };

    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };

    var namespace = '.collapsible';

    var isTransitioning = false;

    function init() {
      $(selectors.trigger).each(function() {
        var $el = $(this);
        var state = $el.hasClass(classes.open);
        $el.attr('aria-expanded', state);
      });

      $('body')
        .off(namespace)
        .on('click' + namespace, selectors.trigger, function() {
        if (isTransitioning) {
          return;
        }

        isTransitioning = true;

        var $el = $(this);
        var isOpen = $el.hasClass(classes.open);
        var isTab = $el.hasClass(classes.tabs);
        var moduleId = $el.attr('aria-controls');
        var $module = $('#' + moduleId);
        var height = $module.find(selectors.moduleInner).outerHeight();
        var isAutoHeight = $el.hasClass(classes.autoHeight);

        if (isTab) {
          if (isOpen) {
            isTransitioning = false;
            return;
          }

          var $newModule;
          // If tab, close all other tabs with same ID before opening
          $(selectors.tabs + '[data-id=' + $el.data('id') + ']').each(function() {
            $(this).removeClass(classes.open);
            $newModule = $('#' + $(this).attr('aria-controls'));
            setTransitionHeight($newModule, 0, true);
          });
        }

        // If isAutoHeight, set the height to 0 just after setting the actual height
        // so the closing animation works nicely
        if (isOpen && isAutoHeight) {
          setTimeout(function() {
            height = 0;
            setTransitionHeight($module, height, isOpen, isAutoHeight);
          }, 0);
        }

        if (isOpen && !isAutoHeight) {
          height = 0;
        }

        $el
          .attr('aria-expanded', !isOpen)
          .toggleClass(classes.open, !isOpen);

        setTransitionHeight($module, height, isOpen, isAutoHeight);
      });
    }

    function setTransitionHeight($module, height, isOpen, isAutoHeight) {
      $module
        .removeClass(classes.hide)
        .prepareTransition()
        .css('height', height)
        .toggleClass(classes.open, !isOpen);

      if (!isOpen && isAutoHeight) {
        var o = $module;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 0);
      } else {
        isTransitioning = false;
      }
    }

    return {
      init: init
    };
  })();

  theme.headerNav = (function() {

    var selectors = {
      wrapper: '.header-wrapper',
      siteHeader: '.site-header',
      logoContainer: '.site-header__logo',
      logo: '.site-header__logo img',
      navigation: '.site-navigation',
      navContainerWithLogo: '.header-item--logo',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level',
      thumbMenu: '.site-nav__thumb-menu'
    };

    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused',
      stickyCartActive: 'body--sticky-cart-open',
      overlayEnabledClass: 'header-wrapper--overlay',
      overlayedClass: 'is-light',
      thumbMenuInactive: 'site-nav__thumb-menu--inactive',
      stickyClass: 'site-header--sticky',
      overlayStickyClass: 'header-wrapper--sticky',
      openTransitionClass: 'site-header--opening'
    };

    var config = {
      namespace: '.siteNav',
      overlayHeader: false,
      stickyActive: false,
      forceStickyOnMobile: false,
      forceCloseThumbNav: false
    };

    // Elements used in resize functions, defined in init
    var $window;
    var $navContainerWithLogo;
    var $logoContainer;
    var $nav;
    var $wrapper;
    var $siteHeader;

    function init() {
      $window = $(window);
      $navContainerWithLogo = $(selectors.navContainerWithLogo);
      $logoContainer = $(selectors.logoContainer);
      $nav = $(selectors.navigation);
      $wrapper = $(selectors.wrapper);
      $siteHeader = $(selectors.siteHeader);

      config.overlayHeader = theme.settings.overlayHeader = $siteHeader.data('overlay');

      accessibleDropdowns();
      var searchModal = new theme.Modals('SearchModal', 'search-modal', {
        closeOffContentClick: false,
        focusOnOpen: '#SearchModalInput'
      });

      // One listener for all header-related resize and load functions
      $window
        .on('resize' + config.namespace, $.debounce(150, headerResize))
        .on('load' + config.namespace, headerLoad);

      // Determine type of header:
        // desktop: sticky bar | sticky button | top only
        // mobile: always sticky button
      setHeaderStyle();

      // Sticky menu (bar or thumb) on scroll
      $window.on('scroll' + config.namespace, $.throttle(150, stickyMenuOnScroll));

      // Make sure sticky nav appears after header is reloaded in editor
      if (Shopify.designMode) {
        $window.trigger('resize');
      }
    }

    function headerLoad() {
      resizeLogo();
      initStickyThumbMenu();

      if (config.headerStyle === 'bar') {
        initStickyBarMenu();
      }
    }

    function headerResize() {
      resizeLogo();
      setHeaderStyle();

      if (config.headerStyle === 'bar') {
        initStickyBarMenu();
      }
    }

    function setHeaderStyle() {
      if (theme.config.bpSmall) {
        config.headerStyle = 'button';
      } else {
        config.headerStyle = $wrapper.data('header-style');
      }

      config.stickyThreshold = config.headerStyle === 'button' ? 100 : 250;

      if (config.headerStyle !== 'button') {
        toggleThumbMenu(false);
      }
    }

    function unload() {
      $(window).off(config.namespace);
      $(selectors.navLinks).off(config.namespace);
      $(selectors.navDropdownLinks).off(config.namespace);
    }

    function resizeLogo() {
      // Using .each() because of possible reversed color logo
      $(selectors.logo).each(function() {
        var $el = $(this),
            logoWidthOnScreen = $el.width(),
            containerWidth = $el.closest('.grid__item').width();
        // If image exceeds container, let's make it smaller
        if (logoWidthOnScreen > containerWidth) {
          $el.css('maxWidth', containerWidth);
        }
        else {
          $el.removeAttr('style');
        }
      });
    }

    function accessibleDropdowns() {
      var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
      var closeOnClickActive = false;

      // Touch devices open dropdown on first click, navigate to link on second
      if (theme.config.isTouch) {
        $(selectors.navLinksWithDropdown).on('touchend' + config.namespace, function(evt) {
          var $el = $(this);
          var $parentItem = $el.parent();
          if (!$parentItem.hasClass(classes.dropdownActive)) {
            evt.preventDefault();
            closeDropdowns();
            openFirstLevelDropdown($el);
          } else {
            window.location.replace($el.attr('href'));
          }
        });

        $(selectors.navDropdownLinks).on('touchend' + config.namespace, function(evt) {
          var $el = $(this);
          var $parentItem = $el.parent();

          // Open third level menu or go to link based on active state
          if ($parentItem.hasClass(classes.hasSubDropdownClass)) {
            if (!$parentItem.hasClass(classes.dropdownActive)) {
              evt.preventDefault();
              closeThirdLevelDropdown();
              openSecondLevelDropdown($el);
            } else {
              window.location.replace($el.attr('href'));
            }
          } else {
            // No third level nav, go to link
            window.location.replace($el.attr('href'));
          }
        });
      }

      // Open/hide top level dropdowns
      $(selectors.navLinks).on('focusin mouseover' + config.namespace, function() {
        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }

        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }

        openFirstLevelDropdown($(this));
      });

      // Force remove focus on sitenav links because focus sometimes gets stuck
      $(selectors.navLinks).on('mouseleave' + config.namespace, function() {
        closeDropdowns();
      });

      // Open/hide sub level dropdowns
      $(selectors.navDropdownLinks).on('focusin' + config.namespace, function() {
        closeThirdLevelDropdown();
        openSecondLevelDropdown($(this), true);
      });

      // Private dropdown methods
      function openFirstLevelDropdown($el) {
        var $parentItem = $el.parent();
        if ($parentItem.hasClass(classes.hasDropdownClass)) {
          $parentItem.addClass(classes.dropdownActive);
          hasActiveDropdown = true;
        }

        if (!theme.config.isTouch) {
          if (!closeOnClickActive) {
            var eventType = theme.config.isTouch ? 'touchend' : 'click';
            closeOnClickActive = true;
            $('body').on(eventType + config.namespace, function() {
              closeDropdowns();
              $('body').off(config.namespace);
              closeOnClickActive = false;
            });
          }
        }
      }

      function openSecondLevelDropdown($el, skipCheck) {
        var $parentItem = $el.parent();
        if ($parentItem.hasClass(classes.hasSubDropdownClass) || skipCheck) {
          $parentItem.addClass(classes.dropdownActive);
          hasActiveSubDropdown = true;
        }
      }

      function closeDropdowns() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      }

      function closeSecondLevelDropdown() {
        $(selectors.navItems).removeClass(classes.dropdownActive);
      }

      function closeThirdLevelDropdown() {
        $(selectors.navDropdownLinks).parent().removeClass(classes.dropdownActive);
      }
    }

    function initStickyBarMenu() {
      $siteHeader.wrap('<div class="site-header-sticky"></div>');

      // No need to set a height on wrapper if positioned absolutely already
      if (config.overlayHeader) {
        return;
      }

      stickyHeaderHeight();
      setTimeout(function() {
        stickyHeaderHeight();

        // Don't let height get stuck on 0
        if ($('.site-header-sticky').outerHeight() === 0) {
          setTimeout(function() {
            $window.trigger('resize');
          }, 500);
        }
      }, 200);

      $window.on('resize' + config.namespace, $.debounce(50, stickyHeaderHeight));
    }

    function stickyHeaderHeight() {
      $('.site-header-sticky').css('height', $siteHeader.outerHeight(true));
    }

    function initStickyThumbMenu() {
      if ($('body').hasClass(classes.stickyCartActive)) {
        return;
      }

      if (theme.config.bpSmall && theme.template !== 'product') {
        setTimeout(function() {
          config.forceStickyOnMobile = true;
          toggleThumbMenu(true);
        }, 25);
      }
    }

    function stickyMenuOnScroll(evt) {
      var scroll = $window.scrollTop();

      if (scroll > config.stickyThreshold) {
        if (config.forceStickyOnMobile) {
          config.forceStickyOnMobile = false;
        }

        if (config.stickyActive) {
          return;
        }

        if (config.headerStyle === 'button') {
          toggleThumbMenu(true);
        } else if (config.headerStyle === 'bar') {
          toggleBarMenu(true);
        }
      } else {
        // If menu is shown on mobile page load, do not
        // automatically hide it when you start scrolling
        if (config.forceStickyOnMobile) {
          return;
        }

        if (!config.stickyActive) {
          return;
        }

        if (config.headerStyle === 'button') {
          if (!theme.config.bpSmall) {
            toggleThumbMenu(false);
          }
        } else if (config.headerStyle === 'bar') {
          toggleBarMenu(false);
        }
      }
    }

    function toggleThumbMenu(active, forceClose) {
      // If forced close, will not open again until page refreshes
      // because sticky nav is open
      if (config.forceCloseThumbNav) {
        return;
      }

      // If thumb menu is open, do not hide menu button
      if ($('.slide-nav__overflow--thumb').hasClass('js-menu--is-open')) {
        return;
      }

      $(selectors.thumbMenu).toggleClass(classes.thumbMenuInactive, !active);
      config.stickyActive = active;

      config.forceCloseThumbNav = forceClose;
    }

    function toggleBarMenu(active) {
      if (config.headerStyle !== 'bar') {
        return;
      }

      if (active) {
        $siteHeader.addClass(classes.stickyClass);
        if (config.overlayHeader) {
          $wrapper
            .removeClass(classes.overlayedClass)
            .addClass(classes.overlayStickyClass);
        }

        // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly
        setTimeout(function() {
          $siteHeader.addClass(classes.openTransitionClass);
        }, 100);
      } else {
        $siteHeader.removeClass(classes.openTransitionClass).removeClass(classes.stickyClass);

        if (config.overlayHeader) {
          $wrapper
            .addClass(classes.overlayedClass)
            .removeClass(classes.overlayStickyClass);
        }
      }

      config.stickyActive = active;
    }

    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      $(selectors.wrapper)
        .removeClass(classes.overlayEnabledClass)
        .removeClass(classes.overlayedClass);
    }

    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader,
      toggleThumbMenu: toggleThumbMenu,
      unload: unload
    };
  })();

  theme.slideNav = (function() {

    var selectors = {
      container: '#PageContainer',
      navWrapper: '.slide-nav__overflow',
      nav: '#SlideNav',
      toggleBtn: '.js-toggle-slide-nav',
      subNavToggleBtn: '.js-toggle-submenu',
      thumbNavToggle: '.site-nav__thumb-button'
    };

    var classes = {
      subNavLink: 'slide-nav__sublist-link',
      return: 'slide-nav__return-btn',
      isActive: 'is-active',
      isOpen: 'js-menu--is-open',
      subNavShowing: 'sub-nav--is-open',
      thirdNavShowing: 'third-nav--is-open'
    };

    var namespace = '.slideNav';

    var isTransitioning;
    var $activeSubNav;
    var $activeTrigger;
    var pageSlide = true;
    var menuLevel = 1;

    function init() {
      if ($(selectors.thumbNavToggle).length) {
        pageSlide = false;
      }

      $(selectors.toggleBtn).on('click' + namespace, toggleNav);
      $(selectors.subNavToggleBtn).on('click' + namespace, toggleSubNav);
    }

    function toggleNav() {
      if ($(selectors.toggleBtn).hasClass(classes.isActive)) {
        closeNav();
      } else {
        openNav();
      }
    }

    function openNav() {
      $(selectors.toggleBtn).addClass(classes.isActive);

      $(selectors.navWrapper).prepareTransition().addClass(classes.isOpen);

      if (pageSlide) {
        $(selectors.container).css({
          transform:
            'translate3d(0, ' + $(selectors.navWrapper).height() + 'px, 0)'
        });
      }

      $(selectors.navWrapper).attr('tabindex', '-1').focus();

      // close on escape
      $(window).on('keyup' + namespace, function(evt) {
        if (evt.which === 27) {
          closeNav();
        }
      });
    }

    function closeNav() {
      $(selectors.toggleBtn).removeClass(classes.isActive);
      $(selectors.navWrapper).prepareTransition().removeClass(classes.isOpen);

      if (pageSlide) {
        $(selectors.container).removeAttr('style');
      }

      $(selectors.toggleBtn).focus();

      $(window).off('keyup' + namespace);
    }

    function toggleSubNav(evt) {
      if (isTransitioning) {
        return;
      }

      var $toggleBtn = $(evt.currentTarget);
      var isReturn = $toggleBtn.hasClass(classes.return);
      isTransitioning = true;

      if (isReturn) {
        // Close all subnavs by removing active class on buttons
        $(
          classes.toggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
        ).removeClass(classes.isActive);
        $('.slide-nav__dropdown[data-level="' + (menuLevel) + '"]').prepareTransition().removeClass(classes.isActive);

        if ($activeTrigger && $activeTrigger.length) {
          $activeTrigger.removeClass(classes.isActive);
        }
      } else {
        $toggleBtn.addClass(classes.isActive);
        $toggleBtn.next('.slide-nav__dropdown').prepareTransition().addClass(classes.isActive);
      }

      $activeTrigger = $toggleBtn;

      goToSubnav($toggleBtn.data('target'));
    }

    function goToSubnav(target) {
      var $targetMenu = target
        ? $('.slide-nav__dropdown[data-parent="' + target + '"]')
        : $(selectors.nav);

      menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

      $activeSubNav = $targetMenu;

      var $elementToFocus = target
        ? $targetMenu.find('.' + classes.subNavLink + ':first')
        : $activeTrigger;

      var translateMenuHeight = $targetMenu.outerHeight();

      var openNavClass =
        menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

      $(selectors.navWrapper)
        .css('height', translateMenuHeight)
        .removeClass(classes.thirdNavShowing)
        .addClass(openNavClass);

      if (!target) {
        // Show top level nav
        $(selectors.navWrapper)
          .removeClass(classes.thirdNavShowing)
          .removeClass(classes.subNavShowing);
      }

      isTransitioning = false;

      // Match height of subnav
      if (pageSlide) {
        $(selectors.container).css({
          transform: 'translate3d(0, ' + translateMenuHeight + 'px, 0)'
        });
      }
    }

    function unload() {
      $(window).off(namespace);
      $(selectors.toggleBtn).off(namespace);
      $(selectors.subNavToggleBtn).off(namespace);
    }

    return {
      init: init,
      unload: unload
    };
  })();

  theme.articleImages = (function() {

    var cache = {};

    function init() {
      cache.$rteImages = $('.rte--indented-images');

      if (!cache.$rteImages.length) {
        return;
      }

      $(window).on('load', setImages);
    }

    function setImages() {
      cache.$rteImages.find('img').each(function() {
        var $el = $(this);
        var attr = $el.attr('style');

        // Check if undefined or float: none
        if (!attr || attr == 'float: none;') {
          // Remove grid-breaking styles if image isn't wider than parent
          if ($el.width() < cache.$rteImages.width()) {
            $el.addClass('rte__no-indent');
          }
        }
      });
    }

    return {
      init: init
    };
  })();

  theme.Slideshow = (function() {
    this.$slideshow = null;

    var classes = {
      next: 'is-next',
      init: 'is-init',
      wrapper: 'slideshow-wrapper',
      slideshow: 'slideshow',
      currentSlide: 'slick-current',
      pauseButton: 'slideshow__pause',
      isPaused: 'is-paused'
    };

    function slideshow(el, args) {
      this.$slideshow = $(el);
      this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
      this.$pause = this.$wrapper.find('.' + classes.pauseButton);

      this.settings = {
        accessibility: true,
        arrows: args.arrows ? true : false,
        dots: args.dots ? true : false,
        draggable: true,
        touchThreshold: 8,
        speed: 300,
        pauseOnHover: args.pauseOnHover ? true : false,
        autoplay: this.$slideshow.data('autoplay'),
        autoplaySpeed: this.$slideshow.data('speed')
      };

      this.$slideshow.on('init', this.init.bind(this));

      // Refresh main page slideshow
      if ($('.root').find(this.$slideshow).length) {
        $('body').on('productModalClose', function() {
          this.$slideshow.addClass('slideshow-refresh');
          this.$slideshow.slick('refresh');
        }.bind(this));
      }

      this.$slideshow.slick(this.settings);

      this.$pause.on('click', this._togglePause.bind(this));
    }

    slideshow.prototype = $.extend({}, slideshow.prototype, {
      init: function(event, obj) {
        this.$slideshowList = obj.$list;
        this.$slickDots = obj.$dots;
        this.$allSlides = obj.$slides;
        this.slideCount = obj.slideCount;

        this.$slideshow.addClass(classes.init);
        this._a11y();
        this._clonedLazyloading();
      },
      destroy: function() {
        this.$slideshow.slick('unslick');
      },

      // Playback
      _play: function() {
        this.$slideshow.slick('slickPause');
        $(classes.pauseButton).addClass('is-paused');
      },
      _pause: function() {
        this.$slideshow.slick('slickPlay');
        $(classes.pauseButton).removeClass('is-paused');
      },
      _togglePause: function() {
        var slideshowSelector = this._getSlideshowId(this.$pause);
        if (this.$pause.hasClass(classes.isPaused)) {
          this.$pause.removeClass(classes.isPaused);
          $(slideshowSelector).slick('slickPlay');
        } else {
          this.$pause.addClass(classes.isPaused);
          $(slideshowSelector).slick('slickPause');
        }
      },

      // Helpers
      _getSlideshowId: function($el) {
        return '#Slideshow-' + $el.data('id');
      },
      _activeSlide: function() {
        return this.$slideshow.find('.slick-active');
      },
      _currentSlide: function() {
        return this.$slideshow.find('.slick-current');
      },
      _nextSlide: function(index) {
        return this.$slideshow.find('.slideshow__slide[data-slick-index="' + index + '"]');
      },

      // a11y fixes
      _a11y: function() {
        var $list = this.$slideshowList;
        var autoplay = this.settings.autoplay;

        if (!$list) {
          return;
        }

        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');

        // When an element in the slider is focused
        // pause slideshow and set aria-live
        $(classes.wrapper).on('focusin', function(evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }

          $list.attr('aria-live', 'polite');
          if (autoplay) {
            this._pause();
          }
        }.bind(this));

        // Resume autoplay
        $(classes.wrapper).on('focusout', function(evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }

          $list.removeAttr('aria-live');
          if (autoplay) {
            this._play();
          }
        }.bind(this));
      },

      // Make sure lazyloading works on cloned slides
      _clonedLazyloading: function() {
        var $slideshow = this.$slideshow;

        $slideshow.find('.slick-slide').each(function(index, el) {
          var $slide = $(el);
          if ($slide.hasClass('slick-cloned')) {
            var slideId = $slide.data('id');
            var $slideImg = $slide.find('.hero__image').removeClass('lazyloading').addClass('lazyloaded');

            // Get inline style attribute from non-cloned slide with arbitrary timeout
            // so the image is loaded
            setTimeout(function() {
              var loadedImageStyle = $slideshow.find('.slideshow__slide--' + slideId + ':not(.slick-cloned) .hero__image').attr('style');

              if (loadedImageStyle) {
                $slideImg.attr('style', loadedImageStyle);
              }

            }, this.settings.autoplaySpeed / 1.5);

          }
        }.bind(this));
      }
    });

    return slideshow;
  })();

  // Modals init
  new theme.Modals('info-msg-modal', 'info-msg-modal');
  new theme.Modals('pre-order-modal', 'pre-order-modal');
  new theme.Modals('araki-pre-order-modal', 'araki-pre-order-modal');
  new theme.Modals('cant-place-order', 'cant-place-order');
  new theme.Modals('moq-error', 'moq-error');
  new theme.Modals('moq-error-color', 'moq-error-color');
  new theme.Modals('save-order', 'save-order');
  new theme.Modals('add-gift-note-modal', 'add-gift-note-modal');
  new theme.Modals('bas-confirm-modal', 'bas-confirm-modal');
  new theme.Modals('bas-save-selections-modal', 'bas-save-selections-modal');
  new theme.Modals('bas-recommended-bundles', 'bas-recommended-bundles');
  new theme.Modals('bas-table-preview', 'bas-table-preview');
  new theme.Modals('bas-color-filter', 'bas-color-filter');

  theme.currencySwitcher = (function() {

    var selectors = {
      dataDiv: '#CurrencyData',
      currencyOptions: '.currency-options__btn',
      pickerFlag: '#CurrencyFlag',
      pickerLabel: '#CurrencyLabel'
    };

    var data = {};
    var modal;

    function init() {
      var $dataDiv = $(selectors.dataDiv);

      if (!$dataDiv.length) {
        return;
      }

      modal = new theme.Modals('CurrencyModal', 'currency-modal', {
        closeOffContentClick: false
      });

      $(selectors.currencyOptions).on('click', setNewCurrency);

      data = {
        currency: $dataDiv.data('shop-currency'),
        format: $dataDiv.data('format'),
        moneyFormat: $dataDiv.data('money-format'),
        moneyCurrencyFormat: $dataDiv.data('money-currency-format')
      };

      if (!theme.settings.nativeMultiCurrency) {
        Currency.format = data.format;

        // Rely on the shop's currency format, not Shopify defaults (in case merchant changes it)
        Currency.money_format[data.currency] = data.moneyFormat;
        Currency.money_with_currency_format[data.currency] = data.moneyCurrencyFormat;

        // Fix for customer account page
        $('span.money span.money').each(function() {
          $(this).parents('span.money').removeClass('money');
        });

        // Save current price
        $('span.money').each(function() {
          $(this).attr('data-currency-' + data.currency, $(this).html());
        });

        checkCookie();
      }
    }

    function setNewCurrency() {
      var newCurrency = $(this).data('value');

      if (theme.settings.nativeMultiCurrency) {
        $(this).addClass('is-active');
        theme.cart.updateCurrency(newCurrency);
        return;
      }

      if (newCurrency !== data.currency) {
        data.currency = newCurrency;
        $(selectors.dataDiv).data('current-currency', newCurrency);
        updatePicker(newCurrency);

        refresh();
      }

      modal.close();
    }

    function updatePicker(currency) {
      $(selectors.pickerFlag).attr('data-flag', currency);
      $(selectors.pickerLabel).text(currency);

      // Update modal options active states
      $(selectors.currencyOptions).removeClass('is-active');
      $(selectors.currencyOptions + '[data-value=' + currency + ']').addClass('is-active');
    }

    // Refresh functions only needed when not using native multi-currency
    function refresh() {
      if (theme.settings.nativeMultiCurrency) {
        return;
      }

      var newCurrency = $(selectors.dataDiv).data('current-currency');
      Currency.convertAll(Currency.currentCurrency, newCurrency);
    }

    function ajaxrefresh() {
      if (theme.settings.nativeMultiCurrency) {
        return;
      }

      var shopCurrency = $(selectors.dataDiv).data('shop-currency');
      var newCurrency = $(selectors.dataDiv).data('current-currency');
      // Ajax cart always returns shop's currency, not what theme settings defines
      Currency.convertAll(shopCurrency, newCurrency);
    }

    function checkCookie() {
      var cookieCurrency = Currency.cookie.read();

      if (cookieCurrency == null) {
        Currency.currentCurrency = cookieCurrency = data.currency;
      } else if ($(selectors.currencyOptions).length && $(selectors.currencyOptions + '[data-value=' + cookieCurrency + ']').length === 0) {
        // If the cookie value does not correspond to any value in the currency dropdown
        Currency.currentCurrency = data.currency;
        Currency.cookie.write(data.currency);
      } else if (cookieCurrency === data.currency) {
        Currency.currentCurrency = data.currency;
      } else {
        Currency.convertAll(data.currency, cookieCurrency);
      }

      // Update current currency with cookie value
      $(selectors.dataDiv).data('current-currency', cookieCurrency);
      data.currency = cookieCurrency;
      updatePicker(cookieCurrency);
    }

    return {
      init: init,
      refresh: refresh,
      ajaxrefresh: ajaxrefresh
    };
  })();

  /*
    Quick shop modals, or product screens, live inside
    product-grid-item markup until page load, where they're
    moved to #ProductScreens at the bottom of the page
   */

  theme.QuickShopScreens = (function() {

    var startingUrl = window.location.pathname;
    var currentPath = startingUrl;
    var prevPath = null;
    var currentScreen = null;
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    var selectors = {
      screensWrap: '#ProductScreens',
      screens: '[data-product-id]',
      trigger: '.quick-product__btn'
    };

    var activeIds = [];

    function init(container) {
      if (!theme.settings.quickView) {
        return;
      }

      var productIds = getProductIds();
      initProductScreens(productIds);
      initHistoryWatcher();
    }

    function initHistoryWatcher() {
      // No need to adjust URL in the editor since it handles the navigation
      if (Shopify.designMode) {
        return;
      }

      // Listen for product screens opening
      $(window).on('newPopstate', function(evt, data) {
        currentScreen = data.screen;
        // Manually trigger back, comes from esc key or close btns
        if (data.back) {
          prevPath = location.pathname;
          currentPath = startingUrl;
          history.pushState({}, '', startingUrl);
        }

        if (data.url) {
          if (data.updateCurrentPath) {
            prevPath = location.pathname;
            currentPath = data.url;
            history.pushState({}, '', data.url);
          }
        }
      });

      $(window).on('popstate', function(evt) {
        var goToUrl = false;
        prevPath = currentPath;

        // Hash change or no change, let browser take over
        if (location.pathname === currentPath) {
          return;
        }

        prevPath = currentPath;
        currentPath = location.pathname;

        // Back to where we started. Close existing screen if open
        if (location.pathname === startingUrl) {
          if (currentScreen && currentScreen.isOpen) {
            closeScreen(currentScreen);
          }
          return;
        }

        // Opening product
        if (location.pathname.indexOf('/products/') !== -1) {
          if (currentScreen) {
            currentScreen.open();
          } else {
            // No screen sent to function, trigger new click
            $('.quick-product__btn[href="'+ location.pathname +'"]').first().trigger('click', { updateCurrentPath: false });
          }

          return;
        }

        if (evt.originalEvent.state) {
          if (currentScreen && currentScreen.isOpen) {
            closeScreen(currentScreen);
            history.replaceState({}, '', startingUrl);
            return;
          }

          goToUrl = true;
        } else {
          if (currentScreen) {
            if (currentScreen.isOpen) {
              closeScreen(currentScreen);
              return;
            }
          } else {
            // No state/modal. Navigate to where browser wants
            goToUrl = true;
          }
        }

        // Fallback if none of our conditions are met
        if (goToUrl) {
          window.location.href = location.href;
        }
      }.bind(this));
    }

    function closeScreen(screen) {
      screen.close();
      currentScreen = null;
      $(window).trigger('resize');
    }

    function getProductIds($scope) {
      var ids = [];

      var $triggers = $scope ? $(selectors.trigger, $scope) : $(selectors.trigger);

      $triggers.each(function() {
        var id = $(this).data('product-id');

        // If another identical modal exists, remove from DOM
        if (ids.indexOf(id) > -1) {
          $('.screen-layer--product[data-product-id="' + id + '"]').slice(1).remove();
          return;
        }

        ids.push(id);
      });

      return ids;
    }

    function getIdsFromTriggers($triggers) {
      var ids = [];

      $triggers.each(function() {
        var id = $(this).data('product-id');
        ids.push(id);
      });

      return ids;
    }

    function initProductScreens(ids) {
      var screenId;
      var $screenLayer;
      var screens = [];

      // Init screens if they're not duplicates
      for (var i = 0; i < ids.length; i++) {
        if (activeIds.indexOf(ids[i]) === -1) {
          screenId = 'ProductScreen-' + ids[i];
          $screenLayer = $('#' + screenId);

          screens.push($screenLayer);
          activeIds.push(ids[i]);
          new theme.ProductScreen(screenId, 'product-' + ids[i]);
        }
      }

      // Append screens to bottom of page
      $(selectors.screensWrap).append(screens);
    }

    // Section unloaded in theme editor.
    // Check if product exists in any other area
    // of the page, remove other's section.instance
    function unload($container) {
      if (!theme.settings.quickView) {
        return;
      }

      var removeIds = [];
      var productIds = getProductIds($container);

      // Get ids from buttons not in removed section
      var $activeButtons = $(selectors.trigger).not($(selectors.trigger, $container));
      var stillActiveIds = getIdsFromTriggers($activeButtons);

      // If ID exists on active button, do not add to IDs to remove
      for (var i = 0; i < productIds.length; i++) {
        var id = productIds[i];
        if (stillActiveIds.indexOf(id) === -1) {
          removeIds.push(id);
        }
      }

      for (var i = 0; i < removeIds.length; i++) {
        sections._removeInstance(removeIds[i]);
      }
    }

    // Section container is sent, so must re-scrape for product IDs
    function reInit($container) {
      if (!theme.settings.quickView) {
        return;
      }

      var newProductIds = getProductIds($container);
      initProductScreens(newProductIds);
      removeDuplicateModals(newProductIds, $container);

      // Re-register product templates in quick view modals.
      // Will not double-register.
      sections.register('product-template', theme.Product, $('#ProductScreens'));
    }

    function removeDuplicateModals(ids, $container) {
      for (var i = 0; i < ids.length; i++) {
        $('.screen-layer--product[data-product-id="' + ids[i] + '"]', $container).remove();
      }
    }

    return {
      init: init,
      unload: unload,
      reInit: reInit
    };
  })();

  /*
    Hover to enable slideshow of product images.
    On mobile slideshow starts as item is in view.
    Destroy on mouseout/out of view.
   */

  theme.HoverProductGrid = (function() {
    var selectors = {
      product: '.grid-product',
      slider: '.product-slider',
    };

    function HoverProductGrid($container) {
      this.$container = $container;
      this.sectionId = this.$container.attr('data-section-id');
      this.namespace = '.product-image-slider-' + this.sectionId;
      this.activeIds = [];

      if (!theme.settings.hoverProductGrid) {
        return;
      }

      this.$products = $container.find(selectors.product);
      this.slidersMobile = $container.data('product-sliders-mobile');

      // No products means no sliders
      if (this.$products.length === 0) {
        return;
      }

      slate.utils.promiseStylesheet().then(function() {
        this.init();
      }.bind(this));
    }

    HoverProductGrid.prototype = $.extend({}, HoverProductGrid.prototype, {
      init: function() {
        this.destroyAllSliders();
        this.setupEventType();
        this.listnerSetup();
      },

      setupEventType: function() {
        this.$products.off('mouseenter mouseout');
        $(window).off('scroll' + this.namespace);

        if (theme.config.bpSmall) {
          if (this.slidersMobile) {
            $(window).on('scroll' + this.namespace, $.throttle(120, this.inViewSliderInit.bind(this)));
            $(window).trigger('scroll' + this.namespace);
          }
        } else {
          this.mouseSliderInit();
        }
      },

      listnerSetup: function() {
        $('body').on('matchSmall matchLarge', function() {
          this.destroyAllSliders();
          this.setupEventType();
        }.bind(this));
      },

      inViewSliderInit: function() {
        this.$products.find(selectors.slider).each(function(i, el) {
          if(theme.isElementVisible($(el), -400)) {
            this.initSlider($(el));
          } else {
            this.destroySlider($(el));
          }
        }.bind(this));
      },

      mouseSliderInit: function() {
        this.$products.on('mouseenter', function(evt) {
          var $slider = $(evt.currentTarget).find(selectors.slider);
          this.initSlider($slider);
        }.bind(this));

        this.$products.on('mouseleave', function(evt) {
          var $slider = $(evt.currentTarget).find(selectors.slider);
          this.destroySlider($slider);
        }.bind(this));
      },

      initSlider: function($slider) {
        if ($slider.data('image-count') < 2) {
          return;
        }

        if (this.activeIds.indexOf($slider.data('id')) !== -1) {
          return;
        }

        this.activeIds.push($slider.data('id'));

        $slider
          .addClass('product-slider--init')
          .slick({
            autoplay: true,
            infinite: true,
            arrows: false,
            speed: 300,
            fade: true,
            pauseOnHover: false,
            autoplaySpeed: 1050
          });
      },

      destroySlider: function($slider) {
        if ($slider.data('image-count') < 2) {
          return;
        }

        var alreadyActive = this.activeIds.indexOf($slider.data('id'));
        if (alreadyActive !== -1) {
          this.activeIds.splice(alreadyActive, 1);
          $slider.slick('unslick');
        }
      },

      destroyAllSliders: function() {
        this.$products.find(selectors.slider).each(function(i, el) {
          this.destroySlider($(el));
        }.bind(this));
      }
    });

    return HoverProductGrid;
  })();

  theme.videoModal = function() {
    var videoModalPlayer = null;
    var videoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        branding: 0,
        cc_load_policy: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      }
    };

    var selectors = {
      triggers: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]'
    };

    if (!$(selectors.triggers).length) {
      return;
    }

    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true
    });

    $(selectors.triggers).on('click', triggerYouTubeModal);

    function triggerYouTubeModal(evt) {
      const test1 = evt.target.getAttribute('goto_youtube');
      const test2 = evt.currentTarget.getAttribute('goto_youtube');
      if (test1 || test2) return;
      evt.preventDefault();
      window.loadYouTube();

      if (theme.config.youTubeReady) {
        startVideoOnClick(evt);
      } else {
        $('body').on('youTubeReady', function() {
          startVideoOnClick(evt);
        });
      }
    }

    function startVideoOnClick(evt) {
      var $el = $(evt.target);

      // get video ID from URL
      var videoId = getYoutubeVideoId($el.attr('href'));

      var args = $.extend({}, videoOptions, {
        videoId: videoId
      });

      // Disable plays inline on mobile
      args.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;

      var videoModalPlayer = new YT.Player('VideoHolder', args);
      modal.open();

      $('body').on('modalClose.VideoModal', function() {
        // Slight timeout so it is destroyed after the modal closes
        setTimeout(function() {
          videoModalPlayer.destroy();
        }, 500); // modal close css transition
      });
    }

    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    }
  };



  theme.customerTemplates = (function() {

    function initEventListeners() {
      // Show reset password form
      $('#RecoverPassword').on('click', function(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });

      // Hide reset password form
      $('#HideRecoverPasswordLink').on('click', function(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
    }

    /**
     *
     *  Show/Hide recover password form
     *
     */
    function toggleRecoverPasswordForm() {
      $('#RecoverPasswordForm').toggleClass('hide');
      $('#CustomerLoginForm').toggleClass('hide');
    }

    /**
     *
     *  Show reset password success message
     *
     */
    function resetPasswordSuccess() {
      var $formState = $('.reset-password-success');

      // check if reset password form was successfully submitted
      if (!$formState.length) {
        return;
      }

      // show success message
      $('#ResetSuccess').removeClass('hide');
    }

    /**
     *
     *  Show/hide customer address forms
     *
     */
    function customerAddressForm() {
      var $newAddressForm = $('#AddressNewForm');
      var $addressForms = $('.js-address-form');

      if (!$newAddressForm.length || !$addressForms.length) {
        return;
      }

      if (Shopify) {
        $('.js-address-country').each(function() {
          var $container = $(this);
          var countryId = $container.data('country-id');
          var provinceId = $container.data('province-id');
          var provinceContainerId = $container.data('province-container-id');

          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }

      // Toggle new/edit address forms
      $('.address-new-toggle').on('click', function() {
        $newAddressForm.toggleClass('hide');
      });

      $('.address-edit-toggle').on('click', function() {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
      });

      $('.address-delete').on('click', function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');

        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
          Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
        }
      });
    }

    /**
     *
     *  Check URL for reset password hash
     *
     */
    function checkUrlHash() {
      var hash = window.location.hash;

      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }

    return {
      init: function() {
        checkUrlHash();
        initEventListeners();
        resetPasswordSuccess();
        customerAddressForm();
      }
    };
  })();


  theme.Product = (function() {

    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable',
      thumbActive: 'thumb--current'
    };

    var selectors = {
      variantsJson: '[data-variant-json]',
      currentVariantJson: '[data-current-variant-json]',

      imageContainer: '[data-product-images]',
      mainSlider: '[data-product-photos]',
      thumbSlider: '[data-product-thumbs]',
      photo: '[data-product-photo]',
      photoThumbs: '[data-product-thumb]',
      photoThumbItem: '[data-product-thumb-item]',

      priceWrapper: '[data-price-wrapper]',
      price: '[data-product-price]',
      comparePrice: '[data-product-price-compare]',
      priceA11y: '[data-price-a11y]',
      comparePriceA11y: '[data-compare-a11y]',
      sku: '[data-sku]',
      inventory: '[data-product-inventory]',

      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      productGiftCardSelect: '.product-gift-card-variants .selectize-input > div',

      originalSelectorId: '[data-product-select]',
      singleOptionSelector: '[data-variant-input]',
      variantColorSwatch: '[data-color-swatch]',

      embroideryCheckbox: '#embroidery-toggle',
      giftwrapCheckbox: '#giftwrap-toggle',
      //addon items with a cost that must be added to the cost of the cart
      //
      cartAddonTriggers: '.additional-addon-cost-item',
      //TODO, clean this up for this selector specifically
      
      colorDropdownSelectors: '.trigger-price-changes select.selectized[data-type="color-option"]',
      labelDropdownSelectors: '.label-block .is-custom-label',

      productImageMain: '.product-image-main',
      productVideo: '[data-product-video]',
      videoParent: '.product__video-wrapper',
      currentSlide: '.slick-current',

      modalFormHolder: '#ProductFormPlaceholder-',
      formContainer: '.product-single__form'
    };

    var youtubeReady;
    var videos = {};
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      height: '480',
      width: '850',
      playerVars :{
        autohide: 0,
        autoplay: 1,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      },
      events: {
        onReady: onVideoPlayerReady,
        onStateChange: onVideoStateChange
      }
    };

    var vimeoReady;
    var vimeoPlayers = [];
    var vimeoVideoOptions = {
      byline: false,
      title: false,
      portrait: false,
      loop: true
    };

    function onVideoPlayerReady(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target; // update stored player
      var player = youtubePlayers[playerId];

      setParentAsLoading($player);

      if (videos[playerId].style === 'muted') {
        youtubePlayers[playerId].mute().playVideo().pauseVideo();
      } else {
        setParentAsLoaded($player);
      }

      // If first slide or only photo, start video
      if ($player.closest(selectors.currentSlide).length || $player.data('image-count') === 1) {
        if (videos[playerId].style === 'muted') {
          youtubePlayers[playerId].playVideo();
          initCheckVisibility(playerId);
        }
      }
    }

    function initCheckVisibility(playerId) {
      // Add out of view pausing
      videoVisibilityCheck(playerId);
      $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
    }

    function videoVisibilityCheck(id) {
      var playerId;

      if (!id) {
        return;
      }

      if (typeof id === 'string') {
        playerId = id;
      } else {
        // Data comes in as part of the scroll event
        playerId = id.data.id;
      }

      if (theme.isElementVisible($('#' + playerId))) {
        if (videos[playerId] && videos[playerId].style === 'unmuted') {
          return;
        }
        playVisibleVideo(playerId);
      } else {
        pauseHiddenVideo(playerId);
      }
    }

    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }

    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }

    function onVideoStateChange(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];

      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }
          break;
        case 0: // ended
          player.playVideo();
          break;
        case 1: // playing
          setParentAsLoaded($player);
          break;
        case 3: // buffering
          videos[playerId].attemptedToPlay = true;
          break;
      }
    }

    function setParentAsLoading($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.loading);
    }

    function setParentAsLoaded($el) {
      $el
        .closest(selectors.videoParent)
        .removeClass(classes.loading)
        .addClass(classes.loaded);
    }

    function setVideoToBeInteractedWith($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.interactable);
    }

    function Product(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');

      this.inModal = $container.closest('.screen-layer').length;
      this.$modal;

      this.namespace = '.product-' + sectionId;
      this.namespaceImages = '.product-image-' + sectionId;

      this.settings = {
        enableHistoryState: $container.data('enable-history-state') || false,
        namespace: '.product-' + sectionId,
        variantType: $container.data('variant-type'),
        inventory: $container.data('inventory') || false,
        inventoryThreshold: $container.data('inventory-threshold') || false,
        modalInit: false,
        slickMainInitialized: false,
        slickThumbInitialized: false,
        hasImages: true,
        hasVideos: $container.find(selectors.productVideo).length || false,
        hasMultipleImages: false,
        stackedImages: $container.data('images-stacked') || false,
        stackedCurrent: 0,
        stackedImagePositions: [],
        imagesAnimating: false,
        imageSize: '620x'
      };

      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.namespace = '.product-' + sectionId + '-modal';
        this.$modal = $('#ProductScreen-' + sectionId);
      }

      this.init();
    }

    Product.prototype = $.extend({}, Product.prototype, {
      init: function() {
        this.$mainSlider = $(selectors.mainSlider, this.$container);
        this.$thumbSlider = $(selectors.thumbSlider, this.$container);
        this.$firstProductImage = this.$mainSlider.find('img').first();
        this.$formHolder = $(selectors.modalFormHolder + this.sectionId);

        if (!this.$firstProductImage.length) {
          this.settings.hasImages = false;
        }
        if (this.inModal) {
          this.$container.addClass(classes.isModal);
          $('body')
            .off('productModalOpen.ProductScreen-' + this.sectionId)
            .off('productModalClose.ProductScreen-' + this.sectionId);
          $('body').on('productModalOpen.ProductScreen-' + this.sectionId, this.openModalProduct.bind(this));
          $('body').on('productModalClose.ProductScreen-' + this.sectionId, this.closeModalProduct.bind(this));
        }

        if (!this.inModal) {
          this.stringOverrides();
          this.formSetup();
          this.preImageSetup();

          this.checkIfVideos();
          this.imageSetup(true);
        }
      },

      formSetup: function() {
        // Determine how to handle variant availability selectors
        if (theme.settings.dynamicVariantsEnable) {
          this.$variantSelectors = $(selectors.formContainer).find(selectors.singleOptionSelector);
        }

        this.initAjaxProductForm();
        this.initVariants();
      },

      preImageSetup: function() {
        this.setImageSizes();
        this.initImageSwitch();
        this.initImageZoom();
      },

      imageSetup: function(needStylesheet) {
        if (!this.$thumbSlider.length || $(selectors.photoThumbs, this.$container).length < 2) {
          // Single product image. Init video if it exists
          var $video = $(selectors.productImageMain, this.$container).find(selectors.productVideo);
          if ($video.length) {
            this.initVideo($video);
          }

          return;
        }

        this.settings.hasMultipleImages = true;

        if (needStylesheet) {
          slate.utils.promiseStylesheet().then(function() {
            this.createImageCarousels();
          }.bind(this));
        } else {
          this.createImageCarousels();
        }
      },

      initImageZoom: function() {
        var $container = $(selectors.imageContainer, this.$container);
        var imageZoom = new theme.Photoswipe($container, this.sectionId);
      },

      stringOverrides: function() {
        theme.productStrings = theme.productStrings || {};
        $.extend(theme.strings, theme.productStrings);
      },

      setImageSizes: function() {
        if (!this.settings.hasImages) {
          return;
        }

        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.$firstProductImage[0].currentSrc;

        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },

      initVariants: function() {
        var $variantJson = $(selectors.variantsJson, this.$container);
        if (!$variantJson.length) {
          return;
        }

        this.variantsObject = JSON.parse($variantJson[0].innerHTML);

        var options = {
          $container: this.$container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: selectors.singleOptionSelector,
          originalSelectorId: selectors.originalSelectorId,
          variants: this.variantsObject
        };

        if ($(selectors.variantColorSwatch, this.$container).length) {
          $(selectors.variantColorSwatch, this.$container).on('change', function(evt) {
            var $el = $(evt.currentTarget);
            var color = $el.data('color-name');
            var index = $el.data('color-index');
            this.updateColorName(color, index);
          }.bind(this));
        }

        //bind the embroideryCheckbox to force an updatecartbutton.bind(this)
        $(selectors.cartAddonTriggers, this.$container).on('change', function() {
          const evt = {variant: this.variants.currentVariant};
          this.updateCartButton(evt);
        }.bind(this));

        //bind the color dropdown selectors to also force an updatecart
        $(selectors.colorDropdownSelectors, this.$container).on('change', function() {
          const evt = {variant: this.variants.currentVariant};
          this.updateCartButton(evt);
          this.updatePrice(evt);
        }.bind(this));

        $(selectors.labelDropdownSelectors, this.$container).on('change', function() {
          console.log('LABEL DROPDOWN CHANGED!! UPDATE THE PRICING AND CART BUTTON NOW THAT IT IS BINDED!!');
          const evt = {variant: this.variants.currentVariant};
          this.updateCartButton(evt);
          this.updatePrice(evt);
        }.bind(this));


        this.variants = new slate.Variants(options);
        this.$container.on('variantChange' + this.namespace, this.updateCartButton.bind(this));
        this.$container.on('variantImageChange' + this.namespace, this.updateVariantImage.bind(this));
        this.$container.on('variantPriceChange' + this.namespace, this.updatePrice.bind(this));
        if ($(selectors.sku, this.$container).length) {
          this.$container.on('variantSKUChange' + this.namespace, this.updateSku.bind(this));
        }
        if (this.settings.inventory) {
          this.$container.on('variantChange' + this.namespace, this.updateInventory.bind(this));
        }

        // Trigger price update after page load for color dropdowns with trigger-price-changes class
        var self = this;
        setTimeout(function() {
          var $colorDropdowns = $(selectors.colorDropdownSelectors, self.$container);
          if ($colorDropdowns.length > 0 && self.variants && self.variants.currentVariant) {
            // Trigger change event which will call updatePrice via the handler above
            $colorDropdowns.trigger('change');
          }
        }, 100);

        // Update individual variant availability on each selection
        var $currentVariantJson = $(selectors.currentVariantJson, this.$container);

        if (theme.settings.dynamicVariantsEnable && $currentVariantJson.length) {
          this.currentVariantObject = JSON.parse($currentVariantJson[0].innerHTML);

          this.$variantSelectors.on('change' + this.namespace, this.updateVariantAvailability.bind(this));

          // Set default state based on current selected variant
          this.setCurrentVariantAvailability(this.currentVariantObject, true);
        }
      },

      // Variant change functions
      updateColorName: function(color, index) {
        // Updates on radio button change, not variant.js
        $('#VariantColorLabel-' + this.sectionId + '-' + index).text(color);
      },

      updateCartButton: function(evt) {
        var variant = evt.variant;
        const giftNote = $('.gift-card-with-product textarea')
        const selects = this.$container.find('.product-single__meta select.selectized:not([data-type="color-option"])').toArray();
        const selectionsMissed = selects.some(elem => $(elem).val().trim() === '') || giftNote && giftNote.val() === ''
        const cta = $(selectors.addToCart, this.$container)
        const text = $(selectors.addToCartText, this.$container);
        const giftCard = $(selectors.productGiftCardSelect, this.$container);
        const giftCardPrice = Number(giftCard?.data('cost')) || 0;
        
        console.log('updating cart button');
        
        //check if Number(document.querySelector('.embroidery-cost-total-cents').value exists and is something and set it
        let additional_addon_cost = 0;
        // Find all addon cost fields within this container
        $('.additional-addon-cost-item', this.$container).each(function() {
            const $field = $(this);
            const addonType = $field.data('feature');
            const cost = parseInt($field.val()) || 0;
            additional_addon_cost += cost;
            // console.log(`Addon type: ${addonType}, Cost: ${cost}`);
        });

        // standardization_labels
        const isCustomLabel = $(selectors.labelDropdownSelectors, this.$container).prop('checked');
        if(isCustomLabel){
          console.log('is custom label, adding 100 to the additional addon cost');
          additional_addon_cost += 200;
        }

        const defText = text.data('default-text');
        let ctaInnerContent = `<span>${defText}</span>`
        
        //check if variant title has gift or card in the title
        var isGiftCard = variant.name.toLowerCase().includes('gift') && variant.name.toLowerCase().includes('card');
        
        if(variant && !isGiftCard) {

          // DYNAMICCOMPAREATPRICING-HOLIDAY
          //HOLIDAY2024TIERPRICING
          // EARTHDAYROLLBACK -- TIEREDPROMOS
          var cart_total = 0;
          var discount_percent = 1;

          //check if the global variable is set limitedColors
          if(theme.cart?.items){
            theme.cart.items.forEach(item => {
              cart_total += item.original_price * item.quantity;
            });
          }else if(current_cart_total){
            cart_total = current_cart_total;
          }
          // DEFAULT DISCOUNTS -- check for default percentage discounts first
          // SITEWIDEDEFAULTDISCOUNT
          let default_discount_percent = parseInt($('[data-product-select]').data('product-default-discount')) || 20;
          
          if($('[data-product-select] option:selected').attr('data-variant-default-discount')){
            let variant_discount_percent = parseInt($('[data-product-select] option:selected').attr('data-variant-default-discount')) || 0;
            if(variant_discount_percent > 0){
              default_discount_percent = variant_discount_percent;
            }
          }

          if (variant?.sku?.toLowerCase().includes('parcel') && !variant?.sku?.toLowerCase().includes('collection')){
            if(variant?.sku?.toLowerCase().includes('lgparcel') || variant?.sku?.toLowerCase().includes('xlparcel')){
              if(variant?.sku?.toLowerCase().includes('trio')){ default_discount_percent = 40; }
              else if(variant?.sku?.toLowerCase().includes('duo')){ default_discount_percent = 30; }
              else{ default_discount_percent = 20; }
            }else{
              if(variant?.sku?.toLowerCase().includes('trio')){ default_discount_percent = 30; }
              else if(variant?.sku?.toLowerCase().includes('duo')){ default_discount_percent = 25; }
              else{ default_discount_percent = 20; }
            }

            //set the text in the badges to match the discount
            $('.standard-product-badge .product__price--compare-text').text(`Save ${default_discount_percent}%`);
          }
 
          //if the sku contains set9, set the default discount percent to 15
          if (variant?.sku?.toLowerCase().includes('set9')) { default_discount_percent = 15; }
          if (default_discount_percent > 0) {
            // Apply default percentage discount (30% = 0.7, 35% = 0.65, 40% = 0.6)
            discount_percent = 1 - (default_discount_percent / 100);
          } else {
            //add the total of the current item to the cart total
            //this is how much it would cost if the item was added to the cart

            // TIEREDPROMOS - ALTER THE TIERS HERE
            // cart_total += variant.price;
            // if (cart_total > 50000){
            //   discount_percent = 0.75; // 25% off
            // }else if (cart_total > 30000){
            //   discount_percent = 0.8; // 20% off
            // }else if (cart_total > 20000){
            //   discount_percent = 0.85; // 15% off
            // }else{
            //   // TIEREDPROMOS - Level 0: 10% off by default
            //   discount_percent = 0.9; // 10% off
            // }
          }

        
          //IMMEMORIAL
          // if(variant.sku.toLowerCase().includes('canvas')){
          //   discount_percent = 1;
          // }

          var altered_variant_price = variant.price;
          var adjusted_compare_at_price = variant.compare_at_price || 0;

          if(additional_addon_cost > 0){
            // add the embroidery price to this items price before we do any other discounts
            altered_variant_price     += additional_addon_cost;
            adjusted_compare_at_price += additional_addon_cost;
          }

          // console.log('variant price after embroidery:', altered_variant_price);
          // EARTHDAYROLLBACK WE MIGHT NEED TO RE-ACTIVATE THIS
          // TIEREDPROMOS 
          var show_default_discount = true;
          // NONDISCOUNTABLELOGICK -- we are basically overriding the discount logic
          // and keeping it the usual price which is already discounted
          // But if there's a default discount, don't override it
          if($('[data-product-select]').data('product-donotdiscount') && default_discount_percent === 0){
            console.log('this product is non discountable');
            discount_percent = 1;
            show_default_discount = true;
          }

          // FLASHDANCE -- additional dollar discounts here
          let additional_dollar_discount = 0;
          additional_dollar_discount = parseInt($('[data-product-select]').data('product-flashsale')) * 100 || 0;

          // DEFAULT BUTTON CONTENT
          //regular button is the cost of the variant plus the additional addon cost
          ctaInnerContent = `<span>${defText} - ${theme.Currency.formatMoney(
            variant.price - additional_dollar_discount + additional_addon_cost
            , theme.settings.moneyFormat).replace('.00', '')}</span>`;

            
          // BUTTON CONTENT WHEN THERE IS A DISCOUNT
          if(discount_percent < 1){
            ctaInnerContent = `<span>${defText} - ${theme.Currency.formatMoney(
              ((variant.price - additional_dollar_discount) * discount_percent)
              + additional_addon_cost //by default the addons are not discountable at this level
              , theme.settings.moneyFormat).replace('.00', '')}</span><span class="product__price--compare">${theme.Currency.formatMoney((variant.price + additional_addon_cost), theme.settings.moneyFormat).replace('.00', '')}</span>`;
          }
          
          // re-activate this once we are done with the holiday sale
          // NOTE -- RE ACTIVATE THIS ONCE WE ARE DONE WITH THE SALE!!
          //TIEREDPROMOS -- REMOVE
          //REVERT IF DISCOUNT IS SPECIFICALLY FORBIDDEN FOR THIS PRODUCT -- THIS JUST APPENDS THE COMPARE PRICE CONTENT TO THE BUTTON
          if(show_default_discount && adjusted_compare_at_price > altered_variant_price) {
            const comparePrice = adjusted_compare_at_price + giftCardPrice
            ctaInnerContent += `<span class="product__price--compare" data-compare="${comparePrice}">${theme.Currency.formatMoney(comparePrice, theme.settings.moneyFormat).replace('.00', '')}</span>`
          }

        }
        if (selectionsMissed) {
          cta.addClass(classes.disabled).prop('disabled', true);
          text.html(ctaInnerContent);
          return;
        }

        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text
            cta.removeClass(classes.disabled).prop('disabled', false);
            text.html(ctaInnerContent);
          } else {
            // Sold out, disable the submit button and change text
            cta.addClass(classes.disabled).prop('disabled', true);
            text.html(theme.strings.soldOut);
          }
        } else {
          // The variant doesn't exist, disable submit button
          cta.addClass(classes.disabled).prop('disabled', true);
          text.html(theme.strings.unavailable);
        }
      },

      updatePrice: function(evt) {
        const variant = evt.variant;
        const handle = $('[data-product-handle]').attr('data-product-handle')
        // if (variant && handle === 'build-your-2') {
        //   const priceFormat = "$\{\{amount_no_decimals\}\}"
        //   $('.option-name .product__price').html(theme.Currency.formatMoney(variant.price, priceFormat)).show();
        //   $('.option-name .product__price--compare').html(theme.Currency.formatMoney(variant.compare_at_price, priceFormat));
        //   return
        // }

        if (handle === 'digital-gift-card-2') { return; }
        
        if (variant) {
          // Regular price
          
          // DYNAMICCOMPAREATPRICING-HOLIDAY
          // HOLIDAY2024TIERPRICING
          var cart_total = 0;
          var discount_percent = 1;

          //check if the global variable is set limitedColors
          if(theme.cart?.items){
            theme.cart.items.forEach(item => {
              cart_total += item.original_price * item.quantity;
            });
          }else if(current_cart_total){
            cart_total = current_cart_total;
          }
          // DEFAULT DISCOUNTS -- check for default percentage discounts first
          // SITEWIDEDEFAULTDISCOUNT
          let default_discount_percent = parseInt($('[data-product-select]').data('product-default-discount')) || 20;
          if($('[data-product-select] option:selected').attr('data-variant-default-discount')){
            let variant_discount_percent = parseInt($('[data-product-select] option:selected').attr('data-variant-default-discount')) || 0;
            if(variant_discount_percent > 0){
              default_discount_percent = variant_discount_percent;
            }
          }
          // Small Parcel: Single 20% off, Duo 25% off, Trio 30% off
          // Medium Parcle: Single 20% off, Duo 25% off, Trio 30% off


          // Large Parcel: Single 20% off, Duo 30% off, Trio 40% off
          // XL Parcel: Single 20% off, Duo 30% off, Trio 40% off
          if (variant?.sku?.toLowerCase().includes('parcel') && !variant?.sku?.toLowerCase().includes('collection')){
            if(variant?.sku?.toLowerCase().includes('lgparcel') || variant?.sku?.toLowerCase().includes('xlparcel')){
              if(variant?.sku?.toLowerCase().includes('trio')){ default_discount_percent = 40; }
              else if(variant?.sku?.toLowerCase().includes('duo')){ default_discount_percent = 30; }
              else{ default_discount_percent = 20; }
            }else{
              if(variant?.sku?.toLowerCase().includes('trio')){ default_discount_percent = 30; }
              else if(variant?.sku?.toLowerCase().includes('duo')){ default_discount_percent = 25; }
              else{ default_discount_percent = 20; }
            }
          }

          if (variant?.sku?.toLowerCase().includes('set9')) { default_discount_percent = 15; }
          if (default_discount_percent > 0) {
            // Apply default percentage discount (30% = 0.7, 35% = 0.65, 40% = 0.6)
            discount_percent = 1 - (default_discount_percent / 100);
          } else {
            // EARTHDAYROLLBACK
            // TIEREDPROMOS
            //add the total of the current item to the cart total
            //this is how much it would cost if the item was added to the cart
            cart_total += variant.price;
            // if (cart_total > 50000){
            //   discount_percent = 0.75; // 25% off
            // }else if (cart_total > 30000){
            //   discount_percent = 0.8; // 20% off
            // }else if (cart_total > 20000){
            //   discount_percent = 0.85; // 15% off
            // }else{
            //   // TIEREDPROMOS - Level 0: 10% off by default
            //   discount_percent = 0.9; // 10% off
            // }
          }

          var dynamicPrice = variant.price;
          var dynamicCompareAtPrice = variant.compare_at_price;
          
          if(variant.title.toLowerCase().includes('core') && variant.price == 13700){
            dynamicCompareAtPrice = dynamicPrice;
            dynamicPrice = dynamicPrice * 0.85;
          }
          if(variant.title.toLowerCase().includes('full') && variant.price == 22500){
            dynamicCompareAtPrice = dynamicPrice;
            dynamicPrice = dynamicPrice * 0.85;
          }

          // FLASHDANCE
          let additional_dollar_discount = 0;
          additional_dollar_discount = parseInt($('[data-product-select]').data('product-flashsale')) * 100 || 0;
          
          //apply a 10% discount to all products based on the cart
          // NOTE -- DE-ACTIVATE THIS WHEN WE ARE DONE WITH THE SALE
          // TIEREDPROMOS -- REMOVE
          if(default_discount_percent > 0 || additional_dollar_discount > 0){
            dynamicCompareAtPrice = dynamicPrice;
            dynamicPrice = (dynamicPrice - additional_dollar_discount) * discount_percent;
          }

          //NOTE -- THIS IS TO PREVENT THE DISCOUNT FROM SHOWING UP ON CERTAIN PRODUCTS
          // But if there's a default discount, don't override it
          if($('[data-product-select]').data('product-donotdiscount') && default_discount_percent === 0){
            // console.log('this product is non discountable');
            discount_percent = 1;
            dynamicPrice = variant.price;
            dynamicCompareAtPrice = variant.compare_at_price;
          }

          // standardization_labels
          // standardization_labels
          // const isCustomLabel = $(selectors.labelDropdownSelectors, this.$container).prop('checked');
          // if(isCustomLabel){
          //   console.log('is custom label, updating the pricing of the PRODUCT at the top');
          //   dynamicPrice += 200;
          // }

          //set the pricing now
          $(selectors.price, this.$container).html(theme.Currency.formatMoney(dynamicPrice, theme.settings.moneyFormat).replace('.00', '')).show();
          

          // Sale price, if necessary
          if (dynamicCompareAtPrice > dynamicPrice) {
            
            $(selectors.comparePrice, this.$container).html(theme.Currency.formatMoney(dynamicCompareAtPrice, theme.settings.moneyFormat).replace('.00', ''));
            $(selectors.comparePrice, this.$container).show();
            $(selectors.priceWrapper, this.$container).removeClass('hide');
            $(selectors.price, this.$container).addClass(classes.onSale);
            $(selectors.comparePriceA11y, this.$container).attr('aria-hidden', 'false');
            $(selectors.priceA11y, this.$container).attr('aria-hidden', 'false');
            
            //update the new pricing containers with the oddit pdp
          } else {
            $(selectors.comparePrice, this.$container).hide();
            $(selectors.priceWrapper, this.$container).addClass('hide');
            $(selectors.price, this.$container).removeClass(classes.onSale);
            $(selectors.comparePriceA11y, this.$container).attr('aria-hidden', 'true');
            $(selectors.priceA11y, this.$container).attr('aria-hidden', 'true');
          }
          
          

          if (theme.settings.currenciesEnabled) {
            theme.currencySwitcher.ajaxrefresh();
          }
        }
      },

      updateSku: function(evt) {
        var variant = evt.variant;
        var newSku = '';

        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }

          $(selectors.sku, this.$container).html(newSku);
        }
      },

      updateInventory: function(evt) {
        var variant = evt.variant;
        var showInventory = false;
        var quantity = 0;
        var $inventoryLabel = $(selectors.inventory, this.$container);

        if (!window.inventories || !window.inventories[this.sectionId]) {
          // Force reload if in editor
          if (Shopify.designMode) {
            location.reload();
          }
          return;
        }

        if (variant && variant.inventory_management === 'shopify') {
          showInventory = true;
          quantity = window.inventories[this.sectionId][variant.id];

          if (quantity <= 0 || quantity > this.settings.inventoryThreshold) {
            showInventory = false;
          }
        }

        if (!showInventory) {
          $inventoryLabel.addClass('hide');
        } else {
          $inventoryLabel
            .removeClass('hide')
            .text(theme.strings.stockLabel.replace('[count]', quantity));
        }

      },

      updateVariantImage: function(evt) {
        var variant = evt.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

        var $newImage = $('.product__thumb[data-id="' + variant.featured_image.id + '"]');
        var imageIndex = this._slideIndex($newImage.closest('.product__thumb-item'));

        // No image, bail
        if (typeof imageIndex === 'undefined') {
          return;
        }

        if (!theme.config.bpSmall && this.settings.stackedImages) {
          this.stackedScrollTo(imageIndex);
        } else {
          this.$mainSlider.slick('slickGoTo', imageIndex);
        }
      },

      setCurrentVariantAvailability: function(variant) {
        var valuesToEnable = {
          option1: [],
          option2: [],
          option3: []
        };

        // Disable all options to start
        this.disableVariantGroup($(selectors.formContainer).find('.variant-input-wrap'));

        // Combine all available variants
        var availableVariants = this.variantsObject.filter(function(el) {
          if (variant.id === el.id) {
            return false;
          }

          // Option 1
          if (variant.option2 === el.option2 && variant.option3 === el.option3) {
            return true;
          }

          // Option 2
          if (variant.option1 === el.option1 && variant.option3 === el.option3) {
            return true;
          }

          // Option 3
          if (variant.option1 === el.option1 && variant.option2 === el.option2) {
            return true;
          }
        });


        // IE11 can't handle shortform of {variant} so extra step is needed
        var variantObject = {
          variant: variant
        };

        availableVariants = Object.assign({}, variantObject, availableVariants);

        // Loop through each available variant to gather variant values
        for (var property in availableVariants) {
          if (availableVariants.hasOwnProperty(property)) {
            var item = availableVariants[property];
            var option1 = item.option1;
            var option2 = item.option2;
            var option3 = item.option3;

            if (option1) {
              if (valuesToEnable.option1.indexOf(option1) === -1) {
                valuesToEnable.option1.push(option1);
              }
            }
            if (option2) {
              if (valuesToEnable.option2.indexOf(option2) === -1) {
                valuesToEnable.option2.push(option2);
              }
            }
            if (option3) {
              if (valuesToEnable.option3.indexOf(option3) === -1) {
                valuesToEnable.option3.push(option3);
              }
            }
          }
        }

        // Have values to enable, separated by option index
        if (valuesToEnable.option1.length) {
          this.enableVariantOptionByValue(valuesToEnable.option1, 'option1');
        }
        if (valuesToEnable.option2.length) {
          this.enableVariantOptionByValue(valuesToEnable.option2, 'option2');
        }
        if (valuesToEnable.option3.length) {
          this.enableVariantOptionByValue(valuesToEnable.option3, 'option3');
        }
      },

      updateVariantAvailability: function(evt, value, index) {
        if (value && index) {
          var newVal = value;
          var optionIndex = index;
        } else {
          var $el = $(evt.currentTarget);
          var newVal = $el.val() ? $el.val() : evt.currentTarget.value;
          var optionIndex = $el.data('index');
        }

        var variants = this.variantsObject.filter(function(el) {
          return el[optionIndex] === newVal;
        });

        // Disable all buttons/dropdown options that aren't the current index
        $(selectors.formContainer).find('.variant-input-wrap').each(function(index, el) {
          var $group = $(el);
          var currentOptionIndex = $group.data('index');

          if (currentOptionIndex !== optionIndex) {
            // Disable all options as a starting point
            this.disableVariantGroup($group);

            // Loop through legit available options and enable
            for (var i = 0; i < variants.length; i++) {
              this.enableVariantOption($group, variants[i][currentOptionIndex]);
            }
          }
        }.bind(this));
      },

      disableVariantGroup: function($group) {
        if (this.settings.variantType === 'dropdown') {
          $group.find('option').prop('disabled', true)
        } else {
          $group.find('input').prop('disabled', true);
          $group.find('label').toggleClass('disabled', true);
        }
      },

      enableVariantOptionByValue: function(array, index) {
        var $group = $(selectors.formContainer).find('.variant-input-wrap[data-index="'+ index +'"]');

        for (var i = 0; i < array.length; i++) {
          this.enableVariantOption($group, array[i]);
        }
      },

      enableVariantOption: function($group, value) {
        // Selecting by value so escape it
        value = value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');

        if (this.settings.variantType === 'dropdown') {
          $group.find('option[value="'+ value +'"]').prop('disabled', false);
        } else {
          var $buttonGroup = $group.find('.variant-input[data-value="'+ value +'"]');
          $buttonGroup.find('input').prop('disabled', false);
          $buttonGroup.find('label').toggleClass('disabled', false);
        }
      },

      // Image/thumbnail toggling
      initImageSwitch: function() {
        if (!$(selectors.photoThumbs, this.$container).length) {
          return;
        }

        var self = this;

        $(selectors.photoThumbs, this.$container).on('click', function(evt) {
          evt.preventDefault();
          if (!theme.config.bpSmall && this.settings.stackedImages) {
            var index = $(evt.currentTarget).data('index');
            this.stackedScrollTo(index);
          }
        }.bind(this));
      },

      checkIfVideos: function() {
        var $productVideos = this.$mainSlider.find(selectors.productVideo);

        // Stop if there are 0 videos
        if (!$productVideos.length) {
          return false;
        }

        var videoTypes = [];

        $productVideos.each(function() {
          var type = $(this).data('video-type');

          if (videoTypes.indexOf(type) < 0) {
            videoTypes.push(type);
          }
        });

        // Load YouTube API if not already loaded
        if (videoTypes.indexOf('youtube') > -1) {
          if (!theme.config.youTubeReady) {
            window.loadYouTube();
            $('body').on('youTubeReady' + this.namespace, function() {
              this.loadYoutubeVideos($productVideos);
            }.bind(this));
          } else {
            this.loadYoutubeVideos($productVideos);
          }
        }

        // Load Vimeo API if not already loaded
        if (videoTypes.indexOf('vimeo') > -1) {
          if (!vimeoReady) {
            window.loadVimeo();
            $('body').on('vimeoReady' + this.namespace, function() {
              this.loadVimeoVideos($productVideos);
            }.bind(this))
          } else {
            this.loadVimeoVideos($productVideos);
          }
        }

        // Add mp4 video players
        if (videoTypes.indexOf('mp4') > -1) {
          this.loadMp4Videos($productVideos);
        }

        return videoTypes;
      },

      loadMp4Videos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'mp4') {
            return;
          }

          var id = $el.attr('id');
          var videoId = $el.data('video-id');

          videos[this.id] = {
            type: 'mp4',
            divId: id,
            style: $el.data('video-style')
          };
        });
      },

      loadVimeoVideos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'vimeo') {
            return;
          }

          var id = $el.attr('id');
          var videoId = $el.data('video-id');

          videos[this.id] = {
            type: 'vimeo',
            divId: id,
            id: videoId,
            style: $el.data('video-style'),
            width: $el.data('video-width'),
            height: $el.data('video-height')
          };
        });

        // Create a new player for each Vimeo video
        for (var key in videos) {
          if (videos[key].type != 'vimeo') {
            continue;
          }

          var args = $.extend({}, vimeoVideoOptions, videos[key]);
          vimeoPlayers[key] = new Vimeo.Player(videos[key].divId, args);
        }

        vimeoReady = true;
      },

      autoplayVimeoVideo: function(id) {
        // Do not autoplay on mobile though
        if (!theme.config.bpSmall) {
          this.requestToPlayVimeoVideo(id);
        } else {
          // Set as loaded on mobile so you can see the image
          var $player = $('#' + id);
          setParentAsLoaded($player);
        }
      },

      requestToPlayVimeoVideo: function(id) {
        // The slider may initialize and attempt to play the video before
        // the API is even ready, because it sucks.

        var $player = $('#' + id);
        setParentAsLoading($player);

        if (!vimeoReady) {
          // Wait for the trigger, then play it
          $('body').on('vimeoReady' + this.namespace, function() {
            this.playVimeoVideo(id);
          }.bind(this))
          return;
        }

        this.playVimeoVideo(id);
      },

      playVimeoVideo: function(id) {
        vimeoPlayers[id].play();

        if (videos[id].style === 'muted') {
          vimeoPlayers[id].setVolume(0);
        }

        var $player = $('#' + id);
        setParentAsLoaded($player);
      },

      stopVimeoVideo: function(id) {
        if (!theme.config.vimeoReady) {
          return;
        }

        if (id) {
          vimeoPlayers[id].pause();
        } else {
          for (key in vimeoPlayers) {
            if (typeof vimeoPlayers[key].pause === 'function') {
              vimeoPlayers[key].pause();
            }
          }
        }
      },

      loadYoutubeVideos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'youtube') {
            return;
          }

          var id = $el.attr('id');
          var videoId = $el.data('youtube-id');

          videos[this.id] = {
            type: 'youtube',
            id: id,
            videoId: videoId,
            style: $el.data('video-style'),
            width: $el.data('video-width'),
            height: $el.data('video-height'),
            attemptedToPlay: false
          };
        });

        // Create a player for each YouTube video
        for (var key in videos) {
          if (videos[key].type === 'youtube') {
            if (videos.hasOwnProperty(key)) {
              var args = $.extend({}, youtubeVideoOptions, videos[key]);

              if (args.style === 'muted') {
                // default youtubeVideoOptions, no need to change anything
              } else {
                args.playerVars.controls = 1;
                args.playerVars.autoplay = 0;
              }

              youtubePlayers[key] = new YT.Player(key, args);
            }
          }
        }

        youtubeReady = true;
      },

      requestToPlayYoutubeVideo: function(id, forcePlay) {
        if (!theme.config.youTubeReady) {
          return;
        }

        var $player = $('#' + id);
        setParentAsLoading($player);

        // If video is requested too soon, player might not be ready.
        // Set arbitrary timeout to request it again in a second
        if (typeof youtubePlayers[id].playVideo != 'function') {
          var o = this;
          setTimeout(function() {
            o.playYoutubeVideo(id, forcePlay);
          }, 1000);
          return;
        }

        this.playYoutubeVideo(id, forcePlay);
      },

      playYoutubeVideo: function (id, forcePlay) {
        var $player = $('#' + id);
        setParentAsLoaded($player);
        if (typeof youtubePlayers[id].playVideo === 'function') {
          youtubePlayers[id].playVideo();
        }

        // forcePlay is sent as true from beforeSlideChange so the visibility
        // check isn't fooled by the next slide positioning
        if (!forcePlay) {
          initCheckVisibility(id);
        }
      },

      stopYoutubeVideo: function(id) {
        if (!theme.config.youTubeReady) {
          return;
        }

        if (id && youtubePlayers[id]) {
          if (typeof youtubePlayers[id].pauseVideo === 'function') {
            youtubePlayers[id].pauseVideo();
          }
          $(window).off('scroll.' + id);
        } else {
          for (key in youtubePlayers) {
            if (typeof youtubePlayers[key].pauseVideo === 'function') {
              youtubePlayers[key].pauseVideo();
              $(window).off('scroll.' + key);
            }
          }
        }
      },

      playMp4Video: function(id) {
        var $player = $('#' + id);
        setParentAsLoaded($player);

        $player[0].play();
      },

      stopMp4Video: function(id) {
        if (id) {
          $('#' + id)[0].pause();
        } else {
          // loop through all mp4 videos to stop them
          for (var key in videos) {
            if (videos[key].type === 'mp4') {
              var player = $('#' + videos[key].divId)[0];
              if (typeof player.pause === 'function') {
                player.pause();
              }
            }
          }
        }
      },

      stackedImagesInit: function() {
        $(window).off(this.namespaceImages);
        this.stackedImagePositions();

        if (this.inModal) {
          // Slight delay in modal to accommodate loading videos
          setTimeout(function() {
            this.stackedActive(this.settings.stackedCurrent);
          }.bind(this), 1000);
        } else {
          this.stackedActive(this.settings.stackedCurrent);
        }


        // update image positions on resize
        $(window).on('resize' + this.namespaceImages, $.debounce(200, this.stackedImagePositions.bind(this)));

        // scroll listener to mark active thumbnail
        $(window).on('scroll' + this.namespaceImages, $.throttle(200, function() {
          var goal = window.scrollY;
          var closest = this.settings.stackedImagePositions.reduce(function(prev, curr) {
            return (Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
          });
          var index = this.settings.stackedImagePositions.indexOf(closest)
          if (this.settings.stackedCurrent !== index) {
            this.stackedActive(index);
          }
        }.bind(this)));
      },

      stackedImagePositions: function() {
        var positions = [];
        $(selectors.photo, this.$container).each(function() {
          positions.push(Math.round($(this).offset().top));
        });
        this.settings.stackedImagePositions = positions;
      },

      stackedScrollTo: function(index) {
        // Scroll to top of large image
        var pos = $(selectors.photo, this.$container).eq(index).offset().top;
        $('html, body').animate({
          scrollTop: pos
        }, 400, 'swing');
      },

      stackedActive: function(index) {
        $(selectors.photoThumbItem, this.$container)
          .removeClass(classes.thumbActive)
          .eq(index).addClass(classes.thumbActive);

        if (this.settings.hasVideos) {
          this.stopVideo();

          var $video = $(selectors.photo, this.$container).eq(index).find(selectors.productVideo);

          if ($video.length) {
            this.initVideo($video);
          }
        }

        this.settings.stackedCurrent = index;
      },

      createImageCarousels: function() {
        // Set starting slide (for both sliders)
        var $activeSlide = this.$mainSlider.find('.starting-slide');
        var startIndex = this._slideIndex($activeSlide);

        // Lame way to prevent duplicate event listeners
        this.$mainSlider.off('init');
        this.$mainSlider.off('beforeChange');
        this.$mainSlider.on('init', this.mainSlideInit.bind(this));
        this.$mainSlider.on('beforeChange', this.beforeSlideChange.bind(this));
        this.$thumbSlider.on('init', this.thumbSlideInit.bind(this));

        // Default (mobile) slider settings
        this.mainSliderArgs = {
          infinite: true,
          arrows: false,
          dots: true,
          touchThreshold: 10,
          speed: 300,
          adaptiveHeight: true,
          initialSlide: startIndex
        };

        this.thumbSliderArgs = {
          initialSlide: startIndex
        };

        // Init sliders normally
        var sliderArgs = this.setSliderArgs();
        this.initSliders(sliderArgs);

        // Re-init slider when a breakpoint is hit
        $('body').on('matchSmall matchLarge', function() {
          var sliderArgs = this.setSliderArgs();
          this.initSliders(sliderArgs);
        }.bind(this));

        // Too many thumbnails can cause the AOS calculations to be off
        // so refresh that when the slider is ready
        if (AOS) {
          AOS.refresh();
        }
      },

      initSliders: function(args) {
        this.destroyImageCarousels();

        if (!theme.config.bpSmall && this.settings.stackedImages) {
          this.stackedImagesInit();
        } else {
          this.$mainSlider.not('.slick-initialized').slick(args.main);
        }

        if (!theme.config.bpSmall && !this.settings.stackedImages) {
          if (this.$thumbSlider.length) {
            this.$thumbSlider.not('.slick-initialized').slick(args.thumbs);
          }
        }
      },

      setSliderArgs: function() {
        var args = {};
        var thumbnailsVertical = this.$thumbSlider.data('position') === 'beside' ? true : false;

        if (theme.config.bpSmall) {
          args.main = this.mainSliderArgs;
          args.thumbs = this.thumbSliderArgs;
        } else {
          args.main = $.extend({}, this.mainSliderArgs, {
            asNavFor: '#' + this.$thumbSlider.attr('id'),
            adaptiveHeight: thumbnailsVertical ? false : true,
            dots: false,
            infinite: false,
            fade: true
          });

          args.thumbs = $.extend({}, this.thumbSliderArgs, {
            asNavFor: '#' + this.$mainSlider.attr('id'),
            slidesToShow: thumbnailsVertical ? 3 : 5,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            vertical: thumbnailsVertical,
            verticalSwiping: thumbnailsVertical,
            focusOnSelect: true,
            infinite: false,
            customHeightMatching: thumbnailsVertical,
            customSlideAdvancement: true
          });
        }

        return args;
      },

      destroyImageCarousels: function() {
        if (this.$mainSlider && this.settings.slickMainInitialized) {
          this.$mainSlider.slick('unslick');
          this.settings.slickMainInitialized = false;
        }

        if (this.$thumbSlider && this.settings.slickThumbInitialized) {
          this.$thumbSlider.slick('unslick');
          this.settings.slickThumbInitialized = false;
        }

        this.settings.slickMainInitialized = false;
        this.settings.slickThumbInitialized = false;
      },

      mainSlideInit: function(event, slick) {
        var $currentSlide = slick.$slider.find(selectors.currentSlide);
        var $video = $currentSlide.find(selectors.productVideo);

        this.settings.slickMainInitialized = true;

        if (!$video.length) {
          return;
        }

        this.initVideo($video);
      },

      thumbSlideInit: function(event, slick) {
        this.settings.slickThumbInitialized = true;
      },

      initVideo: function($video) {
        var videoType = $video.data('video-type');
        var divId = $video.attr('id');

        if (videoType === 'mp4' && videos[divId].style === 'muted') {
          this.playMp4Video(divId);
        }

        if (videoType === 'youtube') {
          if (youtubeReady && videos[divId].style === 'muted') {
            this.requestToPlayYoutubeVideo(divId);
          }
        }

        if (videoType === 'vimeo') {
          if (vimeoReady) {
            this.playOrShowVimeo(divId);
          } else {
            $('body').on('vimeoReady' + this.namespace, function() {
              this.playOrShowVimeo(divId);
            }.bind(this))
          }
        }

        // Hacky way to trigger resetting the slider layout in modals
        if (this.inModal) {
          this.resizeSlides();
        }
      },

      stopVideo: function(id, type) {
        if (!id) {
          this.stopYoutubeVideo();
          this.stopVimeoVideo();
          this.stopMp4Video();
        }

        if (type === 'youtube') {
          this.stopYoutubeVideo(id);
        }

        if (type === 'mp4') {
          this.stopMp4Video(id);
        }

        if (type === 'vimeo') {
          this.stopVimeoVideo(id);
        }
      },

      playOrShowVimeo: function(id) {
        if (videos[id] && videos[id].style === 'muted') {
          this.autoplayVimeoVideo(id);
        } else if (videos[id] && videos[id].style === 'unmuted') {
          setParentAsLoaded($('#' + id));
        }
      },

      getVideoType: function($video) {
        return $video.data('video-type');
      },

      getVideoId: function($video) {
        return $video.attr('id');
      },

      beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find(selectors.currentSlide);
        var $prevVideo = $currentSlide.find('.product__video');
        var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
        var $nextVideo = $nextSlide.find('.product__video');

        // Pause any existing slide video
        if (currentSlide !== nextSlide && $prevVideo.length) {
          var prevVideoType = this.getVideoType($prevVideo);
          var prevVideoId = this.getVideoId($prevVideo);

          if (prevVideoId) {
            this.stopVideo(prevVideoId, prevVideoType);
          }
        }

        // Prep next slide video
        if ($nextVideo.length) {
          var nextVideoType = this.getVideoType($nextVideo);
          var nextVideoId = this.getVideoId($nextVideo);

          // Prep Vimeo with a backup in case the API isn't ready
          if (nextVideoId && nextVideoType === 'vimeo') {
            if (vimeoReady) {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.autoplayVimeoVideo(nextVideoId);
              }
            } else {
              $('body').on('vimeoReady' + this.namespace, function() {
                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                  this.autoplayVimeoVideo(nextVideoId);
                }
              }.bind(this))
            }
          }

          // Prep YouTube with a backup in case API isn't ready
          if (nextVideoId && nextVideoType === 'youtube') {
            if (youtubeReady) {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.requestToPlayYoutubeVideo(nextVideoId, true);
              }
            } else {
              $('body').on('youTubeReady' + this.namespace, function() {
                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                  this.requestToPlayYoutubeVideo(nextVideoId, true);
                }
              }.bind(this))
            }
          }

          // Autoplay muted MP4 videos
          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
            if (nextVideoType === 'mp4') {
              this.playMp4Video(nextVideoId);
            }
          }

          // Set unmuted videos to loaded state
          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style != 'muted') {
            setParentAsLoaded($('#' + nextVideoId));
          }
        }
      },

      resizeSlides: function() {
        if (!this.settings.hasMultipleImages) {
          return;
        }

        // Necessary to make slider visible again
        $(window).trigger('resize.slick');
        setTimeout(function() {
          if (this.$mainSlider && this.settings.slickMainInitialized) {
            this.$mainSlider.slick('setPosition');
          }
          if (this.$thumbSlider && this.settings.slickThumbInitialized) {
            this.$thumbSlider.slick('setPosition');
          }
        }.bind(this), 500); // same timing as modal open transition
      },

      _slideIndex: function($el) {
        return $el.data('index');
      },

      initAjaxProductForm: function() {
        if (theme.settings.cartType === 'drawer' || theme.settings.cartType === 'sticky') {
          new theme.AjaxProduct($(selectors.formContainer, this.$container));
        }
      },

      openModalProduct: function() {
        var initialized = false;
        if (!this.settings.modalInit) {
          var url = this.$formHolder.data('url');
          var template = this.$formHolder.data('template');

          // If not template, product uses default product template
          // which has sections. Ajax view is a slimmed down version to
          // load only essentials
          if (!template) {
            url = url + '?view=ajax';
          }

          $.get(url, function(data) {
            var $template = $(data);
            var $newForm = $template.find('#AddToCartForm-' + this.sectionId);
            this.replaceModalFormHolder(this.$formHolder, $newForm);

            var $sectionDiv = $template.find('#ProductSections-' + this.sectionId);
            if ($sectionDiv.length) {
              this.loadProductSections($sectionDiv);
            }

            var $relatedDiv = $template.find('#Recommendations-' + this.sectionId);
            if ($relatedDiv.length) {
              this.loadRelatedProducts($relatedDiv);
            }

            var $socialDiv = $template.find('.index-section.instagram-section');
            if ($socialDiv.length) {
              this.loadSocialSection($socialDiv);
            }

            if (window.SPR) {
              SPR.initDomEls();SPR.loadBadges();
            }

            sections.loadSubSections(this.$modal);

            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                productId: this.sectionId
              }
            }));
          }.bind(this));

          this.preImageSetup();
          this.loadModalContent();
          this.imageSetup(false);
          this.settings.modalInit = true;
        } else {
          initialized = true;
          if (!theme.config.bpSmall && this.settings.stackedImages) {
            this.stackedActive(0);
          }
        }

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            initialized: initialized,
            productId: this.sectionId
          }
        }));

        this.resizeSlides();
      },

      closeModalProduct: function() {
        this.stopVideo();
        $('body').off(this.namespace);
        $(window).off(this.namespace);
      },

      replaceModalFormHolder: function($holder, $form) {
        $holder.replaceWith($form);
        this.formSetup();
        if (Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      },

      loadProductSections: function($content) {
        $('#ProductSectionsHolder-' + this.sectionId).replaceWith($content);
      },

      loadRelatedProducts: function($content) {
        // Remove any quick view modals as they cause conflicts.
        // These are not output with product.ajax templates,
        // but are in our custom product.sections ones and any custom ones
        // developers create.
        $content.find('.screen-layer--product').remove();

        $('#ProductRelatedHolder-' + this.sectionId).replaceWith($content);
      },

      loadSocialSection: function($content) {
        $('#SocialSectionHolder-' + this.sectionId).replaceWith($content);
      },

      loadModalContent: function() {
        // Load videos if they exist
        var videoTypes = this.checkIfVideos();

        // Lazyload mp4 videos similar to images
        if (videoTypes && videoTypes.indexOf('mp4') > -1) {
          this.$modal.find('.product__video[data-video-type="mp4"]').each(function(i, video) {
            var $el = $(video);
            var src = $el.data('video-src');
            var source = document.createElement('source');
            source.setAttribute('src', src);
            $el.append(source);
          }.bind(this));
        }
      },

      onUnload: function() {
        this.$container.off(this.namespace);
        $('body').off(this.namespace);
        $(window).off(this.namespace).off(this.namespaceImages);;
        this.destroyImageCarousels();

        if (AOS) {
          AOS.refresh();
        }
      }
    });

    return Product;
  })();

  theme.Recommendations = (function() {

    function Recommendations(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');

      this.selectors = {
        recommendations: '#Recommendations-' + sectionId,
        placeholder: '.product-recommendations-placeholder',
        sectionClass: ' .product-recommendations',
        productResults: '.grid-product'
      };

      //this.init();
    }

    Recommendations.prototype = $.extend({}, Recommendations.prototype, {
      init: function() {
        // console.log(this.selectors.recommendations)
        var $section = $(this.selectors.recommendations);

        if (!$section.length || $section.data('enable') === false) {
          return;
        }

        var $placeholder = $section.find(this.selectors.placeholder);
        var id = $section.data('product-id');
        var limit = $section.data('limit');

        var url = '/recommendations/products?section_id=product-recommendations&limit='+ limit +'&product_id=' + id;

        $placeholder.load(url + this.selectors.sectionClass, function(data) {
          theme.reinitProductGridItem($section);

          // If no results, hide the entire section
          if ($(data).find(this.selectors.sectionClass).find(this.selectors.productResults).length === 0) {
            $section.addClass('hide');
          }
        }.bind(this));
      },

      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateVariantInventory: function($section) {
        window.inventories = window.inventories || {};

        $section.find('.product__inventory-data').each(function() {
          var $el = $(this);
          var sectionId = $el.data('section-id');
          window.inventories[sectionId] = {};
          $.each($el.data(), function(variant, qty) {
            window.inventories[sectionId][variant] = qty;
          })
        });
      }
    });

    return Recommendations;
  })();

  // Handles multiple section interactions:
  //  - Featured collection slider
  //  - Featured collection grid (hover product sliders only)
  //  - Related products
  //  - Social reviews
  //
  // Options:
  //  - scrollable: overflow div with arrows
  //  - infinite pagination: only in slider format

  theme.FeaturedCollection = (function() {
    var selectors = {
      scrollWrap: '[data-pagination-wrapper]',
      scrollAnimation: '[data-aos="overflow__animation"]',
      productContainer: '[data-product-container]',
      collectionProductContainer: '[data-collection-container]',
      product: '[data-product-grid]',
      arrows: '[data-arrow]'
    };

    var classes = {
      loading: 'collection-loading',
      arrowLeft: 'overflow-scroller__arrow--left',
      disableScrollLeft: 'overflow-scroller--disable-left',
      disableScrollRight: 'overflow-scroller--disable-right'
    };

    function FeaturedCollection(container) {
      this.$container = $(container);
      this.sectionId = this.$container.attr('data-section-id');
      this.$scrollWrap = $(selectors.scrollWrap, this.$container);
      this.$scrollArrows = $(selectors.arrows, this.$container);
      this.namespace = '.featured-collection-' + this.sectionId;

      this.options = {
        scrollable: this.$container.data('scrollable'),
        paginate: this.$container.data('paginate'),
        instagram: this.$container.data('instagram')
      };

      var paginateBy = this.$container.data('paginate-by');
      var productCount = this.$container.data('collection-count');

      this.settings = {
        url: this.$container.data('collection-url'),
        page: 1,
        pageCount: this.options.paginate ? Math.ceil(productCount / paginateBy) : 0,
        itemsToScroll: 3
      };

      this.state = {
        isInit: false,
        loading: false,
        scrollerEnabled: false,
        loadedAllProducts: false,
        scrollable: this.options.scrollable,
        scrollInterval: null,
        scrollSpeed: 3 // smaller is faster
      };

      this.sizing = {
        scroller: 0,
        itemWidth: 0
      };

      slate.utils.promiseStylesheet().then(function() {
        this.checkVisibility();
        $(window).on('scroll' + this.namespace, $.debounce(200, this.checkVisibility.bind(this)));
      }.bind(this));
    }

    FeaturedCollection.prototype = $.extend({}, FeaturedCollection.prototype, {
      checkVisibility: function() {
        if (this.state.isInit) {
          // If a value is 0, we need to recalculate starting points
          if (this.sizing.scrollSize === 0) {
            this.$scrollWrap.trigger('scroll' + this.namespace);
          }
          $(window).off('scroll' + this.namespace);
          return;
        }

        var visibleThreshold = this.options.instagram ? 500 : 0;

        if (theme.isElementVisible(this.$container, visibleThreshold)) {
          if (this.options.instagram) {
            this.initInstagram();
          }
          this.init();
          this.state.isInit = true;
        }
      },

      init: function() {
        new theme.HoverProductGrid(this.$container);

        if (!this.state.scrollable) {
          return;
        }

        this.sizing = this.getScrollWidths();

        $(window).on('resize' + this.namespace, $.debounce(200, this.handleResize.bind(this)));

        this.toggleScrollListener(this.state.scrollable);
        this.arrowListeners(this.state.scrollable);
      },

      reInit: function() {
        new theme.HoverProductGrid(this.$container);

        if (this.state.scrollable) {
          this.sizing = this.getScrollWidths();
          this.toggleScrollListener(this.state.scrollable);
        }

        theme.reinitProductGridItem();
      },

      initInstagram: function() {
        $('.instagram-image', this.$container).each(function(i, el) {
          if ($(el).is('[data-url]')){
            this.getInstagramImage($(el));
          }
        }.bind(this));
      },

      getInstagramImage: function($el) {
        var instagramLink = $el.attr('data-url')
        var regex = /(instagram.com|instagr.am)\/p\/([^\/\s\?\#]+)/;
        if ( regex.test(instagramLink) ){
          var found = regex.exec(instagramLink);
          var shortcode = found.slice(-1).pop();
          var oembed_url = 'https://www.instagram.com/p/' + encodeURIComponent( shortcode ) + '/media/?size=l';
          var request = new XMLHttpRequest();
          request.open('GET', oembed_url, true);
          request.onload = function() {
            if (request.status >= 200 && request.status < 400) {
              $el.css('background-image', 'url(' + request.responseURL + ')' );
            } else {
              console.warn('Instagram request failed');
            }
          };
          request.onerror = function() {
            console.warn('Instagram request failed');
          };
          request.send();
        } else {
          $el
            .html('Invalid Instagram link. Use this format:<small>https://instagram.com/p/BeQb_V9jyDr</small>')
            .addClass('instagram-image--error');
        }
      },

      loadingState: function(loading) {
        this.state.loading = loading;
        this.$container.toggleClass(classes.loading, loading);
      },

      getScrollWidths: function() {
        var container = this.$scrollWrap.width();
        var scroller = this.$scrollWrap[0].scrollWidth;
        var itemWidth = this.$scrollWrap.find('.grid__item').first().outerWidth();

        // First time this runs there is a 200px CSS animation that JS doesn't
        // take into account, so manually subtract from the scroller width
        if (!this.state.isInit) {
          scroller = scroller - 200;
        }

        if (scroller <= container) {
          this.disableArrow(null, true);
        }

        return {
          scroller: scroller,
          scrollSize: scroller - container,
          itemWidth: itemWidth
        };
      },

      handleResize: function() {
        if (this.state.scrollable) {
          this.sizing = this.getScrollWidths();
        }
        this.toggleScrollListener(this.state.scrollable);
        this.arrowListeners(this.state.scrollable);
      },

      toggleScrollListener: function(enable) {
        if (enable) {
          if (this.state.scrollerEnabled) { return; }
          this.$scrollWrap.on('scroll' + this.namespace, $.throttle(250, this.scrollCheck.bind(this)));
          this.state.scrollerEnabled = true;
        } else {
          this.$scrollWrap.off('scroll' + this.namespace);
          this.state.scrollerEnabled = false;
        }
      },

      scrollCheck: function(evt) {
        if (this.state.loading) {
          this.toggleScrollListener(false);
          return;
        }

        // If a value is 0, we need to recalculate starting points
        if (this.sizing.scrollSize === 0) {
          this.sizing = this.getScrollWidths();
        }

        var scrollLeft = evt.currentTarget.scrollLeft ? evt.currentTarget.scrollLeft : 0;
        var percent = Math.floor(scrollLeft / this.sizing.scrollSize * 100);
        var fromEnd = this.sizing.scrollSize - scrollLeft;

        if (this.options.paginate) {
          if (!this.state.loadedAllProducts && percent > 50) {
            this.getNewProducts();
          }
        }

        if (!percent) {
          percent = 0;
        }

        this.disableArrow(percent);
      },

      arrowListeners: function(enable) {
        if (enable) {
          this.$scrollArrows
            .removeClass('hide')
            .off(this.namespace)
            .on('click' + this.namespace, this.arrowScroll.bind(this));
        } else {
          this.$scrollArrows
            .addClass('hide')
            .off(this.namespace);
        }
      },

      arrowScroll: function(evt) {
        var direction = $(evt.currentTarget).hasClass(classes.arrowLeft) ? 'left' : 'right';
        var iteration = theme.config.bpSmall ? 1 : 2;

        if (evt.type === 'mouseenter') {
          this.state.scrollInterval = setInterval(function(){
            var currentPos = this.$scrollWrap.scrollLeft();
            var newPos = direction === 'left' ? (currentPos - iteration) : (currentPos + iteration);
            this.$scrollWrap.scrollLeft(newPos);
          }.bind(this), this.state.scrollSpeed);
        } else if (evt.type === 'mouseleave') {
          clearInterval(this.state.scrollInterval);
        } else if (evt.type === 'click') {
          clearInterval(this.state.scrollInterval);

          var currentPos = this.$scrollWrap.scrollLeft();
          var scrollAmount = this.sizing.itemWidth * this.settings.itemsToScroll;
          var newPos = direction === 'left' ? (currentPos - scrollAmount) : (currentPos + scrollAmount);

          this.$scrollWrap.stop().animate({
            scrollLeft: newPos
          }, 400, 'swing');
        }

        if (newPos <= 0) {
          this.disableArrow(newPos);
        }
      },

      disableArrow: function(pos, all) {
        this.$scrollArrows
          .removeClass(classes.disableScrollRight)
          .removeClass(classes.disableScrollLeft);

        if (all) {
          this.$scrollArrows
            .addClass(classes.disableScrollRight)
            .addClass(classes.disableScrollLeft);
          return;
        }

        // Max left scroll
        if (pos <= 0) {
          this.$scrollArrows.addClass(classes.disableScrollLeft);
          return;
        }

        // Max right scroll
        if (pos >= 96) {
          this.$scrollArrows.addClass(classes.disableScrollRight);
          return;
        }
      },

      getNewProducts: function() {
        this.loadingState(true);
        var newPage = this.settings.page + 1;

        // No more pages, disable features
        if (newPage > this.settings.pageCount) {
          this.loadingState(false);
          this.state.loadedAllProducts = true;
          return;
        }

        var newUrl = this.settings.url + '?page=' + (newPage);

        $.get(newUrl, function(data) {
          var $template = $(data);
          var $newProducts = $template.find(selectors.collectionProductContainer + ' .grid-product');

          $(selectors.productContainer, this.$container).append($newProducts);
          this.ajaxSuccess();
        }.bind(this));
      },

      ajaxSuccess: function() {
        this.loadingState(false);
        this.settings.page = this.settings.page + 1;
        this.reInit();
      },

      forceReload: function() {
        this.onUnload();
        this.init();
      },

      // Only runs in the editor while a user is activating.
      // Rearranges quick shop modals to fix potentially broken layout
      onLoad: function() {
        theme.QuickShopScreens.reInit(this.$container);
      },

      onUnload: function() {
        $(window).off(this.namespace).trigger('resize');
        this.$scrollWrap.off(this.namespace);
        theme.QuickShopScreens.unload(this.$container);
      }

    });

    return FeaturedCollection;
  })();

  theme.Collection = (function() {
    var isAnimating = false;

    var classes = {
      tags: '.tags',
      activeTag: 'tag--active'
    };

    function Collection(container) {
      this.container = container;
      this.sectionId = $(container).attr('data-section-id');
      this.namespace = '.collection-' + this.sectionId;

      var hasHeroImage = $(container).find('.collection-hero').length;

      if (hasHeroImage) {
        this.checkIfNeedReload();
      } else if (theme.settings.overlayHeader) {
        theme.headerNav.disableOverlayHeader();
      }

      // Ajax pagination
      $(window).on('popstate', function(state) {
        if (state) {

          // Bail if it's a hash link
          if(location.href.indexOf(location.pathname) >= 0) {
            return true;
          }

          this.getNewCollectionContent(location.href);
        }
      }.bind(this));

      this.init();
    }

    Collection.prototype = $.extend({}, Collection.prototype, {
      init: function() {
        // init is called on load and when tags are selected
        this.$container = $(this.container);
        this.sectionId = this.$container.attr('data-section-id');

        new theme.HoverProductGrid(this.$container);
        this.sortBy();
        this.sortTags();
        this.initTagAjax();
      },

      initTagAjax: function() {
        this.$container.on('click' + this.namespace, '.tags a', function(evt) {
          var $el = $(evt.currentTarget);
          if ($el.hasClass('no-ajax')) {
            return;
          }

          evt.preventDefault();

          if (isAnimating) {
            return;
          }

          isAnimating = true;

          var newUrl = $el.attr('href');
          $(classes.tags).find('.' + classes.activeTag).removeClass(classes.activeTag);
          $el.parent().addClass(classes.activeTag);
          history.pushState({}, '', newUrl);
          $('.grid-product').addClass('unload');
          this.getNewCollectionContent(newUrl);
        }.bind(this));
      },

      getNewCollectionContent: function(url) {
        url = url + '?view=ajax';
        $('#CollectionAjaxResult').load(url + ' #CollectionAjaxContent', function() {
          isAnimating = false;
          this.reInit();
        }.bind(this));
      },

      sortBy: function() {
        var $sortBy = $('#SortBy');

        if (!$sortBy.length) {
          return;
        }

        $sortBy.on('change', function() {
          location.href = '?sort_by=' + $(this).val();
        });
      },

      sortTags: function() {
        var $sortTags = $('#SortTags');

        if (!$sortTags.length) {
          return;
        }

        $sortTags.on('change', function() {
          location.href = $(this).val();
        });
      },

      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function() {
        if (!Shopify.designMode) {
          return;
        }

        if (!theme.settings.overlayHeader) {
          return;
        }

        if (!$('.header-wrapper').hasClass('header-wrapper--overlay')) {
          location.reload();
        }
      },

      reInit: function() {
        sections.reinitSection('collection-template');

        theme.reinitProductGridItem();
      },

      forceReload: function() {
        this.onUnload();
        this.init();
      },

      onUnload: function() {
        $(window).off(this.namespace);
        this.$container.off(this.namespace);
      }

    });

    return Collection;
  })();

  theme.HeaderSection = (function() {

    function Header(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');

      this.initDrawers();
      theme.headerNav.init();
      theme.slideNav.init();

      // Reload any slideshow when the header is reloaded to make sure the
      // sticky header works as expected (it can be anywhere in the sections.instance array)
      sections.reinitSection('slideshow-section');
    }

    Header.prototype = $.extend({}, Header.prototype, {
      initDrawers: function() {
        if ($(document.body).hasClass('template-cart')) {
          new theme.AjaxCart('CartPage');
        } else if (theme.settings.cartType === 'drawer') {
          new theme.AjaxCart('CartDrawer');
        }
      },

      onUnload: function() {
        theme.headerNav.unload();
        theme.slideNav.unload();
      }
    });

    return Header;

  })();

  theme.FeaturedContentSection = (function() {

    function FeaturedContent() {
      $('.rte').find('a:not(:has(img))').addClass('text-link');
    }

    return FeaturedContent;
  })();

  theme.slideshows = {};

  theme.SlideshowSection = (function() {

    function SlideshowSection(container) {
      var $container = this.$container = $(container);
      var $section = $container.parent();
      var sectionId = $container.attr('data-section-id');
      var slideshow = this.slideshow = '#Slideshow-' + sectionId;

      var $imageContainer = $(container).find('.hero');
      if ($imageContainer.length) {
        theme.loadImageSection($imageContainer);
      }

      this.init();
    }

    SlideshowSection.prototype = $.extend({}, SlideshowSection.prototype, {
      init: function() {
        var args = {
          arrows: $(this.slideshow).data('arrows'),
          dots: $(this.slideshow).data('dots'),
          pauseOnHover: true
        };

        theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, args);
      },

      forceReload: function() {
        this.onUnload();
        this.init();
      },

      onUnload: function() {
        theme.slideshows[this.slideshow].destroy();
        delete theme.slideshows[this.slideshow];
      },

      onSelect: function() {
        $(this.slideshow).slick('slickPause');
      },

      onDeselect: function() {
        $(this.slideshow).slick('slickPlay');
      },

      onBlockSelect: function(evt) {
        var $slideshow = $(this.slideshow);

        // Ignore the cloned version
        var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');

        // Go to selected slide, pause autoplay
        $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
      },

      onBlockDeselect: function() {
        $(this.slideshow).slick('slickPlay');
      }
    });

    return SlideshowSection;
  })();

  theme.HeroAnimated = (function() {

    var classes = {
      active: 'animated__slide--active',
      inactive: 'animated__slide--inactive'
    }

    function HeroAnimated(container) {
      var $container = this.$container = $(container);
      var $section = $container.parent();
      var sectionId = $container.attr('data-section-id');
      var imageCount = $container.data('count');
      var namespace = '.hero-animated-' + sectionId;

      var $imageContainer = $(container).find('.hero');
      if ($imageContainer.length) {
        theme.loadImageSection($imageContainer);
      }
      this.$allImages = $container.find('.animated__slide');

      this.state = {
        active: false,
        activeIndex: 0
      };

      if (imageCount === 1) {
        this.setFades(true);
        return;
      }

      this.interval;
      this.intervalSpeed = $container.data('interval');
      this.maxIndex = imageCount - 1;

      slate.utils.promiseStylesheet().then(function() {
        this.checkVisibility();
        $(window).on('scroll' + namespace, $.throttle(300, this.checkVisibility.bind(this)));
      }.bind(this));
    }

    HeroAnimated.prototype = $.extend({}, HeroAnimated.prototype, {
      checkVisibility: function() {
        if (!theme.isElementVisible(this.$container)) {
          this.state.active = false;
          clearInterval(this.interval);
          return;
        }

        if (this.state.active) {
          return;
        }

        this.initInterval();
      },

      initInterval: function() {
        this.state.active = true;

        this.setFades(true);
        this.interval = setInterval(function() {
          this.setFades();
        }.bind(this), this.intervalSpeed);
      },

      setFades: function(first) {
        // Get next image index
        var nextIndex = this.state.activeIndex === this.maxIndex ? 0 : this.state.activeIndex + 1;

        if (first) {
          nextIndex = this.state.activeIndex;
        }

        // Unset existing image
        if (!first) {
          this.$allImages.eq(this.state.activeIndex)
            .removeClass(classes.active)
            .addClass(classes.inactive);
        }

        // Set next image as active
        this.$allImages.eq(nextIndex)
          .removeClass(classes.inactive)
          .addClass(classes.active);

        this.state.activeIndex = nextIndex;
      },

      onUnload: function() {
        clearInterval(this.interval);
      }
    });

    return HeroAnimated;
  })();

  theme.VideoSection = (function() {
    var youtubeReady;
    var videos = [];
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      },
      events: {
        onReady: onVideoPlayerReady,
        onStateChange: onVideoStateChange
      }
    };

    var vimeoReady = false;
    var vimeoVideoOptions = {
      byline: false,
      title: false,
      portrait: false,
      loop: true
    };

    var selectors = {
      videoParent: '.video-parent-section'
    };

    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    };

    function videoSection(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      var youtubePlayerId = this.youtubePlayerId = 'YouTubeVideo-' + this.sectionId;
      this.namespace = '.' + youtubePlayerId;
      var vimeoPlayerId = this.vimeoPlayerId = 'Vimeo-' + this.sectionId;
      var $vimeoTrigger = this.$vimeoTrigger = $('#VimeoTrigger-' + this.sectionId);
      var mp4Video = 'Mp4Video-' + this.sectionId;

      var $youtubeDiv = $('#' + youtubePlayerId);
      var $vimeoDiv = $('#' + vimeoPlayerId);
      var $mp4Div = $('#' + mp4Video);

      this.vimeoPlayer = [];

      if ($youtubeDiv.length) {
        this.youtubeVideoId = $youtubeDiv.data('video-id');
        this.initYoutubeVideo();
      }

      if ($vimeoDiv.length) {
        this.vimeoVideoId = $vimeoDiv.data('video-id');
        this.initVimeoVideo();
      }

      if ($mp4Div.length) {
        startMp4Playback(mp4Video).then(function() {
          // Video played as expected
          setParentAsLoaded($mp4Div);
        }).catch(function(error) {
          // Video cannot be played with autoplay, so let
          // user interact with video element itself
          setParentAsLoaded($mp4Div);
          setVideoToBeInteractedWith($mp4Div);
        })
      }
    }

    function startMp4Playback(mp4Video) {
      return document.querySelector('#' + mp4Video).play();
    }

    function onVideoPlayerReady(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target; // update stored player
      var player = youtubePlayers[playerId];

      setParentAsLoading($player);

      youtubePlayers[playerId].mute();

      // Remove from tabindex because YouTube iframes are annoying and you can focus
      // on the YouTube logo and it breaks
      $player.attr('tabindex', '-1');

      // Play video if in view
      slate.utils.promiseStylesheet().then(function() {
        videoVisibilityCheck(playerId);

        // Add out of view pausing
        $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
      });
    }

    function videoVisibilityCheck(id) {
      var playerId;

      if (!id) {
        return;
      }

      if (typeof id === 'string') {
        playerId = id;
      } else {
        // Data comes in as part of the scroll event
        if (id && id.data) {
          playerId = id.data.id;
        } else {
          return;
        }
      }

      if (theme.isElementVisible($('#' + playerId))) {
        playVisibleVideo(playerId);
      } else {
        pauseHiddenVideo(playerId);
      }
    }

    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }

    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }

    function onVideoStateChange(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];

      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }
          break;
        case 0: // ended
          player.playVideo();
          break;
        case 1: // playing
          setParentAsLoaded($player);
          break;
        case 3: // buffering
          videos[playerId].attemptedToPlay = true;
          break;
      }
    }

    function setParentAsLoading($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.loading);
    }

    function setParentAsLoaded($el) {
      $el
        .closest(selectors.videoParent)
        .removeClass(classes.loading)
        .addClass(classes.loaded);
    }

    function setVideoToBeInteractedWith($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.interactable);
    }

    videoSection.prototype = $.extend({}, videoSection.prototype, {
      initYoutubeVideo: function() {
        videos[this.youtubePlayerId] = {
          id: this.youtubePlayerId,
          videoId: this.youtubeVideoId,
          type: 'youtube',
          attemptedToPlay: false
        };

        if (!youtubeReady) {
          window.loadYouTube();
          $('body').on('youTubeReady' + this.namespace, this.loadYoutubeVideo.bind(this));
        } else {
          this.loadYoutubeVideo();
        }
      },

      loadYoutubeVideo: function() {
        var args = $.extend({}, youtubeVideoOptions, videos[this.youtubePlayerId]);
        args.playerVars.controls = 0;
        youtubePlayers[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, args);

        youtubeReady = true;
      },

      initVimeoVideo: function() {
        videos[this.vimeoPlayerId] = {
          divId: this.vimeoPlayerId,
          id: this.vimeoVideoId,
          type: 'vimeo'
        };

        var $player = $('#' + this.vimeoPlayerId);
        setParentAsLoading($player);

        // Button to play video on mobile
        this.$vimeoTrigger.on('click', + this.namespace, function(evt) {
          // $(evt.currentTarget).addClass('hide');
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        }.bind(this));

        if (!vimeoReady) {
          window.loadVimeo();
          $('body').on('vimeoReady' + this.namespace, this.loadVimeoVideo.bind(this));
        } else {
          this.loadVimeoVideo();
        }
      },

      loadVimeoVideo: function() {
        var args = $.extend({}, vimeoVideoOptions, videos[this.vimeoPlayerId]);
        this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(videos[this.vimeoPlayerId].divId, args);

        vimeoReady = true;

        // Only autoplay on larger screens
        if (!theme.config.bpSmall) {
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        } else {
          var $player = $('#' + this.vimeoPlayerId);
          setParentAsLoaded($player);
        }
      },

      requestToPlayVimeoVideo: function(id) {
        // The slider may initialize and attempt to play the video before
        // the API is even ready, because it sucks.

        if (!vimeoReady) {
          // Wait for the trigger, then play it
          $('body').on('vimeoReady' + this.namespace, function() {
            this.playVimeoVideo(id);
          }.bind(this))
          return;
        }

        this.playVimeoVideo(id);
      },

      playVimeoVideo: function(id) {
        this.vimeoPlayer[id].play();
        this.vimeoPlayer[id].setVolume(0);

        var $player = $('#' + id);
        setParentAsLoaded($player);
      },

      onUnload: function(evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        var playerId = 'YouTubeVideo-' + sectionId;
        if (youtubePlayers[playerId]) {
          youtubePlayers[playerId].destroy();
        }
        $(window).off('scroll' + this.namespace);
        $('body').off('vimeoReady' + this.namespace);
      }
    });

    return videoSection;
  })();

  theme.Testimonials = (function() {
    var slideCount = 0;
    var defaults = {
      accessibility: true,
      arrows: false,
      dots: true,
      autoplay: false,
      touchThreshold: 20,
      slidesToShow: 3,
      slidesToScroll: 3
    };

    function Testimonials(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      var wrapper = this.wrapper = '.testimonials-wrapper';
      var slider = this.slider = '#Testimonials-' + sectionId;
      var $slider = $(slider);

      this.sliderActive = false;
      var mobileOptions = $.extend({}, defaults, {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
      });

      slideCount = $slider.data('count');

      // Override slidesToShow/Scroll if there are not enough blocks
      if (slideCount < defaults.slidesToShow) {
        defaults.slidesToShow = slideCount;
        defaults.slidesToScroll = slideCount;
      }

      $slider.on('init', this.a11y.bind(this));

      if (theme.config.bpSmall) {
        this.init($slider, mobileOptions);
      } else {
        this.init($slider, defaults);
      }

      $('body').on('matchSmall', function() {
        this.init($slider, mobileOptions);
      }.bind(this));

      $('body').on('matchLarge', function() {
        this.init($slider, defaults);
      }.bind(this));
    }

    Testimonials.prototype = $.extend({}, Testimonials.prototype, {
      onUnload: function() {
        $(this.slider, this.wrapper).slick('unslick');
      },

      onBlockSelect: function(evt) {
        // Ignore the cloned version
        var $slide = $('.testimonials-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');

        // Go to selected slide, pause autoplay
        $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
      },

      init: function(obj, args) {
        if (this.sliderActive) {
          obj.slick('unslick');
          this.sliderActive = false;
        }

        obj.slick(args);
        this.sliderActive = true;

        if (AOS) {
          AOS.refresh();
        }
      },

      a11y: function(event, obj) {
        var $list = obj.$list;
        var $wrapper = $(this.wrapper, this.$container);

        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');

        // When an element in the slider is focused set aria-live
        $wrapper.on('focusin', function(evt) {
          if ($wrapper.has(evt.target).length) {
            $list.attr('aria-live', 'polite');
          }
        });

        // Remove aria-live
        $wrapper.on('focusout', function(evt) {
          if ($wrapper.has(evt.target).length) {
            $list.removeAttr('aria-live');
          }
        });
      }
    });

    return Testimonials;
  })();

  theme.NewsletterPopup = (function() {
    function NewsletterPopup(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      this.cookieName = 'newsletter-' + sectionId;

      if (!$container.length) {
        return;
      }

      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }

      this.data = {
        secondsBeforeShow: $container.data('delay-seconds'),
        daysBeforeReappear: $container.data('delay-days'),
        cookie: Cookies.get(this.cookieName),
        testMode: $container.data('test-mode')
      };

      this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');

      // Open modal if errors or success message exist
      if ($container.find('.errors').length || $container.find('.note--success').length) {
        this.modal.open();
      }

      // Set cookie as opened if success message
      if ($container.find('.note--success').length) {
        this.closePopup(true);
        return;
      }

      $('body').on('modalClose.' + $container.attr('id'), this.closePopup.bind(this));

      if (!this.data.cookie || this.data.testMode) {
        this.initPopupDelay();
      }
    }

    NewsletterPopup.prototype = $.extend({}, NewsletterPopup.prototype, {
      initPopupDelay: function() {
        setTimeout(function() {
          this.modal.open();
        }.bind(this), this.data.secondsBeforeShow * 1000);
      },

      closePopup: function(success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode) {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }

        var expiry = success ? 200 : this.data.daysBeforeReappear;

        Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
      },

      onLoad: function() {
        this.modal.open();
      },

      onSelect: function() {
        this.modal.open();
      },

      onDeselect: function() {
        this.modal.close();
      },

      onUnload: function() {}
    });

    return NewsletterPopup;
  })();

  theme.Maps = (function() {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];

    var errors = {
      addressNoResults: theme.strings.addressNoResults,
      addressQueryLimit: theme.strings.addressQueryLimit,
      addressError: theme.strings.addressError,
      authError: theme.strings.authError
    };

    var selectors = {
      section: '[data-section-type="map"]',
      map: '[data-map]',
      mapOverlay: '[data-map-overlay]'
    };

    var classes = {
      mapError: 'map-section--load-error',
      errorMsg: 'map-section__error errors text-center'
    };

    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function() {
      if (!Shopify.designMode) {
        return;
      }

      $(selectors.section).addClass(classes.mapError);
      $(selectors.map).remove();
      $(selectors.mapOverlay).after(
        '<div class="' +
          classes.errorMsg +
          '">' +
          theme.strings.authError +
          '</div>'
      );
    };

    function Map(container) {
      this.$container = $(container);
      this.sectionId = this.$container.attr('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.$map = this.$container.find(selectors.map);
      this.key = this.$map.data('api-key');

      if (!this.key) {
        return;
      }

      // Lazyload API
      this.checkVisibility();
      $(window).on('scroll' + this.namespace, $.throttle(50, this.checkVisibility.bind(this)));
    }

    function initAllMaps() {
      // API has loaded, load all Map instances in queue
      $.each(mapsToLoad, function(index, instance) {
        instance.createMap();
      });
    }

    function geolocate($map) {
      var deferred = $.Deferred();
      var geocoder = new google.maps.Geocoder();
      var address = $map.data('address-setting');

      geocoder.geocode({ address: address }, function(results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          deferred.reject(status);
        }

        deferred.resolve(results);
      });

      return deferred;
    }

    Map.prototype = $.extend({}, Map.prototype, {
      prepMapApi: function() {
        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);

          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined' ) {
              $.getScript(
                'https://maps.googleapis.com/maps/api/js?key=' + this.key
              ).then(function() {
                apiStatus = 'loaded';
                initAllMaps();
              });
            }
          }
        }
      },

      createMap: function() {
        var $map = this.$map;

        return geolocate($map)
          .then(
            function(results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: 'none',
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };

              var map = (this.map = new google.maps.Map($map[0], mapOptions));
              var center = (this.center = map.getCenter());

              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });

              google.maps.event.addDomListener(
                window,
                'resize',
                $.debounce(250, function() {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  $map.removeAttr('style');
                })
              );
            }.bind(this)
          )
          .fail(function() {
            var errorMessage;

            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }

            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              $map
                .parent()
                .addClass(classes.mapError)
                .html(
                  '<div class="' +
                    classes.errorMsg +
                    '">' +
                    errorMessage +
                    '</div>'
                );
            }
          });
      },

      checkVisibility: function() {
        if (theme.isElementVisible(this.$container, 600)) {
          this.prepMapApi();
          $(window).off(this.namespace);
        }
      },

      onUnload: function() {
        if (this.$map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        google.maps.event.clearListeners(this.map, 'resize');
      }
    });

    return Map;
  })();

  theme.Blog = (function() {

    function Blog(container) {
      this.tagFilters();
    }

    Blog.prototype = $.extend({}, Blog.prototype, {
      tagFilters: function() {
        var $filterBy = $('#BlogTagFilter');

        if (!$filterBy.length) {
          return;
        }

        $filterBy.on('change', function() {
          location.href = $(this).val();
        });
      },

      onUnload: function() {

      }
    });

    return Blog;
  })();

  theme.Photoswipe = (function() {
    var selectors = {
      trigger: '.product__photo-zoom',
      images: '.photoswipe__image',
      activeImage: '.slick-active .photoswipe__image'
    };

    function Photoswipe($container, sectionId) {
      this.$container = $container;
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.$images;
      this.inSlideshow = false;

      if ($container.attr('data-zoom') === 'false') {
        return;
      }

      if ($container.attr('data-has-slideshow') === 'true') {
        this.inSlideshow = true;
      }

      this.init();
    }

    Photoswipe.prototype = $.extend({}, Photoswipe.prototype, {
      init: function() {
        var $trigger = this.$container.find(selectors.trigger);
        this.$images = this.$container.find(selectors.images);
        var items = [];

        // Init gallery on active image
        $trigger.on('click' + this.namespace, function(evt) {
          items = this.getImageData();
          if (this.inSlideshow || theme.config.bpSmall) {
            var index = this.$container.find(selectors.activeImage).data('index');
          } else {
            var index = $(evt.currentTarget).data('index');
          }
          this.initGallery(items, index);
        }.bind(this));
      },

      getImageData: function() {
        var haveImages = false;
        var items = [];
        var options = {};

        this.$images.each(function() {
          var haveImages = true;
          var smallSrc = $(this).prop('currentSrc') || $(this).prop('src');
          var item = {
            msrc: smallSrc,
            src: $(this).data('photoswipe-src'),
            w: $(this).data('photoswipe-width'),
            h: $(this).data('photoswipe-height'),
            el: $(this)[0],
            initialZoomLevel: 0.5
          };

          items.push(item);
        });

        return items;
      },

      initGallery: function(items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];

        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: 'zoom',
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function(index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
          }
        }

        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

        this.gallery.init();
        this.gallery.listen('afterChange', this.afterChange.bind(this));

        // If need to destroy it
        // this.gallery.destroy();
      },

      afterChange: function() {
        if (this.inSlideshow) {
          var $slideshow = $('#ProductPhotos-' + this.sectionId);
          if ($slideshow.hasClass('slick-initialized')) {
            var newIndex = this.gallery.getCurrentIndex();
            $slideshow.slick('slickGoTo', newIndex);
          }
        }
      }
    });

    return Photoswipe;
  })();



  // Breakpoint values are used throughout many templates.
  // We strongly suggest not changing them globally.
  theme.bp = {};
  theme.bp.smallUp = 769;
  theme.bp.small = theme.bp.smallUp - 1;

  theme.config = {
    cssLoaded: false,
    bpSmall: false,
    hasSessionStorage: true,
    mediaQuerySmall: 'screen and (max-width: '+ theme.bp.small +'px)',
    mediaQuerySmallUp: 'screen and (min-width: '+ theme.bp.smallUp +'px)',
    youTubeReady: false,
    vimeoReady: false,
    vimeoLoading: false,
    isSafari: !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/),
    isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false
  };

  window.onYouTubeIframeAPIReady = function() {
    theme.config.youTubeReady = true;
    $('body').trigger('youTubeReady');
  };

  window.loadYouTube = function() {
    if (theme.config.youtubeReady) {
      return;
    }

    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  };

  window.loadVimeo = function() {
    if (theme.config.vimeoLoading) {
      return;
    }

    if (!theme.config.vimeoReady) {
      theme.config.vimeoLoading = true;
      var tag = document.createElement('script');
      tag.src = "https://player.vimeo.com/api/player.js";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // Because there's no way to check for the Vimeo API being loaded
      // asynchronously, we use this terrible timeout to wait for it being ready
      checkIfVimeoIsReady()
        .then(function() {
          theme.config.vimeoReady = true;
          theme.config.vimeoLoading = false;
          $('body').trigger('vimeoReady');
        })
        .fail(function() {
          // No vimeo API to talk to
        });
    }
  };

  function checkIfVimeoIsReady() {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (!Vimeo) {
        return;
      }

      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  };

  theme.init = function() {
    theme.setGlobals();
    theme.pageTransitions();
    theme.QuickShopScreens.init();
    theme.articleImages.init();
    theme.collapsibles.init();
    if (theme.settings.cartType === 'sticky') {
      new theme.StickyCart();
    }
    theme.customerTemplates.init();
    if (theme.settings.currenciesEnabled) {
      theme.currencySwitcher.init();
    }
    theme.videoModal();
    slate.rte.init();

    $(document.documentElement).on('keyup.tab', function(evt) {
      if (evt.keyCode === 9) {
        $(document.documentElement).addClass('tab-outline');
        $(document.documentElement).off('keyup.tab');
      }
    });
  };

  theme.setGlobals = function() {
    theme.config.hasSessionStorage = theme.isSessionStorageSupported();

    if (theme.config.isTouch) {
      $('body').addClass('supports-touch');
    }

    enquire.register(theme.config.mediaQuerySmall, {
      match: function() {
        theme.config.bpSmall = true;
        $('body').trigger('matchSmall');
      },
      unmatch: function() {
        theme.config.bpSmall = false;
        $('body').trigger('unmatchSmall');
      }
    });

    enquire.register(theme.config.mediaQuerySmallUp, {
      match: function() {
        $('body').trigger('matchLarge');
      },
      unmatch: function() {
        $('body').trigger('unmatchLarge');
      }
    });
  };

  theme.loadImageSection = function($container) {
    // Wait until images inside container have lazyloaded class
    function setAsLoaded() {
      $container.removeClass('loading').addClass('loaded');
    }

    function checkForLazyloadedImage() {
      return $container.find('.lazyloaded').length;
    }

    // If it has SVGs it's in the onboarding state so set as loaded
    if ($container.find('svg').length) {
      setAsLoaded();
      return;
    };

    if (checkForLazyloadedImage() > 0) {
      setAsLoaded();
      return;
    }

    var interval = setInterval(function() {
      if (checkForLazyloadedImage() > 0) {
        clearInterval(interval);
        setAsLoaded();
      }
    }, 80);
  }

  theme.isSessionStorageSupported = function() {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage = window.sessionStorage;
    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.isElementVisible = function($el, threshold) {
    var rect = $el[0].getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    threshold = threshold ? threshold : 0;

    return (
      rect.bottom >= (0 - (threshold / 1.5)) &&
      rect.right >= 0 &&
      rect.top <= (windowHeight + threshold) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  theme.pageTransitions = function() {
    if ($('body').data('transitions') == true) {

      // Hack test to fix Safari page cache issue.
      // window.onpageshow doesn't always run when navigating
      // back to the page, so the unloading class remains, leaving
      // a white page. Setting a timeout to remove that class when leaving
      // the page actually finishes running when they come back.
      if (theme.config.isSafari) {
        $('a').on('click', function() {
          window.setTimeout(function() {
            $('body').removeClass('unloading');
          }, 1200);
        });
      }

      // Add disable transition class to malito, anchor, and YouTube links
      $('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"]').each(function() {
        $(this).addClass('js-no-transition');
      });

      $('a:not(.js-no-transition)').bind('click', function(evt) {
        if (evt.metaKey || evt.ctrlKey) return true;

        var src = $(this).attr('href');

        // Bail if it's a hash link
        if(src.indexOf(location.pathname) >= 0) {
          return true;
        }

        evt.preventDefault();
        $('body').addClass('unloading');
        window.setTimeout(function() {
          location.href = src;
        }, 50);
      });
    }
  };

  window.onpageshow = function(evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      $('body').removeClass('unloading');
    }
  };

  theme.initSecondary = function() {
    document.body.classList.add('js-animate');
    AOS.init({
      easing: 'ease-out-quad',
      once: false,
      mirror: true,
      offset: 100,
      disableMutationObserver: true
    });

    document.addEventListener('lazyloaded', function(evt) {
      var $img = $(evt.target);
      if ($img.length) {
        $img.parent().addClass('loaded');
      }

      //trigger hero section transitions on initial page load
      const wrapper = $('.custom-home-capsules-block-content');
      if(wrapper.length === 0) return;

      wrapper.trigger('heroLoaded');
    });

    document.dispatchEvent(new CustomEvent('page:loaded'));

    theme.reviewAppLinkListener();
    theme.checkForAnchorLink();
  };

  theme.reviewAppLinkListener = function() {
    $('body').on('click', '.spr-pagination', function() {
      var $scroller = $(this).closest('.spr-reviews').scrollLeft(0);
    });
  };

  theme.checkForAnchorLink = function() {
    if(window.location.hash) {
      var $el = $(window.location.hash);
      if ($el.length) {
        var top = $el.offset().top - 100;
        if (top > 0) {
          window.scroll(0, top);
        }
      }
    }
  };

  theme.reinitProductGridItem = function($scope) {
    if (AOS) {
      AOS.refreshHard();
    }

    // Refresh currency
    if (theme.settings.currenciesEnabled) {
      theme.currencySwitcher.ajaxrefresh();
    }

    // Refresh reviews app
    if (window.SPR) {
      SPR.initDomEls();SPR.loadBadges();
    }

    // Re-register product templates in quick view modals.
    // Will not double-register.
    // theme.initQuickShop(true);
    // sections.register('product-template', theme.Product, $scope);

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();
  };

  $(document).ready(function() {
    theme.init();

    // Init CSS-dependent scripts
    slate.utils.promiseStylesheet().then(function() {
      theme.initSecondary();
    });

    window.sections = new theme.Sections();
    sections.register('header-section', theme.HeaderSection);
    sections.register('slideshow-section', theme.SlideshowSection);
    sections.register('hero-animated', theme.HeroAnimated);
    sections.register('video-section', theme.VideoSection);
    sections.register('product', theme.Product);
    sections.register('product-recommendations', theme.Recommendations);
    sections.register('product-template', theme.Product);
    sections.register('featured-collection', theme.FeaturedCollection);
    sections.register('collection-template', theme.Collection);
    sections.register('featured-content-section', theme.FeaturedContentSection);
    sections.register('testimonials', theme.Testimonials);
    sections.register('newsletter-popup', theme.NewsletterPopup);
    sections.register('map', theme.Maps);
    sections.register('blog', theme.Blog);
  });


  // *******************************************  BUNDLE SCRIPTS ******************************************************/

  $('.variant-wrapper.customize').insertAfter('.bundle-type .product-single__meta');
  $('.bundle-type .variant-wrapper.customize').show();

  // Bundle swatch changer
  $('input[type=radio][data-radio-type=swatch]').change(function () {
      var bundleRow = $(this).closest('.label-row');
      var swatchColor = $(this).val();
      var swatchProductImage = $(this).data('image-url');
      console.log(swatchProductImage);
      bundleRow.find('.color-line-item').val(swatchColor);
      bundleRow.find('.hex-area svg').removeClass().addClass(swatchColor);
      bundleRow.find('.single-product-image img').attr('src', swatchProductImage).attr('srcset', swatchProductImage);
  });



  // Single Product Swatch Color changer
  $('.color-swatch-dropdown').change(function () {
      // console.log('change');
      var swatchColor = $('option', this).val();
      // console.log(swatchColor);
      $('.hex-area svg').removeClass().addClass(swatchColor);
  });


  // UPdate Colors On load
  var swatchColor = $('.color-swatch-dropdown option:selected').val();
  $('.hex-area svg').removeClass().addClass(swatchColor);



  /***************** COLOR SWATCH DROP DOWN ***************************/
  typeof Selectize != 'undefined' && $('.color-swatch-dropdown').selectize({

      create: true,
      sortField: 'text',

      render: {
          option: function (data, escape) {
              return '<div class="option"  data-selectable="" data-basecolor="' + data.basecolor + '" data-value="' + data.value + '">' + data.value + '</div>'

          },
          item: function (data, escape) {
              return '<div class="item" data-value="' + data.value + '" data-basecolor="' + data.basecolor + '">' + data.value + '</div>'
          }
      }

  });

  /**************** GIFT Card Scripts *****************************/


  function getGiftCardLabels(input) {
      var labelDest = $(input).data('location');
      var label = $(input).val();
      var selector = $('.giftcardSVG text[data-location="' + labelDest + '"]');
      console.log(selector);
      $(selector).text(label);
  }

  $('.gift-option').on('keyup', function () {
      getGiftCardLabels(this);
  });

  $('.gift-card-type .variant-input input').change(function () {
      var value = $(this).val();
      console.log(value);
      $('.giftcardSVG text[data-location="amount"]').text(value);
  });





  // ADD MINIS TO CART
  var miniID = $('.progress-bar').data('free-item-id');
  var miniVariantID = $('.progress-bar').data('free-item-variant-id');

  //console.log(miniID,miniVariantID);

  function addFreeMinis() {
      theme.cart.getCart().then(function (cart) {
          var currentCartItems = cart.items;
          //console.log(currentCartItems);

          function getMiniCount() {
              var miniCount = 0;
              $(currentCartItems).each(function (index, value) {
                  //  console.log(index, value);
                  var prodID = value.product_id;
                  var prodQty = parseInt(value.quantity);
                  // console.log(prodID);
                  if (prodID === miniID) {
                      miniCount = value.quantity;
                      // console.log('Mini Count is', miniCount);
                  }
              });
              return miniCount;
          }

          function getProductCount() {
              var productCount = 0;
              var miniCount = 0;
              $(currentCartItems).each(function (index, value) {
                  // console.log(index, value);
                  var prodID = value.product_id;
                  var prodType = value.product_type;
                  //console.log(prodType);
                  var prodQty = parseInt(value.quantity);
                  if (prodType == 'Single Unit') {
                      productCount = productCount + prodQty;
                      // console.log('Count is', productCount);
                  }
              });

              return productCount;
          }
          //console.log(getMiniCount());
          //console.log(getProductCount());
          if (getMiniCount() < 1 && getProductCount() > 1) {
              // console.log('we have ', getProductCount());
              var data = {
                  quantity: 2,
                  id: miniVariantID,
                  properties: {
                      'Offer': 'Free Item'
                  }
              }
              //console.log('add minis');
              theme.cart.addItemFromForm(data);
          }
          if (getMiniCount() == 1 && getProductCount() > 1) {
              // console.log('we have ', getProductCount());
              var data = {
                  quantity: 1,
                  id: miniVariantID,
                  properties: {
                      'Offer': 'Free Item'
                  }
              }
              // console.log('add minis');
              theme.cart.addItemFromForm(data);
          }
      });
  }
  // END ADD FREE MINIS FUNCTION - AUTOMATICALLY ADDS MINIS TO CART

  // FREE MINIS POPUP FUNCTION
  function freeMiniPopup(cart) {
      const currentCartItems = cart.items;

      function getMiniCount() {
        let miniCount = 0;
        $(currentCartItems).each(function (index, value) {
            const prodID = value.product_id;
            if (prodID === miniID) {
                miniCount = value.quantity;
            }
        });
        return miniCount;
      }

      function getProductCount() {
          let productCount = 0;
          $(currentCartItems).each(function (index, value) {
              const prodType = value.product_type;
              const prodQty = parseInt(value.quantity);
              if (prodType == 'Single Unit') {
                  productCount = productCount + prodQty;
              }
          });
          return productCount;
      }
      if (getMiniCount() < 2 && getProductCount() > 1) {
          $('#freeGiftPopup').fadeIn(500);
          $('#freeGiftPopup .premade-labels').show();
      }
  }
  // END FREE MINIS POPUP FUNCTION


  // GOAL FUNCTION / PROGRESS BAR FUNCTIONS
  function goalTracker(cart) {
      const goalNeeded = $('.progress-bar').data('qualify-count');
      const goalText = $('.progress-bar').data('goal-text');
      const goalBeforeText = $('.progress-bar').data('qualify-before-text');
      const goalAfterText = $('.progress-bar').data('qualify-after-text');
      const goalBeforeText2 = $('.progress-bar').data('qualify-before-text2');
      const goalAfterText2 = $('.progress-bar').data('qualify-after-text2');

      const currentCartItems = cart.items;

      function getMiniCount() {
          let miniCount = 0;
          $(currentCartItems).each(function (index, value) {
              const prodID = value.product_id;
              if (prodID === miniID) {
                  miniCount = value.quantity;
              }
          });
          return miniCount;
      }

      function getProductCount() {
          let productCount = 0;
          $(currentCartItems).each(function (index, value) {
              const prodType = value.product_type;
              const prodQty = parseInt(value.quantity);
              if (prodType == 'Single Unit') {
                  productCount = productCount + prodQty;
              }
          });
          return productCount;
      }

      const itemsLeft = goalNeeded - getProductCount();
      if (getProductCount() == 1) {
          $('.progress-bar').removeClass().addClass('progress-bar goal-' + itemsLeft + '').html('<span class="text">' + goalBeforeText2 + ' ' + itemsLeft + ' ' + goalAfterText2 + '</span>');
      } else if (getProductCount() < goalNeeded) {
          $('.progress-bar').removeClass().addClass('progress-bar goal-' + itemsLeft + '').html('<span class="text">' + goalBeforeText + ' ' + itemsLeft + ' ' + goalAfterText + '</span>');
      } else {
          $('.progress-bar').removeClass().addClass('progress-bar').html('<span class="text">' + goalText + '</span>');
      }
  }
  // END GOAL TRACKER FUNCTION

  // FREE SHIPPING GOAL FUNCTION / PROGRESS BAR FUNCTIONS
  function freeShipProgress(cart) {
    const container = $('#CartDrawer .free-ship-progress-area');
    const goalNeeded = container.data('amount-needed');
    const lockedMessage = container.data('locked-message');

    const currentCartItems = cart.items;

    var autoFreeShipping = false;
    var allPresaleItems = false;

    // function getProductCount() {
    //   let productCount = 0;
    //   $(currentCartItems).each(function (index, value) {
    //     const prodType = value.product_type;
    //     const prodQty = parseInt(value.quantity);
    //     // SPATULACODE
    //     const presaleItem = value.sku.includes('spatula');
    //     if (prodType != 'Label') {
    //       productCount = productCount + prodQty;
    //     }
    //     if (!presaleItem) {
    //       allPresaleItems = false;
    //     }
        
    //     const freeShippingItem = value.handle.includes('the-132-set-of-4-sm');
    //     if(freeShippingItem){
    //       autoFreeShipping = true;
    //     }
    //   });
    //   return productCount;
    // }
    
    // const productsCount = getProductCount();

    const percentage = Math.min(cart.original_total_price * 100 / goalNeeded, 100);
    $('#CartDrawer .free-ship-progress-area .progress').css('width', `${percentage}%`)
    $('#CartDrawer .free-ship-progress-area').show();
    
    if(autoFreeShipping){
      // show this when we're automatically offering free shipping because of some items in their cart!
      $('#CartDrawer .free-ship-progress-area .goal-text').hide();
      $('#CartDrawer .free-ship-progress-area .goal-text-achived').show();
      $('#CartDrawer .free-ship-progress-area .progress').css('width', `100%`)
      
    }else if (percentage < 100) {
      const amountLeft = goalNeeded - cart.original_total_price;
      const message_str = lockedMessage.replace('n_amount', theme.Currency.formatMoney(amountLeft, theme.settings.moneyFormat).replace('.00', ''))
      $('#CartDrawer .free-ship-progress-area .goal-text').text(message_str);
      $('#CartDrawer .free-ship-progress-area .goal-text').show();
      $('#CartDrawer .free-ship-progress-area .goal-text-achived').hide();
    } else {
      $('#CartDrawer .free-ship-progress-area .goal-text').hide();
      $('#CartDrawer .free-ship-progress-area .goal-text-achived').show();
    }
    
    //if all items are presale items, hide the shipping progress
    $('#CartDrawer .free-ship-progress-area').show();
    $('#CartDrawer').removeClass('all-presale-items');
    if(allPresaleItems){
      console.log('all items are presale');
      $('#CartDrawer .free-ship-progress-area').hide();
      $('#CartDrawer').addClass('all-presale-items');
    }

    //  // 15OFFSITEWIDE -- SECONDARYGOAL HERE
    //   var secondaryGoalNeeded = 12500;
    //   var percentageSecondaryGoal = Math.min(cart.total_price * 100 / secondaryGoalNeeded, 100);
    //   if(percentageSecondaryGoal < 100) {
    //     const amountLeft = secondaryGoalNeeded - cart.original_total_price;
    //     const message_str = `Free shipping unlocked! Add ${theme.Currency.formatMoney(amountLeft, theme.settings.moneyFormat
    //     ).replace('.00', '')} for 15% off!`;
    //     $('#CartDrawer .free-ship-progress-area .goal-text').text(message_str);
    //     $('#CartDrawer .free-ship-progress-area .goal-text').show();
    //     $('#CartDrawer .free-ship-progress-area .goal-text-achived').hide();
    //     $('#CartDrawer .free-ship-progress-area .progress').css('width', `${percentageSecondaryGoal
    //     }%`);
    //   } else {
    //     var message_str2 = `Your order qualifies for free shipping and 15% off!`;
    //     $('#CartDrawer .free-ship-progress-area .goal-text').text(message_str2);
    //     $('#CartDrawer .free-ship-progress-area .goal-text').show();

        
    //     $('#CartDrawer .free-ship-progress-area .progress').css('background-color', '#4d6648');
    //     // REMOVE THIS WHEN WE'RE DONE WITH THE SALE
    //     // $('#CartDrawer .free-ship-progress-area .goal-text-achived').show();
    //     $('#CartDrawer .free-ship-progress-area .goal-text-achived').hide();
    //   }


  }

  function holidayPromoMiniParcel(cart) {    
    const currentCartItems = cart.items;

    const cartCurrency = cart.currency || 'USD';
    if(cartCurrency !== 'USD') return;

    let qualifiesForMiniParcel = false;
    let miniParcelQuantity = 0;
    let miniParcelKeys = [];
    let cartTotal = cart.original_total_price || 0;

    //determine if there is a parcel already in the cart first
    currentCartItems.forEach(item => {
      if(item.variant_id === 41935438512213){        
        miniParcelQuantity += item.quantity;
        miniParcelKeys.push(item.key);
      }
    });

    if(miniParcelQuantity > 0){
      cartTotal -= miniParcelQuantity * 45;
    }
    // console.log('cart total without mini parcel included, if at all: ', cartTotal);

    if(cartTotal >= 50000 ){
      qualifiesForMiniParcel = true;
    }
    // console.log('miniParcelQuantity: ', miniParcelQuantity);
    // console.log('miniParcelKeys: ', miniParcelKeys);
    // console.log('total price: ', cartTotal);
    // console.log('qualifiesForMiniParcel: ', qualifiesForMiniParcel);

    //if it qualifies for the mini parcel and there is no mini parcel in their cart, we need to add it
    if(qualifiesForMiniParcel && miniParcelQuantity == 1){
      // console.log('mini parcel already in cart');
    }else if(qualifiesForMiniParcel && miniParcelQuantity < 1){
      // console.log('QUALIFIES: adding mini parcel to the cart');
      //add the mini parcel to the cart
        var data = {
          quantity: 1,
          id: 41935438512213,
          properties: {
              '_isgift': 'true',
              '_promocode': 'Holiday_auto',
              '_gift_tag': 'mini_parcel'
          }
      }
      theme.cart.addItemFromForm(data);
    }else if(qualifiesForMiniParcel && miniParcelQuantity > 1){
      let firstMiniParcelKey = miniParcelKeys[0];
      // console.log('QUALIFIES: removing extra mini parcel from the cart, keep just 1 in the first instance of the cart that we found', firstMiniParcelKey);
      miniParcelKeys.forEach(key => {
        if(key == firstMiniParcelKey){
          theme.cart.changeItem(key, 1);
        }else{
          theme.cart.changeItem(key, 0);
        }
      });
    }else if(!qualifiesForMiniParcel && miniParcelQuantity > 0 && miniParcelKeys.length > 0){
      //remove the mini parcel from the cart
      // console.log('DOES NOT QUALIFY: removing mini parcel from the cart');
      miniParcelKeys.forEach(key => {
        theme.cart.changeItem(key, 0);
      });
    }
  }

  function holidayPromoProgress(cart) {
    // HOLIDAY2024TIERPRICING  
    // Get data from any container (works for both CartDrawer and announcement bar)
    const container = $('.holiday-promo-bar-container').first();
    const goal1Needed = container.data('amount-needed-tier1');
    const goal2Needed = container.data('amount-needed-tier2');
    const goal3Needed = container.data('amount-needed-tier3');

    const currentCartItems = cart.items;
    // console.log({goal1Needed}); 
    //full percentage
    // const percentage = Math.min(cart.total_price * 100 / goal3Needed, 100);

    // TIEREDPROMOS - Now break them down by tiers and set the tier-0, tier-1, tier-2, tier-3 active
    
    //remove the active tiers active from all four 
    $('.holiday-promo-bar-container .tier').removeClass('active');
    $('.holiday-promo-bar-container .tier').removeClass('achieved');
    
    // TIEREDPROMOS - Tier 0 (10% off) is always active by default

    let percentage = 0;

    //now activate each tier
    if(cart.original_total_price >= goal3Needed){
      // Tier 3: 25% off at $500+
      $('.holiday-promo-bar-container .tier.tier-0, .holiday-promo-bar-container .tier.tier-1, .holiday-promo-bar-container .tier.tier-2').addClass('achieved');
      $('.holiday-promo-bar-container .tier.tier-3').addClass('active');

      $('.holiday-promo-bar-container .promo-message').html(`You've unlocked <b>25% off</b> and free gift!`);
      $('.announcement-promo-message').html(`You've unlocked <b>25% off</b> and free gift!`);
      percentage = 100;

    }else if(cart.original_total_price >= goal2Needed){
      // Tier 2: 20% off at $300
      // Progress bar: 50% to 75% (between $300 and $500)
      $('.holiday-promo-bar-container .tier.tier-0, .holiday-promo-bar-container .tier.tier-1').addClass('achieved');
      $('.holiday-promo-bar-container .tier.tier-2').addClass('active');
      let amountLeft = theme.Currency.formatMoney(goal3Needed - cart.original_total_price, theme.settings.moneyFormat).replace('.00', '');
      $('.holiday-promo-bar-container .promo-message').html(`You're ${amountLeft} from <b>25% off and free gift</b>`);
      $('.announcement-promo-message').html(`You're ${amountLeft} from <b>25% off and free gift</b>`);
      percentage = 50 + ((cart.original_total_price - goal2Needed) / (goal3Needed - goal2Needed)) * 25;

    }else if(cart.original_total_price >= goal1Needed){
      // Tier 1: 15% off at $200
      // Progress bar: 25% to 50% (between $200 and $300)
      $('.holiday-promo-bar-container .tier.tier-0').addClass('achieved');
      $('.holiday-promo-bar-container .tier.tier-1').addClass('active');
      let amountLeft = theme.Currency.formatMoney(goal2Needed - cart.original_total_price, theme.settings.moneyFormat).replace('.00', '');
      $('.holiday-promo-bar-container .promo-message').html(`You're ${amountLeft} from <b>20% off your order</b>`);
      $('.announcement-promo-message').html(`You're ${amountLeft} from <b>20% off your order</b>`);
      percentage = 25 + ((cart.original_total_price - goal1Needed) / (goal2Needed - goal1Needed)) * 25;

    }else{
      // Tier 0: 10% off (default - always active)
      // Progress bar: 0% to 25% (between $0 and $200)
      $('.holiday-promo-bar-container .tier.tier-0').addClass('active');
      let amountLeft = theme.Currency.formatMoney(goal1Needed - cart.original_total_price, theme.settings.moneyFormat).replace('.00', '');
      $('.holiday-promo-bar-container .promo-message').html(`You're ${amountLeft} from <b>15% off your order</b>`);
      // For tier 0, show "Save up to 25% off" in the main announcement text
      
      
      //if they're at zero dollars, show Save up to 25%, else show the same as above, how much they have left
      if(cart.original_total_price === 0){
        $('.announcement-promo-message').html(`Save up to 25%`);
      }else{
        $('.announcement-promo-message').html(`You're ${amountLeft} from <b>15% off your order</b>`);
      }

      percentage = (cart.original_total_price / goal1Needed) * 25;
    }

    // Update progress bar width for ALL instances (CartDrawer and announcement bar)
    $('.holiday-promo-bar-container .progress').css('width', `${percentage}%`)
    $('#CartDrawer .holiday-promo-bar-container').show();

    //now go through the remaining prices in the site and show/hide the right ones

    var cart_total = cart.original_total_price;
    if(isNaN(cart_total)) cart_total = 0;
    //go through each of the elements tiered-pricing-container, check the current cart total against the data-price attribute, then show the appropriate price

    $('.tiered-pricing-container').each(function(){
      var price = $(this).data('price');
      //if price is not an integer or a number, set it to 0
      if(isNaN(price)) price = 0;
      var handle = $(this).data('product-handle');
      var total_price_with_this_item = parseInt(cart_total) + parseInt(price);
      $(this).find('.tiered-pricing').hide();

      var full_container_content = false;
      var show_discount_savings = false;
      if($(this).hasClass('holiday-offer')){
        // $(this).hide();
        full_container_content = true;
        show_discount_savings = true;
      }
      
      if(total_price_with_this_item >= goal3Needed){
        $(this).find('.tier-3-price').show();
        show_discount_savings = true;
        // console.log('post-update activating tier-3-price for product', handle)
      } else if(total_price_with_this_item >= goal2Needed){
        $(this).find('.tier-2-price').show();
        show_discount_savings = true;
        // console.log('post-update activating tier-2-price for product', handle)
      } else if(total_price_with_this_item >= goal1Needed){
        $(this).find('.tier-1-price').show();
        show_discount_savings = true;
        // console.log('post-update activating tier-1-price for product', handle)
      } else {
        $(this).find('.tier-0-price').show();
        // console.log('post-update activating tier-0-price for product', handle)
      }
      if (full_container_content && show_discount_savings){
        $(this).show();
      }
      
    });
  }
  
  // END FREE SHIPPING GOAL FUNCTION

  // Free capsule
  function freeCapsuleProgress(cart) {
    const container = $('.free-capsule-progress-area');
    const bundlesCostNeeded = parseInt(container.data('cost-needed'), 10);
    const capsulesQtyNeeded = parseInt(container.data('capsules-needed'), 10);
    const capsuleProductId = container.data('capsule-id');
    let freeCapsules = 0, capsulesInCart = 0, progress = 0, validBundles = 0;

    cart.items.forEach(item => {
      const parsedPrice = item.price / 100 + 1;

      // bundles
      if (parsedPrice > bundlesCostNeeded) {
        validBundles += item.quantity;
      // capsules (not discounted only)
      } else if (item.product_id === capsuleProductId && item.discounted_price > 0) {
        capsulesInCart += item.quantity;
      }
    });

    freeCapsules = parseInt(capsulesInCart / capsulesQtyNeeded, 10) + validBundles;
    progress = freeCapsules > 0 ? 100 : capsulesInCart * 100 / capsulesQtyNeeded;

    $('.free-capsule-progress-area .progress').css('width', `${progress}%`);
    $('.free-capsule-progress-area .goal-text-achived > span').html(freeCapsules);
    if (freeCapsules === 0) {
      $('.free-capsule-progress-area .goal-text').show();
      $('.free-capsule-progress-area .goal-text-achived').hide();
    } else {
      $('.free-capsule-progress-area .goal-text').hide();
      $('.free-capsule-progress-area .goal-text-achived').show();
    }
  }

  // IMPACT FUNCTIONS
  var rotate = 0;

  function checkImpact() {
      rotate += 180;
      $('#impactIcon span').addClass('go-green')
          .css({
              'transform': 'rotate(' + rotate + 'deg)'
          });

      $('#impactBar').slideDown(500);
		updateImpactText();
  }



  function updateImpactText() {
    $.ajax({
	type: 'GET',
	url: '/cart?view=impact-fields',
	success: function(data, index) {
		json_response = JSON.parse(data);
		totals = json_response.totals[0]
        // console.log(json_response);
        // console.log(totals.qty);

      $('#impactBar [data-cart-qty]').data('cart-qty', totals.qty).html(totals.qty);
      $('#impactBar [data-impact-effort]').data('data-impact-effort', totals.impact).html(totals.impact);
	},
	error: function(status) {
		console.warn( 'ERROR', status );
	}
})

  }



  // END IMPACT FUNCTIONS



  // POPUP FUNCTIONS
  // CLOSE POPUP

  $('.popup-close').click(function () {
      $(this).closest('.popup-container').fadeOut(500);
  });


  // TOGGLER FUNCTIONS

  $('.toggler').click(function (e) {
      e.preventDefault();
      $(this).toggleClass('active').next().slideToggle(500);
  });

  // PRODUCT MENU on PRODUCT PAGES
  $('.product-menu > li > a').click(function (e) {
      e.preventDefault();
      $(this).next().slideToggle();
  });


  $(document).mouseup(function (e) {
      var container = $('.product-menu');
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
          $('.product-menu > li > ul').slideUp();
      }
  });


  // SET UP RELATED ITEMS SLIDER AFTER ALL THE AJAX IS FINISHED



  $(document).ajaxStop(function () {
    if(checkWidth() > 640) {
      if (!$('#relatedArea').hasClass('slicked')) {
          $('#shopify-section-product-recommendations').appendTo('#relatedArea');
          $('#relatedProducts').length && $('#relatedProducts').slick({
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              nextArrow: '<button type="button" class="slick-next"><span class="ico-chevron-right"></span></button>',
              prevArrow: '<button type="button" class="slick-prev"><span class="ico-chevron-left"></span></button>',
            rows: 0,
            useTransform: false,
              responsive: [{
                  breakpoint: 640,
                  settings: {
                      slidesToShow: 2
                  }
              }]
          });
          $('#relatedArea').addClass('slicked');
      }
    } else {


       if (!$('#relatedAreaMobile').hasClass('slicked')) {
          $('#shopify-section-product-recommendations').appendTo('#relatedAreaMobile');
          $('#relatedProducts').length && $('#relatedProducts').slick({
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              nextArrow: '<button type="button" class="slick-next"><span class="ico-chevron-right"></span></button>',
              prevArrow: '<button type="button" class="slick-prev"><span class="ico-chevron-left"></span></button>',

              responsive: [{
                  breakpoint: 640,
                  settings: {
                      slidesToShow: 2
                  }
              }]
          });
          $('#relatedAreaMobile').addClass('slicked');
      }

    }
  });




  // CLOSE ITEM STUFF

  $('.close-item').click(function (e) {
      e.preventDefault();
      $(this).closest('.hidden-content').fadeOut();
  });




  // CART QTY BTNS
  $('.drawer--cart').on('click', '.increase-qty', function (e) {
    e.preventDefault();
    const qty = Number($(this).closest('.cart-quantity-area').find('.cart__quantity').val());

      $(this).closest('.cart-quantity-area').find('.cart__quantity').val(qty+1).change();
  });

  $('.drawer--cart').on('click', '.decrease-qty', function (e) {
      e.preventDefault();
      const qty = Number($(this).closest('.cart-quantity-area').find('.cart__quantity').val());

      $(this).closest('.cart-quantity-area').find('.cart__quantity').val(qty-1).change();
  });

//   $('.add-gift-note-checkbox input').change((e) => {
//     console.log('post ajax click')
//     const target = $(e.target)
//     const wrapper = target.closest('.add-gift-note-checkbox')
//     console.log('add-gift-note-checkbox change', target.is(':checked'));
//     if (target.is(':checked')) {
//       wrapper.next().show()
//       return
//     }
//     wrapper.next().hide()
//     $('.cart-textarea-wrapper').removeClass('active')
//     $.post('/cart/update.js', { attributes: { 'Gift message': '' } })
//   })

//   $('.custom-home-shop-itemColors').click(function(e) {
//     console.log('handler preventing default from custom-home-shop-itemColorButton clicked from POST AJAX');
//     e.preventDefault();
//     e.stopPropagation();
//   })
  
//   $('.custom-home-shop-itemColorButton'). click(function(e) {
//     console.log('custom-home-shop-itemColorButton clicked from POST AJAX');
//     e.preventDefault();
//     e.stopPropagation();
//     const item = $(this).closest('.custom-home-shop-item');
//     $(item.find('.custom-home-shop-itemColorButton')).removeClass('active');
//     $(this).addClass('active');
//     //get the name of the color from this data-color-value
//     const color = $(this).data('color-value');
//     // console.log('home shop item color clicked is ', color);
    
//     let images
//     if ($(item).attr('data-product_handle') === 'xxxthe-days-of-the-week') {
//       images = item.find('.custom-home-shop-itemImage.color-preview').map((i, image) => {
//         if ((i + 1) % 3 == 0) {
//           return image
//         }
//       });
//     } else {
//       images = item.find('.custom-home-shop-itemImage.color-preview');
//     }
//     //=== new way 
//     images.removeClass('active');
//     $(images).filter(`.color${color}`).addClass('active');

//     setPreSelectedLabel()
//   })

//   // Quick add to cart
// $('.quick-add-to-cart').click(async (e) => {
//   console.log('quick-add-to-cart POST AJAX')
//   debugger;
//   const itemEl = $(e.target).closest('[data-hash_name]')
//   const color = itemEl.find('.custom-home-shop-itemColorButton.active').data('color-value')
//   const addtocart_location = itemEl.data('addtocart_location') ? itemEl.data('addtocart_location') : 'quick_add_to_cart'
//   console.log('location', addtocart_location)
//   const recommendationsSingleLabel = itemEl.data('recommendations_single_label')
//   const variantId = itemEl.find('.product-variants option').toArray().find((el) => $(el).text().includes(color)).value
//   const item = {id: variantId, quantity: 1}
//   if (recommendationsSingleLabel) {
//     item.properties = {
//       "Custom Label": "",
//       "Customization Cost": "",
//       "Label": recommendationsSingleLabel,
//       "_add_source": addtocart_location
//     }
//   }else {
//     item.properties = {
//       "_add_source": addtocart_location
//     }
//   }

//   data = {items: [item]}
//   addShadowProducts(data, item, itemEl, color)
//   await theme.cart.clearCartIfHasCorporateGifts()
//   theme.cart.addItemFromForm(data)

//   function addShadowProducts(data, product, itemEl, color) {
//     const hashName = itemEl.attr('data-hash_name')
//     if (hashes_for_skipping_shadow_products.includes(hashName)) return
  
//     const capsuleCount = Number(itemEl.attr('data-cpsl_cnt'))
//     const tilesCount = Number(itemEl.attr('data-tile_cnt'))
//     const presetLabels = itemEl.attr('data-labels').split(',')
//     const presetSizes = itemEl.attr('data-sizes').split(',')
//     const count = tilesCount || capsuleCount
//     const cartItems = theme.cart.data.items
//     const existingInCart = cartItems.find((item) => {
//       const defaultProps = { Timestamp: ""}
//       const itemProps = JSON.stringify({...item.properties, ...defaultProps})
//       const productProps = JSON.stringify({...product.properties, ...defaultProps})
//       return  Number(product.id) === Number(item.id) && itemProps === productProps
//     })
  
//     product.properties ||= {}
//     product.properties['Timestamp'] = existingInCart?.properties?.Timestamp || new Date().getTime()
//     if (!count) return
  
//     const { items } = data
//     for (let i = 1; i <= count; i++) {
//       properties = {
//         'Product': hashName,
//         'Color': color,
//         'Label': presetLabels[i - 1].trim(),
//         'Custom Label': "",
//         'Parent Timestamp': product.properties['Timestamp']
//       }
//       const size = presetSizes[i - 1] ? presetSizes[i - 1].toLowerCase() : defaulf_size.toLowerCase()
//       const shadowProductId = getShadowProduct(capsuleCount ? 'capsule' : 'tile', properties['Color'], size)?.id
//       const item = {id: shadowProductId, quantity: Number(product.quantity), properties}
//       const existingItem = existingShadowProductItem(item, items)
//       if (existingItem)
//         existingItem.quantity += Number(product.quantity)
//       else 
//         items.push(item)
//     }
//     items.forEach((el) => el.properties && el.properties['Parent Timestamp'] === product.properties['Timestamp'] && (el.properties['Quantity'] = el.quantity / product.quantity))
//   }
// })




   var $window = $(window);
   function checkWidth() {
			var windowsize = $window.innerWidth();
           return windowsize;
 	}




   /***************** NEW MOBILE MENU ***************************/

var headerHeight = $('.header-wrapper');

$('#mobileMenuToggle').click(function(e){
    	$('html').toggleClass('menu-open');
  $('#mobileMenuContainer').fadeToggle(500).toggleClass('active');
   	$(this).toggleClass('active');
  if($(this).hasClass('active')){
    //console.log('activemenu');
    //$('.mobile-menu li:first-child a').focus();
  }
});

$('input[name="Color"]').change(function(e) {
  if (!$('html').hasClass('template-product')) return;
  const index = $(this).data('color-index');
  const $slideshow = $($('.slick-initialized.slick-slider')[0]);
  $slideshow.slick('slickGoTo', index);
});


// Init labels code
// window.initLabels($);


})();

